"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[135],{

/***/ 8605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2125);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7753);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  margin: calc( -2 * var( --stack-basis ) );\n  margin-top: var( --stack-basis );\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-grow: 1;\n  max-width: 120px;\n  max-height: 60px;\n  padding-left: calc( 2 * var( --stack-basis ) );\n  padding-right: calc( 2 * var( --stack-basis ) );\n  margin-top: calc( 2 * var( --stack-basis ) );\n  margin-bottom: calc( 2 * var( --stack-basis ) );\n\n  & + div {\n    border-left: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



function PartnerLogo(param) {
    var label = param.label, logos = param.logos;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPartnershipTitle, {
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPartnerLogos, {
                children: logos === null || logos === void 0 ? void 0 : logos.map(function(image) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPartnerLogo, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            src: image.url,
                            alt: image.alt,
                            width: image.width,
                            height: image.height,
                            dateModified: image.dateModified
                        })
                    }, image.id);
                })
            })
        ]
    });
}
var StyledPartnershipTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-1ba275af-0"
})(_templateObject(), function(p) {
    return p.theme.typo.smallMeta;
}, function(p) {
    return p.theme.colors.grey400;
});
var StyledPartnerLogos = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1ba275af-1"
})(_templateObject1());
var StyledPartnerLogo = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1ba275af-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.grey400;
});
/* harmony default export */ __webpack_exports__["Z"] = (PartnerLogo);


/***/ }),

/***/ 8390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e2": function() { return /* binding */ StyledCardContent; },
/* harmony export */   "v0": function() { return /* binding */ StyledCardImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(570);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7753);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    justify-content: center;\n    align-items: center;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  min-height: 154px;\n\n  ",
        "\n  \n  ",
        "\n  \n  ",
        "\n  \n  ",
        "\n\n  > div {\n    position: relative;\n    margin: 0 var( --grid-gutter );\n    width: ",
        "px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  padding: calc( 4 * var( --stack-basis ) ) var( --grid-gutter );\n\n  > h4 {\n    margin: 0 0 var( --stack-basis ) 0;\n  }\n\n  > div > * {\n    margin: 1rem 0;\n    font-size: ",
        ";\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n\n  ",
        " {\n    margin-top: auto;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        " {\n      justify-content: center;\n      align-items: center;\n    }\n\n    ",
        " {\n      text-align: center;\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  width: calc( 100% - var( --grid-gutter ) );\n  max-width: 418px;\n  min-width: 200px;\n  border-radius: var( --card-border-radius );\n  background: white;\n\n  ",
        "\n\n  @media ( min-width: 600px ) {\n    width: calc( 33.333% - var( --grid-gutter ) );\n    min-width: 270px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




function Card(param) {
    var alignment = param.alignment, card = param.card;
    var ref;
    var img = (ref = card.cardImage) === null || ref === void 0 ? void 0 : ref[0];
    var imgAlignment = function() {
        if ([
            "center",
            "bottomLeft"
        ].includes(card.cardImageAlignment)) {
            return card.cardImageAlignment;
        }
        return null;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCard, {
        $alignment: alignment,
        children: [
            img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCardImage, {
                $alignment: imgAlignment(),
                $color: card.cardColor,
                $imgWidth: img.width,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        src: img.url,
                        alt: img.alt,
                        width: img.width,
                        height: img.height,
                        dateModified: img.dateModified
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCardContent, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
                        children: card.cardTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: card.cardDescription
                        }
                    }),
                    card.cardButtonLink && card.cardButtonLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        href: card.cardButtonLink,
                        fullWidth: true,
                        children: card.cardButtonLabel
                    })
                ]
            })
        ]
    });
}
var StyledCardImage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f5ae68f2-0"
})(_templateObject5(), function(p) {
    return p.$color === "grey" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), p.theme.colors.grey100);
}, function(p) {
    return p.$color === "blue" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1(), p.theme.colors.blue100);
}, function(p) {
    return p.$color === "green" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), p.theme.colors.green100);
}, function(p) {
    return p.$color === "red" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject3(), p.theme.colors.red100);
}, function(p) {
    return p.$imgWidth;
}, function(p) {
    return p.$alignment === "center" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4());
});
var StyledCardContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f5ae68f2-1"
})(_templateObject6(), function(p) {
    return p.theme.typo.sizes.dropped;
}, _Button__WEBPACK_IMPORTED_MODULE_2__/* .StyledButton */ .Sn);
var StyledCard = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f5ae68f2-2"
})(_templateObject8(), function(p) {
    return p.$alignment === "center" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject7(), StyledCardImage, StyledCardContent);
});
/* harmony default export */ __webpack_exports__["ZP"] = (Card);


/***/ }),

/***/ 4921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ StyledContactCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7753);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5741);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n\n  p {\n    margin: 0;\n    font-size: ",
        ";\n    word-wrap: break-word;\n    word-break: break-all;\n    word-break: break-word;\n    hyphens: auto;\n\n    a {\n      display: block;\n      color: ",
        ";\n      text-decoration: underline;\n      text-decoration-thickness: 1px;\n      text-underline-offset: 3px;\n      transition: color .3s ease-out;\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  position: relative;\n  width: 100px;\n  height: 78px;\n  margin-bottom: calc( 3 * var( --stack-basis ) );\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




function ContactCard(param) {
    var contactCard = param.contactCard;
    var image = contactCard.icon[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledContactCard, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImage, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    src: image.url,
                    alt: image.alt,
                    dateModified: image.dateModified,
                    layout: "fill",
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                children: [
                    contactCard.text,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        href: contactCard.linkDestination,
                        children: contactCard.linkText
                    })
                ]
            })
        ]
    });
}
var StyledContactCard = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f83c0fcf-0"
})(_templateObject(), function(p) {
    return p.theme.typo.sizes.medium;
}, function(p) {
    return p.theme.colors.green400;
}, function(p) {
    return p.theme.colors.green700;
});
var StyledImage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f83c0fcf-1"
})(_templateObject1());
/* harmony default export */ __webpack_exports__["Z"] = (ContactCard);


/***/ }),

/***/ 7011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function ChevronIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "9",
        viewBox: "0 0 16 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.99967 8L8.36825 8.33786C8.27355 8.44118 8.13983 8.5 7.99967 8.5C7.85952 8.5 7.7258 8.44118 7.6311 8.33786L7.99967 8ZM1.70158 0.38941L8.36825 7.66214L7.6311 8.33786L0.96443 1.06514L1.70158 0.38941ZM7.6311 7.66214L14.2978 0.38941L15.0349 1.06513L8.36825 8.33786L7.6311 7.66214Z",
            fill: "#009877"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ChevronIcon);


/***/ }),

/***/ 3525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function TickIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "18",
        height: "13",
        viewBox: "0 0 18 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6.86015 11.9028L7.21799 12.252C7.12228 12.35 6.99052 12.4045 6.8535 12.4027C6.71648 12.4009 6.58621 12.3429 6.49315 12.2423L6.86015 11.9028ZM1.44441 5.3133L7.22715 11.5632L6.49315 12.2423L0.710402 5.99245L1.44441 5.3133ZM6.50231 11.5535L17.1422 0.650787L17.8578 1.34921L7.21799 12.252L6.50231 11.5535Z",
            fill: "#A2A9AD"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (TickIcon);


/***/ }),

/***/ 2475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7753);
/* harmony import */ var _layout_Background__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7940);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: 0;\n  top: 50%;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function PageSegmentBackground(param) {
    var segmentType = param.segmentType, _anchorId = param.anchorId, anchorId = _anchorId === void 0 ? null : _anchorId, hasSectionTitle = param.hasSectionTitle, _color = param.color, color = _color === void 0 ? "transparent" : _color, _image = param.image, image = _image === void 0 ? null : _image, _additionalBottomPadding = param.additionalBottomPadding, additionalBottomPadding = _additionalBottomPadding === void 0 ? 0 : _additionalBottomPadding, _hideOverflow = param.hideOverflow, hideOverflow = _hideOverflow === void 0 ? false : _hideOverflow, children = param.children;
    var classNames = [
        "bx-page-segment"
    ];
    if (segmentType) {
        classNames.push("bx-page-segment-".concat(segmentType));
    }
    classNames.push("bx-page-segment-".concat(hasSectionTitle ? "with-title" : "without-title"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Background__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        $color: color,
        style: {
            overflow: hideOverflow ? "hidden" : "visible",
            paddingBottom: "calc( ".concat(additionalBottomPadding, " * var( --stack-basis ) )")
        },
        className: classNames.join(" "),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            id: anchorId || null,
            style: image && {
                position: "relative",
                paddingBottom: "20vh"
            },
            children: [
                image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBgImage, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        src: image.url,
                        dateModified: image.dateModified,
                        alt: "",
                        layout: "fill",
                        objectFit: "cover"
                    })
                }),
                children
            ]
        })
    });
}
var StyledBgImage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-97d5ef35-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (PageSegmentBackground);


/***/ }),

/***/ 157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin: 0 auto;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc( 100vw - ( 2 * var( --container-margin-width ) ) );\n  max-width: min( 60rem, 100% );\n  ",
        "\n  text-align: ",
        ";\n  color: inherit;\n\n  h2 {\n    margin: 0;\n    ",
        "\n    font-size: ",
        ";\n    line-height: 1.1;\n    color: inherit;\n\n    @media ( max-width: 500px ) {\n      font-size: ",
        ";\n    }\n  }\n\n  h2 + p {\n    margin: var( --stack-basis ) 0 0;\n    color: inherit;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


function PageSegmentHeading(param) {
    var _id = param.id, id = _id === void 0 ? null : _id, _title = param.title, title = _title === void 0 ? null : _title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? null : _subtitle, _align = param.align, align = _align === void 0 ? "center" : _align, _size = param.size, size = _size === void 0 ? "veryLarge" : _size;
    if (!title && !subtitle) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPageSegmentHeading, {
        id: id,
        $textSize: size,
        $textAlign: align,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                children: subtitle
            })
        ]
    });
}
var StyledPageSegmentHeading = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].hgroup.withConfig */ .ZP.hgroup.withConfig({
    componentId: "sc-3236cb9-0"
})(_templateObject1(), function(p) {
    return p.$textAlign === "center" && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
}, function(p) {
    return p.$textAlign;
}, function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes[p.$textSize];
}, function(p) {
    return p.theme.typo.sizes.medium;
});
/* harmony default export */ __webpack_exports__["Z"] = (PageSegmentHeading);


/***/ }),

/***/ 1135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pageSegments_PageSegments; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/layout/Background.tsx
var Background = __webpack_require__(7940);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(4970);
// EXTERNAL MODULE: ./components/pageSegments/PageSegmentHeading.tsx
var PageSegmentHeading = __webpack_require__(157);
// EXTERNAL MODULE: ./components/Image.tsx
var Image = __webpack_require__(7753);
// EXTERNAL MODULE: ./lib/strings.tsx
var strings = __webpack_require__(8744);
// EXTERNAL MODULE: ./styles/links.tsx
var links = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/infoPoints/InfoPoint.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: ",
        ";\n  word-wrap: break-word;\n    word-break: break-all;\n    word-break: break-word;\n    hyphens: auto;\n\n  h3 {\n    margin: 0;\n    ",
        "\n    font-size: ",
        ";\n    line-height: 1.2;\n\n    @media ( max-width: 500px ) {\n      font-size: ",
        ";\n    }\n  }\n\n  p {\n    margin: 0;\n  }\n\n  h3 + div > p {\n    margin-top: calc( var( --stack-basis ) * 3 );\n  }\n\n  a {\n    ",
        "\n  }\n\n  strong {\n    font-weight: 600;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 120px;\n  margin: 0 ",
        ";\n  margin-bottom: calc( var( --stack-basis ) * 4 );\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function InfoPoint(param) {
    var title = param.title, description = param.description, icon = param.icon, alignment = param.alignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInfoPoint, {
        $alignment: alignment,
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                $alignment: alignment,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                    src: icon.url,
                    alt: icon.alt,
                    width: icon.width,
                    height: icon.height,
                    dateModified: icon.dateModified
                })
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: title
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: (0,strings/* wrapWithPTags */.gu)(description)
                }
            })
        ]
    });
}
var StyledInfoPoint = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4b0864cb-0"
})(_templateObject(), function(p) {
    return p.$alignment;
}, function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return p.theme.typo.sizes.medium;
}, function(p) {
    return (0,links/* textLink */.k)(p.theme);
});
var StyledIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4b0864cb-1"
})(_templateObject1(), function(p) {
    return p.$alignment === "center" ? "auto" : 0;
});
/* harmony default export */ var infoPoints_InfoPoint = (InfoPoint);

;// CONCATENATED MODULE: ./components/infoPoints/InfoPoints.tsx

function InfoPoints_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --info-point-stack-padding: max( var( --grid-gutter ), calc( 3 * var( --stack-basis ) ) );\n  overflow: hidden;\n\n  > div {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin: \n      calc( -1 * var( --info-point-stack-padding ) ) \n      calc( -1 * var( --grid-gutter ) );\n    \n    > * {\n      box-sizing: border-box;\n      flex: 1 0 calc( 33.333% - ( 2 * var( --grid-gutter ) ) );\n      min-width: min( 205px, 90% );\n      max-width: ",
        ";\n      margin: \n        var( --info-point-stack-padding )\n        calc( 1 * var( --grid-gutter ) );\n    }\n  }\n"
    ]);
    InfoPoints_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function InfoPoints(param) {
    var infoPoints = param.infoPoints, alignment = param.alignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInfoPoints, {
        $alignment: alignment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: infoPoints.map(function(infoPoint) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(infoPoints_InfoPoint, {
                    title: infoPoint.infoPointTitle,
                    description: infoPoint.infoPointDescription,
                    icon: infoPoint.infoPointIcon[0],
                    alignment: alignment
                }, infoPoint.id);
            })
        })
    });
}
var StyledInfoPoints = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bebbac29-0"
})(InfoPoints_templateObject(), function(p) {
    return p.$alignment === "center" ? "360px" : "none";
});
/* harmony default export */ var infoPoints_InfoPoints = (InfoPoints);

// EXTERNAL MODULE: ./components/pageSegments/PageSegmentBackground.tsx
var PageSegmentBackground = __webpack_require__(2475);
;// CONCATENATED MODULE: ./components/pageSegments/InfoPointsSegment.tsx






function InfoPointsSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, alignment = param.alignment, infoPoints = param.infoPoints, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        segmentType: "infoPoints",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(infoPoints_InfoPoints, {
                        infoPoints: infoPoints,
                        alignment: alignment
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var pageSegments_InfoPointsSegment = (InfoPointsSegment);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(570);
;// CONCATENATED MODULE: ./components/icons/VideoPlayIcon.tsx

function VideoPlayIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "62",
        height: "62",
        viewBox: "0 0 62 62",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "31",
                cy: "31",
                r: "31",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.1142 30.2408L27.6508 20.415C27.0021 19.859 26 20.3199 26 21.1743L26 40.8259C26 41.6802 27.0021 42.1411 27.6508 41.5851L39.1142 31.7593C39.5798 31.3602 39.5798 30.6399 39.1142 30.2408Z",
                fill: "#009877"
            })
        ]
    });
}
/* harmony default export */ var icons_VideoPlayIcon = (VideoPlayIcon);

;// CONCATENATED MODULE: ./lib/video.ts
function getEmbedUrl(videoUrl) {
    var ref, ref1;
    var youTubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    var youTubeMatch = videoUrl.match(youTubeRegExp);
    if (youTubeMatch && ((ref = youTubeMatch[2]) === null || ref === void 0 ? void 0 : ref.length) === 11) {
        return "//www.youtube-nocookie.com/embed/".concat(youTubeMatch[2]);
    }
    var vimeoRegExp = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i;
    var vimeoMatch = videoUrl.match(vimeoRegExp);
    if (vimeoMatch && ((ref1 = vimeoMatch[1]) === null || ref1 === void 0 ? void 0 : ref1.length) > 1) {
        return "//player.vimeo.com/video/".concat(vimeoMatch[1], "?dnt=1");
    }
    return null;
}
function getYoutubeId(videoUrl) {
    var ref;
    var youTubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    var youTubeMatch = videoUrl.match(youTubeRegExp);
    if (youTubeMatch && ((ref = youTubeMatch[2]) === null || ref === void 0 ? void 0 : ref.length) === 11) {
        return youTubeMatch[2];
    }
    return false;
}

;// CONCATENATED MODULE: ./components/VideoEmbed.tsx

function VideoEmbed_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  div,\n  iframe {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    Height: 100%;\n  }\n"
    ]);
    VideoEmbed_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function VideoEmbed(param) {
    var url = param.url, _autoplay = param.autoplay, autoplay = _autoplay === void 0 ? false : _autoplay;
    var embedUrl = getEmbedUrl(url);
    if (!embedUrl) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledVideoEmbed, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                width: "853",
                height: "480",
                src: "".concat(embedUrl).concat(autoplay ? "?autoplay=1" : ""),
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: true,
                title: "Embedded youtube"
            })
        })
    });
}
var StyledVideoEmbed = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfca077e-0"
})(VideoEmbed_templateObject());
/* harmony default export */ var components_VideoEmbed = (VideoEmbed);

;// CONCATENATED MODULE: ./components/VideoCta.tsx

function VideoCta_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    VideoCta_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoCta_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex: 0 0 50%;\n  aspect-ratio: 1.59/1;\n  margin-top: max( var( --grid-gutter ), calc( 4 * var( --stack-basis ) ) );\n\n  button {\n    display: block;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border: 0;\n    padding: 0;\n    margin: 0;\n    background: ",
        ";\n    cursor: pointer;\n\n    img {\n      opacity: 0.6;\n    }\n\n    &:hover svg {\n      transform: \n      translate( -50%, -50% )\n      scale( 1.1 );\n    }\n  }\n\n  svg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate( -50%, -50% );\n    transition: transform .3s ease-out;\n  }\n"
    ]);
    VideoCta_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-bottom: max( var( --grid-gutter ), calc( 4 * var( --stack-basis ) ) );\n\n  h2 {\n    ",
        "\n    font-size: ",
        ";\n    line-height: 1.2;\n\n    @media ( max-width: 500px ) {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  @media ( min-width: 900px ) {\n    flex-direction: row;\n    \n    ",
        " {\n      flex: 0 0 calc( 50% - ( var( --grid-gutter ) * 3 ) );\n      margin-left: auto;\n    }\n\n    ",
        " {\n      margin-top: calc( -6 * var( --stack-basis ) );\n      margin-bottom: calc( -6 * var( --stack-basis ) );\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










function VideoCta(param) {
    var _anchorId = param.anchorId, anchorId = _anchorId === void 0 ? null : _anchorId, title = param.title, description = param.description, coverImage = param.coverImage, buttonLabel = param.buttonLabel, videoUrl = param.videoUrl;
    var doVideo = function() {
        setShowVideo(true);
    };
    var ref = (0,react.useState)(false), showVideo = ref[0], setShowVideo = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledVideoCta, {
        id: anchorId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Background/* default */.Z, {
            $color: "blue100",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                $containerType: "full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGrid, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCoverImage, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        onClick: doVideo,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                                                src: coverImage.url,
                                                alt: coverImage.alt,
                                                dateModified: coverImage.dateModified,
                                                layout: "fill",
                                                objectFit: "cover"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_VideoPlayIcon, {})
                                        ]
                                    }),
                                    showVideo && videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VideoEmbed, {
                                        url: videoUrl,
                                        autoplay: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContent, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                                    $top: 4,
                                    $between: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: title
                                        }),
                                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: description
                                        }),
                                        buttonLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                            outline: true,
                                            onClick: doVideo,
                                            children: buttonLabel
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}
var StyledVideoCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29eabf0-0"
})(VideoCta_templateObject());
var StyledCoverImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29eabf0-1"
})(VideoCta_templateObject1(), function(p) {
    return p.theme.colors.black;
});
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29eabf0-2"
})(_templateObject2(), function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.veryLarge;
}, function(p) {
    return p.theme.typo.sizes.medium;
});
var StyledGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29eabf0-3"
})(_templateObject3(), StyledContent, StyledCoverImage);
/* harmony default export */ var components_VideoCta = (VideoCta);

;// CONCATENATED MODULE: ./components/pageSegments/VideoCtaSegment.tsx


function VideoCtaSegment(param) {
    var anchorId = param.anchorId, title = param.title, description = param.description, coverImage = param.coverImage, buttonLabel = param.buttonLabel, videoUrl = param.videoUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VideoCta, {
        anchorId: anchorId,
        title: title,
        description: description,
        coverImage: coverImage,
        buttonLabel: buttonLabel,
        videoUrl: videoUrl
    });
}
/* harmony default export */ var pageSegments_VideoCtaSegment = (VideoCtaSegment);

;// CONCATENATED MODULE: ./components/pageSegments/PageSegmentBodyText.tsx

function PageSegmentBodyText_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: ",
        ";\n  "
    ]);
    PageSegmentBodyText_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PageSegmentBodyText_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 32rem;\n  margin: 0 auto;\n  text-align: center;\n  color: inherit;\n\n  p {\n    margin: var( --stack-basis ) 0 0;\n    color: inherit;\n  }\n\n  a {\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    PageSegmentBodyText_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



function PageSegmentBodyText(param) {
    var html = param.html, _bodyStyle = param.bodyStyle, bodyStyle = _bodyStyle === void 0 ? "normal" : _bodyStyle;
    if (!html) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPageSegmentBodyText, {
        $style: bodyStyle,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
}
var StyledPageSegmentBodyText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9ea7b918-0"
})(PageSegmentBodyText_templateObject1(), function(p) {
    return (0,links/* textLink */.k)(p.theme);
}, function(p) {
    return p.$style === "small" && (0,styled_components_browser_esm/* css */.iv)(PageSegmentBodyText_templateObject(), p.theme.typo.sizes.dropped);
});
/* harmony default export */ var pageSegments_PageSegmentBodyText = (PageSegmentBodyText);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./components/icons/TickIcon.tsx
var TickIcon = __webpack_require__(3525);
;// CONCATENATED MODULE: ./components/packages/Bullets.tsx

function Bullets_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"
    ]);
    Bullets_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Bullets_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: calc( var( --stack-basis ) * 2 );\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  svg {\n    flex: 0 0 18px;\n    margin: 5px 0.8rem 0 0;\n  }\n"
    ]);
    Bullets_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



function Bullets(param) {
    var bullets = param.bullets;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBullets, {
        children: bullets.map(function(bullet, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBullet, {
                $highlight: bullet.highlight,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TickIcon/* default */.Z, {}),
                    bullet.text
                ]
            }, i);
        })
    });
}
var StyledBullets = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-d6a78238-0"
})(Bullets_templateObject());
var StyledBullet = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-d6a78238-1"
})(Bullets_templateObject1(), function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.$highlight ? 600 : 400;
});
/* harmony default export */ var packages_Bullets = (Bullets);

;// CONCATENATED MODULE: ./components/icons/PlusIcon.tsx

function PlusIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.5 12.625C0.947715 12.625 0.5 13.0727 0.5 13.625C0.5 14.1773 0.947715 14.625 1.5 14.625L1.5 12.625ZM26.5 14.625C27.0523 14.625 27.5 14.1773 27.5 13.625C27.5 13.0727 27.0523 12.625 26.5 12.625L26.5 14.625ZM13 26.125C13 26.6773 13.4477 27.125 14 27.125C14.5523 27.125 15 26.6773 15 26.125L13 26.125ZM15 1.125C15 0.572715 14.5523 0.125 14 0.125C13.4477 0.125 13 0.572715 13 1.125L15 1.125ZM1.5 14.625L26.5 14.625L26.5 12.625L1.5 12.625L1.5 14.625ZM15 26.125L15 1.125L13 1.125L13 26.125L15 26.125Z",
            fill: "#009877"
        })
    });
}
/* harmony default export */ var icons_PlusIcon = (PlusIcon);

// EXTERNAL MODULE: ./components/PartnerLogo.tsx
var PartnerLogo = __webpack_require__(8605);
;// CONCATENATED MODULE: ./components/packages/Additional.tsx

function Additional_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  > div:first-child {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin: auto 0;\n  }\n\n  @media ( max-width: 650px ) {\n    min-width: 100%;\n    padding-top: 3rem !important;\n  }\n"
    ]);
    Additional_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Additional_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: var( --stack-basis ) 1rem;\n    background: ",
        ";\n  "
    ]);
    Additional_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Additional_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  p {\n    margin: 0;\n  }\n\n  ",
        "\n"
    ]);
    Additional_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Additional_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translate( -50%, -70% );\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 51px;\n  height: 51px;\n  border-radius: 100%;\n  background: ",
        ";\n\n  @media ( max-width: 650px ) {\n    left: 50%;\n    top: 0;\n    transform: translate( -50%, -50% );\n  }\n"
    ]);
    Additional_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-self: flex-end;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






function Additional(param) {
    var additional = param.additional;
    var partnerLogo = additional.find(function(item) {
        return item.typeHandle === "partnerLogo";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAdditional, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.ZP, {
                $between: 1,
                children: additional.map(function(item) {
                    if (item.typeHandle === "text") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                            dangerouslySetInnerHTML: {
                                __html: item.text
                            }
                        }, item.id);
                    }
                    if (item.typeHandle === "textHighlight") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                            dangerouslySetInnerHTML: {
                                __html: item.text
                            },
                            $highlight: true
                        }, item.id);
                    }
                    if (item.typeHandle === "bullets") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* StackItem */.vO, {
                            $top: 3,
                            $bottom: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(packages_Bullets, {
                                bullets: item.bullets
                            })
                        }, item.id);
                    }
                    return null;
                })
            }),
            partnerLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPartnerLogo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLogo/* default */.Z, {
                    label: partnerLogo.partnerLabel,
                    logos: partnerLogo.partnerLogo
                })
            }, partnerLogo.id),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPlus, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_PlusIcon, {})
            })
        ]
    });
}
var StyledAdditional = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-940ac849-0"
})(Additional_templateObject());
var StyledText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-940ac849-1"
})(Additional_templateObject2(), function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.$highlight && (0,styled_components_browser_esm/* css */.iv)(Additional_templateObject1(), p.theme.colors.blue200);
});
var StyledPlus = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-940ac849-2"
})(Additional_templateObject3(), function(p) {
    return p.theme.colors.realWhite;
});
var StyledPartnerLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-940ac849-3"
})(_templateObject4());
/* harmony default export */ var packages_Additional = (Additional);

// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
;// CONCATENATED MODULE: ./components/packages/Package.tsx

function Package_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Package_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Package_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-grow: 2;\n\n    @media ( min-width: 651px ) {\n      flex-basis: calc( var( --flex-basis ) * 2 );\n      /* min-width: calc( var( --min-width ) * 2 ); */\n    }\n    \n    @media ( max-width: 650px ) {\n      flex-wrap: wrap;\n    }\n  "
    ]);
    Package_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Package_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --highlight-color: ",
        ";\n  --flex-basis: 300px;\n  --max-width: 450px;\n  /* --min-width: calc( var( --flex-basis ) * 0.6 ); */\n  display: flex;\n  box-sizing: border-box;\n  flex: 1 1 var( --flex-basis );\n  /* min-width: var( --min-width ); */\n  max-width: calc( ",
        " * var( --max-width ) );\n  border-radius: var( --card-border-radius );\n  border-top: 16px solid var( --highlight-color );\n  background: ",
        ";\n  box-shadow: 0px 6px 12px rgba( 0, 0, 0, 0.1 );\n  \n  > div {\n    box-sizing: border-box;\n    padding: 2rem 2rem 3rem;\n\n    &:nth-child( 2 ) {\n      position: relative;\n      flex: 0 0 50%;\n      background: ",
        ";\n    }\n  }\n\n  h3 {\n    margin: 0;\n    ",
        "\n    font-size: ",
        ";\n    color: var( --highlight-color );\n  }\n\n  p {\n    font-size: ",
        ";\n  }\n\n  ",
        " {\n    margin-top: calc( -1 * var( --stack-basis ) );\n    min-height: 3.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n\n    > span {\n      margin-bottom: 0.5rem;\n      font-size: ",
        ";\n      color: ",
        ";\n\n      > i {\n        display: inline-block;\n        padding: 8px;\n        margin-left: 1em;\n        font-size: ",
        ";\n        font-weight: 500;\n        font-style: normal;\n        color: ",
        ";\n        background: ",
        ";\n      }\n    }\n\n    p {\n      margin: 0;\n      ",
        "\n      font-size: ",
        ";\n      line-height: 1.1;\n\n      span {\n        margin-left: 1em;\n        font-size: ",
        ";\n      }\n\n      @media ( max-width: 500px ) {\n        font-size: ",
        ";\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    Package_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Package_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  a {\n    ",
        "\n    font-size: ",
        ";\n    color: ",
        ";\n    text-decoration-thickness: 1px;\n    text-underline-offset: 3px;\n    text-decoration-color: transparent;\n    transition: text-decoration-color .3s ease-out;\n\n    &:hover {\n      text-decoration-color: currentColor;\n    }\n  }\n"
    ]);
    Package_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







function Package(param) {
    var thePackage = param.thePackage;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPackage, {
        $highlight: thePackage.highlight,
        $withAdditional: ((ref = thePackage.packageAdditional) === null || ref === void 0 ? void 0 : ref.length) > 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                    $between: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: thePackage.packageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: thePackage.packageDescription
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPrice, {
                            children: [
                                thePackage.originalPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        thePackage.originalPriceLabel && "".concat(thePackage.originalPriceLabel, ": "),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                            children: thePackage.originalPrice
                                        }),
                                        thePackage.discountHighlight && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            children: thePackage.discountHighlight
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        thePackage.price,
                                        thePackage.pricePostfix && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: thePackage.pricePostfix
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                href: thePackage.buttonLink,
                                outline: !thePackage.highlight,
                                color: thePackage.highlight ? "green" : "black",
                                fullWidth: true,
                                children: thePackage.buttonLabel
                            })
                        }),
                        ((ref1 = thePackage.bulletPoints) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* StackItem */.vO, {
                            $top: 5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(packages_Bullets, {
                                bullets: thePackage.bulletPoints
                            })
                        }),
                        thePackage.moreInfoLink && thePackage.moreInfoLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* StackItem */.vO, {
                            $top: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMoreInfoLink, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: thePackage.moreInfoLink,
                                    children: thePackage.moreInfoLabel
                                })
                            })
                        })
                    ]
                })
            }),
            ((ref2 = thePackage.packageAdditional) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(packages_Additional, {
                additional: thePackage.packageAdditional
            })
        ]
    });
}
var StyledPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac94c741-0"
})(Package_templateObject());
var StyledPackage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac94c741-1"
})(Package_templateObject2(), function(p) {
    return p.$highlight ? p.theme.colors.green400 : p.theme.colors.black;
}, function(p) {
    return p.$withAdditional ? 2 : 1;
}, function(p) {
    return p.theme.colors.realWhite;
}, function(p) {
    return p.theme.colors.green100;
}, function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.theme.typo.sizes.dropped;
}, StyledPrice, function(p) {
    return p.theme.typo.sizes.small;
}, function(p) {
    return p.theme.colors.grey700;
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.theme.colors.green400;
}, function(p) {
    return p.theme.colors.green100;
}, function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.veryLarge;
}, function(p) {
    return p.theme.typo.sizes.small;
}, function(p) {
    return p.theme.typo.sizes.medium;
}, function(p) {
    return p.$withAdditional && (0,styled_components_browser_esm/* css */.iv)(Package_templateObject1());
});
var StyledMoreInfoLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac94c741-2"
})(Package_templateObject3(), function(p) {
    return p.theme.typo.medium;
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.theme.colors.green400;
});
/* harmony default export */ var packages_Package = (Package);

;// CONCATENATED MODULE: ./components/packages/Packages.tsx



function Packages_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: calc( var( --grid-gutter ) * 2 );\n"
    ]);
    Packages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function Packages(param) {
    var packages = param.packages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPackages, {
        children: packages.map(function(thePackage) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(packages_Package, {
                thePackage: thePackage.packageTitle ? convertPackagesFieldToPacakgesEntry(thePackage) : thePackage
            }, thePackage.id);
        })
    });
}
var StyledPackages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-738a2e9d-0"
})(Packages_templateObject());
function convertPackagesFieldToPacakgesEntry(packageFieldValues) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, packageFieldValues), {
        packageName: packageFieldValues.packageTitle,
        packageDescription: packageFieldValues.description,
        bulletPoints: packageFieldValues.bullets,
        packageAdditional: packageFieldValues.additional.map(function(pa) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pa), {
                partnerLogo: pa.logo
            });
        })
    });
}
/* harmony default export */ var packages_Packages = (Packages);

;// CONCATENATED MODULE: ./components/pageSegments/PackagesSegment.tsx







function PackagesSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, bodyText = param.bodyText, packages = param.packages, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        color: "ivory",
        segmentType: "packages",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            $containerType: "full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                    $top: 12,
                    $bottom: 12,
                    $between: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                            title: title,
                            subtitle: subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(packages_Packages, {
                            packages: packages
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_PageSegmentBodyText, {
                            html: bodyText,
                            bodyStyle: "small"
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var pageSegments_PackagesSegment = (PackagesSegment);

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
;// CONCATENATED MODULE: ./components/testimonials/Testimonial.tsx

function Testimonial_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n\n  blockquote {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    margin: 0;\n    padding: 0;\n    ",
        ";\n    font-size: ",
        ";\n\n    p {\n      margin: 0 0 calc( 3 * var( --stack-basis ) ) 0;\n    }\n\n    footer {\n      margin-top: auto;\n      color: ",
        ";\n      font-size: ",
        ";\n\n      cite {\n        display: block;\n        font-style: normal;\n      }\n      \n      span {\n        display: block;\n        font-weight: 400;\n      }\n    }\n  }\n"
    ]);
    Testimonial_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Testimonial_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: relative;\n  width: 100px;\n  height: 100px;\n  border-radius: 100%;\n  margin-bottom: calc( 3 * var( --stack-basis ) );\n"
    ]);
    Testimonial_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




function Testimonial(param) {
    var testimonial = param.testimonial;
    var image = testimonial.mainImage[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTestimonial, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                    src: image.url,
                    alt: image.alt,
                    dateModified: image.dateModified,
                    layout: "fill",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "“",
                            testimonial.description,
                            "”"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("cite", {
                                children: testimonial.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    testimonial.amountSaved,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        description: "saved",
                                        defaultMessage: "saved",
                                        id: "KHged8"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var StyledTestimonial = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-55662cd1-0"
})(Testimonial_templateObject(), function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return p.theme.colors.green400;
}, function(p) {
    return p.theme.typo.sizes.normal;
});
var StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-55662cd1-1"
})(Testimonial_templateObject1());
/* harmony default export */ var testimonials_Testimonial = (Testimonial);

;// CONCATENATED MODULE: ./components/testimonials/Testimonials.tsx

function Testimonials_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: calc( 2 * var( --grid-gutter ) );\n\n  > * {\n    max-width: 305px;\n  }\n"
    ]);
    Testimonials_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function Testimonials(param) {
    var testimonials = param.testimonials;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTestimonials, {
        children: testimonials.map(function(t) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonials_Testimonial, {
                testimonial: t
            }, t.id);
        })
    });
}
var StyledTestimonials = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-716a8b1e-0"
})(Testimonials_templateObject());
/* harmony default export */ var testimonials_Testimonials = (Testimonials);

;// CONCATENATED MODULE: ./components/pageSegments/TestimonialsSegment.tsx






function TestimonialsSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, testimonials = param.testimonials, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        segmentType: "testimonials",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonials_Testimonials, {
                        testimonials: testimonials
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var pageSegments_TestimonialsSegment = (TestimonialsSegment);

// EXTERNAL MODULE: ./components/icons/ArrowIcon.tsx
var ArrowIcon = __webpack_require__(7009);
;// CONCATENATED MODULE: ./components/Accordion.tsx

function Accordion_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Accordion_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Accordion_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Accordion_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Accordion_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          transform: rotate( 90deg );\n        "
    ]);
    Accordion_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Accordion_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: ",
        ";\n    "
    ]);
    Accordion_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Accordion_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        color: ",
        ";\n        \n        ",
        " svg path {\n          fill: ",
        ";\n        }\n      "
    ]);
    Accordion_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    h3 button {\n      color: ",
        ";\n\n      ",
        " svg path {\n        fill: ",
        ";\n      }\n\n      ",
        "\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        color: ",
        ";\n        \n        ",
        " svg path {\n          fill: ",
        ";\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    \n    h3 button {\n      color: inherit;\n      \n      ",
        " svg path {\n        fill: ",
        ";\n      }\n\n      ",
        "\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --arrow-size: 33px;\n  max-width: 650px;\n\n  h3 {\n    margin: 0 0 calc( 3 * var( --stack-basis ) );\n\n    button {\n      display: flex;\n      align-items: flex-start;\n      padding: 0;\n      margin: 0;\n      background: 0;\n      border: 0;\n      ",
        "\n      font-size: ",
        ";\n      line-height: 1.2;\n      text-align: left;\n      cursor: pointer;\n      transition: color .3s ease-out;\n\n      ",
        " {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 var( --arrow-size );\n        width: var( --arrow-size );\n        height: var( --arrow-size );\n        margin-right: var( --grid-gutter );\n        transition: transform .3s ease-in-out;\n\n        svg {\n          width: 100%;\n        }\n\n        ",
        "\n      }\n\n      &:hover {\n        color: ",
        ";\n      }\n\n      @media ( max-width: 500px ) {\n        font-size: ",
        ";\n      }\n    }\n  }\n\n  ",
        " {\n    overflow: hidden;\n    height: 0;\n    margin-left: calc( var( --grid-gutter ) + var( --arrow-size ) );\n    font-size: ",
        ";\n    transition: height .3s ease-in-out;\n\n    ",
        "\n\n    p {\n      &:first-child {\n        margin-top: 0;\n      }\n      \n      &:last-child {\n        margin-bottom: 0;\n        padding-bottom: calc( 3 * var( --stack-basis ) );\n      }\n    }\n\n    strong {\n      font-weight: 600;\n    }\n\n    a {\n      ",
        "\n    }\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






function Accordion(param) {
    var items = param.items, _openFirstItem = param.openFirstItem, openFirstItem = _openFirstItem === void 0 ? true : _openFirstItem, _alwaysOne = param.alwaysOne, alwaysOne = _alwaysOne === void 0 ? true : _alwaysOne, _theme = param.theme, theme = _theme === void 0 ? null : _theme;
    var ref;
    var ref1 = (0,react.useState)(openFirstItem || alwaysOne ? (ref = items[0]) === null || ref === void 0 ? void 0 : ref.id : null), openItem = ref1[0], setOpenItem = ref1[1];
    var toggleItem = function(itemId) {
        setOpenItem(openItem !== itemId || alwaysOne ? itemId : null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAccordion, {
        children: items.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionItem, {
                theme: theme,
                item: item,
                isOpen: item.id === openItem,
                toggleItem: toggleItem
            }, item.id);
        })
    });
}
function AccordionItem(param) {
    var theme = param.theme, item = param.item, isOpen = param.isOpen, toggleItem = param.toggleItem;
    var headerRef = (0,react.useRef)(null);
    var bodyRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), bodyHeight = ref[0], setBodyHeight = ref[1];
    (0,react.useEffect)(function() {
        if (bodyRef.current) {
            setBodyHeight(Math.max(bodyRef.current.offsetHeight, bodyRef.current.scrollHeight));
        }
    }, [
        isOpen
    ]);
    (0,react.useEffect)(function() {
        // A hack to get the correct height for an item that is open on initial render
        // ¯\_(ツ)_/¯
        if (isOpen && bodyRef.current) {
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    requestAnimationFrame(function() {
                        if (bodyRef.current) {
                            setBodyHeight(Math.max(bodyRef.current.offsetHeight, bodyRef.current.scrollHeight));
                        }
                    });
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
        $isOpen: isOpen,
        $height: bodyHeight,
        $theme: theme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                ref: headerRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: function() {
                        return toggleItem(item.id);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrow, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {})
                        }),
                        item.heading
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                ref: bodyRef,
                dangerouslySetInnerHTML: {
                    __html: (0,strings/* wrapWithPTags */.gu)(item.itemContent)
                }
            })
        ]
    });
}
var StyledBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e187ebac-0"
})(Accordion_templateObject());
var StyledArrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e187ebac-1"
})(Accordion_templateObject1());
var StyledItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-e187ebac-2"
})(_templateObject8(), function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.large;
}, StyledArrow, function(p) {
    return p.$isOpen && (0,styled_components_browser_esm/* css */.iv)(Accordion_templateObject2());
}, function(p) {
    return p.theme.colors.green400;
}, function(p) {
    return p.theme.typo.sizes.medium;
}, StyledBody, function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.$isOpen && (0,styled_components_browser_esm/* css */.iv)(Accordion_templateObject3(), p.$height ? "".concat(p.$height, "px") : "auto");
}, function(p) {
    return (0,links/* textLink */.k)(p.theme);
}, function(p) {
    return p.$theme === "blue" && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), p.theme.colors.blue700, StyledArrow, p.theme.colors.blue700, p.$isOpen && (0,styled_components_browser_esm/* css */.iv)(Accordion_templateObject4(), p.theme.colors.realWhite, StyledArrow, p.theme.colors.realWhite), p.theme.colors.white);
}, function(p) {
    return p.$theme === "green" && (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), p.theme.colors.green100, StyledArrow, p.theme.colors.green100, p.$isOpen && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), p.theme.colors.realWhite, StyledArrow, p.theme.colors.realWhite), p.theme.colors.realWhite);
});
var StyledAccordion = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-e187ebac-3"
})(_templateObject9());
/* harmony default export */ var components_Accordion = (Accordion);

;// CONCATENATED MODULE: ./components/pageSegments/AccordionSegment.tsx

function AccordionSegment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: calc( 2 * var( --grid-gutter ) );\n\n  > * {\n    flex-grow: 1;\n    max-width: 450px;\n\n    &:last-child {\n      max-width: max( calc( 50% + 17px ), 600px );\n    }\n  }\n"
    ]);
    AccordionSegment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AccordionSegment_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n  "
    ]);
    AccordionSegment_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AccordionSegment_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row-reverse;\n  justify-content: space-evenly;\n  gap: calc( 2 * var( --grid-gutter ) );\n\n  > * {\n    flex-grow: 1;\n    max-width: 450px;\n  }\n\n  ",
        "\n"
    ]);
    AccordionSegment_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AccordionSegment_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  /* margin-top: calc( 3 * var( --stack-basis ) ); */\n"
    ]);
    AccordionSegment_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










function AccordionSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, accordionStyle = param.accordionStyle, accordionLayout = param.accordionLayout, buttonLabel = param.buttonLabel, buttonLink = param.buttonLink, buttonIcon = param.buttonIcon, image = param.image, accordion = param.accordion, additionalBottomPadding = param.additionalBottomPadding;
    var getThemeColors = function() {
        if (accordionStyle === "blue") {
            return {
                bgColor: "blue400",
                textColor: "realWhite"
            };
        }
        if (accordionStyle === "green") {
            return {
                bgColor: "green700",
                textColor: "green100"
            };
        }
        return {
            bgColor: "transparent",
            textColor: "black"
        };
    };
    var ref = getThemeColors(), bgColor = ref.bgColor, textColor = ref.textColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        color: bgColor,
        segmentType: "accordion",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    image && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Background/* default */.Z, {
                                $textColor: textColor,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                                    title: title,
                                    subtitle: subtitle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAccordionWithImage, {
                                $layout: accordionLayout,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSegment_StyledImage, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                                            src: image.url,
                                            alt: image.alt,
                                            width: image.width,
                                            height: image.height,
                                            dateModified: image.dateModified,
                                            layout: "responsive"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Accordion, {
                                        items: accordion,
                                        theme: accordionStyle
                                    })
                                ]
                            })
                        ]
                    }),
                    !image && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionSegment_StyledAccordion, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Background/* default */.Z, {
                                $textColor: textColor,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                                    $between: 5,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                                            title: title,
                                            subtitle: subtitle,
                                            align: "left"
                                        }),
                                        buttonLabel && buttonLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                            href: buttonLink,
                                            color: "green",
                                            icon: buttonIcon,
                                            children: buttonLabel
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Accordion, {
                                items: accordion,
                                theme: accordionStyle
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var AccordionSegment_StyledAccordion = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15e350f-0"
})(AccordionSegment_templateObject());
var StyledAccordionWithImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15e350f-1"
})(AccordionSegment_templateObject2(), function(p) {
    return p.$layout === "textRight" && (0,styled_components_browser_esm/* css */.iv)(AccordionSegment_templateObject1());
});
var AccordionSegment_StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15e350f-2"
})(AccordionSegment_templateObject3());
/* harmony default export */ var pageSegments_AccordionSegment = (AccordionSegment);

;// CONCATENATED MODULE: ./components/ButtonGroup.tsx

function ButtonGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: var( --grid-gutter );\n"
    ]);
    ButtonGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function ButtonGroup(param) {
    var buttons = param.buttons;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonGroup, {
        children: buttons.map(function(button) {
            var preIcon = button.preIcon || null;
            var postIcon = button.postIcon || null;
            if (button.href) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    href: button.href,
                    target: button.openInNewTab ? "_blank" : "_self",
                    color: button.color || "green",
                    outline: !button.primary,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            preIcon,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: button.label
                            }),
                            postIcon
                        ]
                    })
                }, button.id);
            }
            if (button.onClick) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    onClick: button.onClick,
                    color: button.color || "green",
                    outline: !button.primary,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            preIcon,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: button.label
                            }),
                            postIcon
                        ]
                    })
                }, button.id);
            }
            return null;
        })
    });
}
var StyledButtonGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-915313f-0"
})(ButtonGroup_templateObject());
/* harmony default export */ var components_ButtonGroup = (ButtonGroup);

// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(2317);
;// CONCATENATED MODULE: ./components/icons/brixel/HouseInHand.tsx


function HouseInHand(param) {
    var _color = param.color, color = _color === void 0 ? "green700" : _color;
    var houseColor = (0,colors/* getColor */.L)(color);
    var handColor = (0,colors/* getColor */.L)("black");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "162",
        height: "151",
        viewBox: "0 0 162 151",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.9199 13.5684L65.8096 25.4297",
                stroke: handColor,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M127.591 13.5684L115.701 25.4297",
                stroke: handColor,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M90.7568 17.8048V1.03149",
                stroke: handColor,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.0154 89.4508L31.469 72.0219C30.5103 71.4155 29.4253 71.0359 28.2969 70.9122C27.1686 70.7885 26.0269 70.9239 24.959 71.308C23.8912 71.6922 22.9256 72.3149 22.1361 73.1286C21.3467 73.9423 20.7542 74.9253 20.4041 76.0025C19.8249 77.794 19.9497 79.738 20.7531 81.4411C21.5565 83.1443 22.95 84.723 24.7029 85.4196",
                stroke: handColor,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M48.7827 82.9826L38.7515 76.6252C37.8708 76.0679 37.1252 75.3221 36.5688 74.442C36.0125 73.5618 35.6593 72.5693 35.5347 71.5362C35.4102 70.5031 35.5174 69.4553 35.8487 68.4686C36.18 67.4819 36.7271 66.5811 37.4503 65.8313C38.7259 64.5087 40.47 63.737 42.3089 63.6814C44.1479 63.6258 46.0784 64.5133 47.2892 65.5339L58.0838 73.245",
                stroke: handColor,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M99.6783 83.3856L67.4597 103.281L58.0742 99.1665V51.5514L90.954 27.2755L123.834 51.5514V86.1293L114.736 82.5962C112.314 81.6544 109.718 81.2377 107.122 81.3738C104.526 81.5099 101.988 82.1957 99.6783 83.3856Z",
                fill: houseColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M160.038 149.889L132.099 134.045C128.737 132.139 125.027 130.923 121.187 130.469C117.347 130.016 113.455 130.334 109.74 131.404L81.3522 139.582C78.4293 140.426 75.3541 140.607 72.3519 140.112C69.3497 139.617 66.4965 138.459 64.0012 136.722L5.69521 96.156C4.62652 95.4105 3.73845 94.436 3.096 93.3039C2.45356 92.1717 2.073 90.9106 1.98218 89.6128C1.89136 88.315 2.09257 87.0134 2.57109 85.8032C3.04962 84.593 3.79334 83.5048 4.74783 82.6184C5.95958 81.4966 7.46519 80.7403 9.09017 80.4372C10.7151 80.1342 12.3929 80.2967 13.9291 80.906L66.2582 102.894M160.038 104.334L119.198 84.4254C115.554 82.6492 111.524 81.8037 107.471 81.9648C103.419 82.1259 99.4696 83.2885 95.9785 85.3482L66.2585 102.883C65.2736 103.465 64.4209 104.245 63.7546 105.173C63.0883 106.101 62.623 107.158 62.3884 108.276C62.1538 109.393 62.1551 110.547 62.392 111.664C62.6289 112.781 63.0964 113.837 63.7647 114.764C64.8322 116.243 66.362 117.326 68.1136 117.843C69.8653 118.36 71.7395 118.283 73.4419 117.622L99.6343 107.461",
                stroke: handColor,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
/* harmony default export */ var brixel_HouseInHand = (HouseInHand);

;// CONCATENATED MODULE: ./components/icons/brixel/MagnifyingGlass.tsx


function MagnifyingGlass(param) {
    var _color = param.color, color = _color === void 0 ? "green700" : _color;
    var houseColor = (0,colors/* getColor */.L)(color);
    var magnifyingGlassColor = (0,colors/* getColor */.L)("black");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "144",
        height: "144",
        viewBox: "0 0 144 144",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50.9131 86.4219L42.5084 94.8265L48.8751 101.193L57.2797 92.7885",
                stroke: magnifyingGlassColor,
                strokeWidth: "2",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.8525 96.2452C52.7899 95.3299 51.7534 94.3684 50.7457 93.3607C49.6103 92.2253 48.5336 91.0534 47.5156 89.8488L50.7457 86.6187L53.929 89.802L57.1123 92.9853L53.8525 96.2452Z",
                fill: magnifyingGlassColor,
                stroke: magnifyingGlassColor,
                strokeWidth: "2",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "90.7417",
                cy: "53.3357",
                r: "51.8034",
                stroke: magnifyingGlassColor,
                strokeWidth: "2",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "90.7418",
                cy: "53.3358",
                r: "33.9642",
                transform: "rotate(45 90.7418 53.3358)",
                stroke: magnifyingGlassColor,
                strokeWidth: "2",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "36.5592",
                y: "88.8271",
                width: "25.9017",
                height: "49.645",
                transform: "rotate(45 36.5592 88.8271)",
                stroke: magnifyingGlassColor,
                strokeWidth: "2",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M108.899 68.0305C108.899 69.135 108.003 70.0305 106.899 70.0305H74.5848C73.4803 70.0305 72.5848 69.135 72.5848 68.0305V44.5174C72.5848 43.8854 72.8835 43.2906 73.3905 42.9132L89.5474 30.8839C90.2562 30.3561 91.2274 30.3561 91.9362 30.8839L108.093 42.9132C108.6 43.2906 108.899 43.8854 108.899 44.5174V68.0305Z",
                fill: houseColor
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/icons/grid/GoGridIcon.tsx

function GoGridIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "145",
        height: "144",
        viewBox: "0 0 145 144",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.77246 90.7651L4.63343 91.5062L6.57929 92.0784L8.50732 92.7041L10.4252 93.3544L12.2946 94.1474L14.2218 94.7739L16.1201 95.4837L18.0524 96.0933L19.9575 96.7843L21.894 97.3828L23.8051 98.0552L25.7433 98.6495L27.6374 99.3703L29.5629 100L31.4638 100.703L33.3663 101.399L35.3105 101.978L37.2224 102.647L39.0952 103.431L41.0148 104.078L42.9224 104.762L44.8624 105.351L46.7692 106.036L48.7116 106.617L50.593 107.376L52.5202 108.002L54.4142 108.724L56.3618 109.292L58.2389 110.062L60.1831 110.639L62.1111 111.263L64.0111 111.97L65.9315 112.614L67.8519 113.26L69.7731 113.901L71.6791 114.589L73.5511 115.374L75.4876 115.971L77.4072 116.621L79.3454 117.215L81.2293 117.966L83.1633 118.573L85.0565 119.295L87.0057 119.859L88.9032 120.57L90.8321 121.192L92.7279 121.909L94.6627 122.514L96.5355 123.297L98.4559 123.943L100.407 124.502L102.284 125.272L104.221 125.873L106.118 126.585L108.023 127.276L109.977 127.827L111.883 128.514L113.79 129.198L115.687 129.915L117.624 130.511L119.525 131.214L121.466 131.802L123.332 132.606L125.252 133.252L127.165 133.922L129.079 134.589L130.989 135.268L132.915 135.899L134.81 136.469L134.629 134.471L134.381 132.432L134.279 130.378L134.055 128.336L133.751 126.303L133.616 124.251L133.372 122.211L133.247 120.159L133.078 118.112L132.835 116.072L132.53 114.038L132.388 111.988L132.155 109.947L131.979 107.9L131.744 105.859L131.516 103.818L131.434 101.761L131.098 99.7303L130.961 97.68L130.767 95.6348L130.648 93.5828L130.305 91.5521L130.238 89.4941L129.929 87.4608L129.735 85.4156L129.611 83.3636L129.367 81.3244L129.064 79.2902L129.014 77.2306L128.69 75.199L128.54 73.1496L128.293 71.1103L128.113 69.0634L128 67.0106L127.644 64.9824L127.504 62.9312L127.258 60.892L127.077 58.8459L126.91 56.7973L126.774 54.7471L126.543 52.7053L126.333 50.6618L126.02 48.6285L125.896 46.5765L125.605 44.5406L125.457 42.4912L125.228 40.4494L124.996 38.4076L124.908 36.3522L124.598 34.318L124.422 32.2712L124.279 30.2209L124.13 28.1714L123.789 26.1407L123.694 24.0853L123.39 22.0511L123.226 20.0025L123.07 17.9531L122.833 15.9113L122.62 13.8687L120.929 14.9978L119.229 16.1142L117.49 17.172L115.807 18.3148L114.028 19.3106L112.342 20.4499L110.673 21.6164L108.878 22.5868L107.195 23.7296L105.468 24.8052L103.816 25.998L102.079 27.0567L100.329 28.0984L98.6172 29.1978L96.9515 30.3686L95.2561 31.4935L93.4835 32.4987L91.8067 33.6524L90.057 34.6924L88.3344 35.7757L86.6882 36.977L84.9453 38.0289L83.2201 39.1071L81.5332 40.2456L79.8064 41.3221L78.0677 42.38L76.3791 43.5159L74.637 44.5678L72.9789 45.7513L71.2945 46.8931L69.5753 47.9807L67.8451 49.0512L66.1344 50.1524L64.428 51.2586L62.6808 52.3028L61.0049 53.4592L59.2373 54.4703L57.5894 55.669L55.8346 56.7014L54.1298 57.8119L52.3869 58.8629L50.7 60.0005L49.0003 61.1204L47.2972 62.2334L45.6044 63.3625L43.8427 64.3847L42.1363 65.4918L40.4443 66.6217L38.709 67.6855L36.9592 68.7272L35.3156 69.9336L33.6125 71.0466L31.8399 72.0518L30.1775 73.2285L28.4677 74.3322L26.7163 75.3705L25.0336 76.5149L23.3178 77.6101L21.6164 78.7257L19.8336 79.7147L18.1195 80.8116L16.4351 81.9543L14.7448 83.0877L12.9984 84.1345L11.2877 85.2365L9.55666 86.3079L7.89521 87.4871L6.13867 88.517L4.46703 89.6826L2.77246 90.7651Z",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M75.7082 -0.866102L75.7863 1.17315L75.6683 3.2107L75.6844 5.2491L75.7184 7.2875L75.7498 9.32591L75.7192 11.3643L75.7863 13.4027L75.6377 15.4411L75.664 17.4795L75.7022 19.5179L75.7786 21.5563L75.7387 23.5947L75.6725 25.6331L75.7676 27.6724L75.6555 29.7108L75.7667 31.7492L75.6903 33.7876L75.6445 35.826L75.6691 37.8644L75.6615 39.9028L75.6547 41.942L75.7413 43.9804L75.6538 46.0197L75.7167 48.0581L75.737 50.0973L75.6632 52.1459L76.4502 54.0493L77.2669 55.9298L78.2177 57.7517L78.9861 59.6535L79.8393 61.5178L80.5788 63.4306L81.4812 65.2746L82.2886 67.1585L83.1164 69.033L83.9076 70.9245L84.7014 72.8152L85.4663 74.7186L86.3518 76.5686L87.177 78.4456L87.9904 80.3278L88.8054 82.1769L90.8098 82.2788L92.8448 82.1888L94.8798 82.2949L96.914 82.1506L98.949 82.1905L100.984 82.2066L103.019 82.2499L105.054 82.1879L107.089 82.2245L109.125 82.1888L111.111 82.1727L111.208 80.1962L111.117 78.1697L111.199 76.1432L111.098 74.1175L111.165 72.091L111.173 70.0645L111.092 68.038L111.172 66.0115L111.167 63.9858L111.152 61.9593L111.132 59.9336L111.223 57.9063L111.159 55.8806L111.17 53.8541L111.112 51.8276L111.229 49.801L111.098 47.7754L111.158 45.7489L111.098 43.7223L111.156 41.6958L111.081 39.6693L111.09 37.6428L111.156 35.6163L111.091 33.5898L111.207 31.5632L111.09 29.5367L111.184 27.5102L111.079 25.4829L111.111 23.4563L111.21 21.4298L111.23 19.4033L111.085 17.3768L111.21 15.3503L111.078 13.3238L111.09 11.2972L111.236 9.26987L111.19 7.24336L111.078 5.21599L111.102 3.18948L111.077 1.16211L111.176 -0.881384L109.075 -0.894968L106.99 -0.943359L104.905 -0.922135L102.82 -0.841482L100.734 -0.861008L98.6485 -0.794788L96.5634 -0.885629L94.4783 -0.832992L92.3932 -0.907702L90.3081 -0.928078L88.223 -0.787996L86.1379 -0.88478L84.0519 -0.900062L81.966 -0.935719L79.8809 -0.808372L77.795 -0.812617L75.7082 -0.866102Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M100.839 144.197L98.8091 144.21L96.7588 144.148L94.7093 144.209L92.6591 144.182L90.6096 144.229L88.5593 144.182L86.509 144.295L84.4596 144.191L82.4093 144.149L80.3599 144.179L78.3096 144.292L76.2593 144.29L74.209 144.278L72.1587 144.145L70.1093 144.176L68.059 144.243L66.0087 144.283L63.9584 144.236L61.9081 144.272L59.8587 144.134L57.8084 144.212L55.7581 144.261L53.7078 144.275L51.6567 144.222L49.6064 144.221L47.5561 144.298L45.5152 144.206L45.5058 142.151L45.5339 140.085L45.5661 138.02L45.4685 135.954L45.4456 133.889L45.5576 131.823L45.544 129.757L45.5058 127.692L45.4957 125.625L45.5848 123.56L45.4685 121.494L45.544 119.428L45.4277 117.361L45.5109 115.301L47.5544 115.273L49.6047 115.228L51.6542 115.326L53.7044 115.326L55.7539 115.351L57.8042 115.229L59.8545 115.333L61.9039 115.326L63.9542 115.332L66.0036 115.348L68.0539 115.34L70.1042 115.266L72.1545 115.286L74.2048 115.257L76.2542 115.3L78.3045 115.317L80.3548 115.214L82.4051 115.293L84.4554 115.371L86.5048 115.371L88.5551 115.374L90.6054 115.285L92.6557 115.342L94.7068 115.367L96.7571 115.368L98.8074 115.301L100.852 115.303L100.897 117.361L100.821 119.427L100.909 121.493L100.89 123.558L100.805 125.624L100.815 127.689V129.755L100.813 131.82V133.886L100.858 135.952L100.881 138.018L100.86 140.084L100.815 142.15L100.839 144.197Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M100.839 144.197L98.8091 144.21L96.7588 144.148L94.7093 144.209L92.6591 144.182L90.6096 144.229L88.5593 144.182L86.509 144.295L84.4596 144.191L82.4093 144.149L80.3599 144.179L78.3096 144.292L76.2593 144.29L74.209 144.278L72.1587 144.145L70.1093 144.176L68.059 144.243L66.0087 144.283L63.9584 144.236L61.9081 144.272L59.8587 144.134L57.8084 144.212L55.7581 144.261L53.7078 144.275L51.6567 144.222L49.6064 144.221L47.5561 144.298L45.5152 144.206L45.5058 142.151L45.5339 140.085L45.5661 138.02L45.4685 135.954L45.4456 133.889L45.5576 131.823L45.544 129.757L45.5058 127.692L45.4957 125.625L45.5848 123.56L45.4685 121.494L45.544 119.428L45.4277 117.361L45.5109 115.301L47.5544 115.273L49.6047 115.228L51.6542 115.326L53.7044 115.326L55.7539 115.351L57.8042 115.229L59.8545 115.333L61.9039 115.326L63.9542 115.332L66.0036 115.348L68.0539 115.34L70.1042 115.266L72.1545 115.286L74.2048 115.257L76.2542 115.3L78.3045 115.317L80.3548 115.214L82.4051 115.293L84.4554 115.371L86.5048 115.371L88.5551 115.374L90.6054 115.285L92.6557 115.342L94.7068 115.367L96.7571 115.368L98.8074 115.301L100.852 115.303L100.897 117.361L100.821 119.427L100.909 121.493L100.89 123.558L100.805 125.624L100.815 127.689V129.755L100.813 131.82V133.886L100.858 135.952L100.881 138.018L100.86 140.084L100.815 142.15L100.839 144.197Z",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.635 83.4566L119.637 85.5731L119.75 87.7211L119.751 89.869L119.652 92.0169L119.625 94.1258L117.646 94.1512L115.625 94.2158L113.604 94.209L111.584 94.2243L109.562 94.1317L107.541 94.1529L105.52 94.0833L103.499 94.0952L101.478 94.2132L99.4568 94.2073L97.4362 94.1869L95.4148 94.113L93.3943 94.2124L91.3737 94.2039L89.3531 94.1708L87.3325 94.1309L85.3111 94.175L83.2905 94.1563L81.2691 94.2039L79.2485 94.0969L77.2271 94.1444L75.2065 94.1181L73.186 94.2073L71.1646 94.1351L69.1431 94.209L67.1226 94.13L65.1011 94.1062L63.0806 94.2158L61.0591 94.1767L59.0386 94.1045L57.0171 94.1275L54.9957 94.1266L52.9743 94.1869L50.9529 94.2489L48.9323 94.1317L46.9109 94.2421L44.8895 94.2344L42.8689 94.1597L40.8475 94.237L38.826 94.2209L36.8046 94.0893L34.7832 94.2472L32.7618 94.1801L30.7403 94.2056L28.7181 94.1343L26.6474 94.2115L26.6601 92.0178L26.7187 89.8698L26.6754 87.7219L26.6211 85.574L26.6652 83.3964L28.7172 83.3412L30.7386 83.3573L32.7592 83.348L34.7798 83.4193L36.8012 83.4702L38.8218 83.46L40.8432 83.4286L42.8646 83.37L44.8852 83.4091L46.9058 83.4278L48.9272 83.4745L50.9486 83.4388L52.9692 83.4914L54.9898 83.3904L57.0104 83.3582L59.0309 83.3828L61.0523 83.3666L63.0729 83.3938L65.0943 83.4048L67.1149 83.4388L69.1363 83.4227L71.1569 83.4957L73.1775 83.4914L75.1989 83.4218L77.2203 83.4991L79.2409 83.3955L81.2623 83.5093L83.2829 83.4864L85.3043 83.4363L87.3249 83.3709L89.3463 83.3947L91.3677 83.5008L93.3892 83.46L95.4106 83.4201L97.4312 83.4015L99.4526 83.3607L101.474 83.4948L103.495 83.404L105.516 83.3437L107.537 83.3972L109.559 83.4957L111.58 83.4694L113.602 83.3403L115.623 83.4439L117.645 83.376L119.635 83.4566Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.635 83.4566L119.637 85.5731L119.75 87.7211L119.751 89.869L119.652 92.0169L119.625 94.1258L117.646 94.1512L115.625 94.2158L113.604 94.209L111.584 94.2243L109.562 94.1317L107.541 94.1529L105.52 94.0833L103.499 94.0952L101.478 94.2132L99.4568 94.2073L97.4362 94.1869L95.4148 94.113L93.3943 94.2124L91.3737 94.2039L89.3531 94.1708L87.3325 94.1309L85.3111 94.175L83.2905 94.1563L81.2691 94.2039L79.2485 94.0969L77.2271 94.1444L75.2065 94.1181L73.186 94.2073L71.1646 94.1351L69.1431 94.209L67.1226 94.13L65.1011 94.1062L63.0806 94.2158L61.0591 94.1767L59.0386 94.1045L57.0171 94.1275L54.9957 94.1266L52.9743 94.1869L50.9529 94.2489L48.9323 94.1317L46.9109 94.2421L44.8895 94.2344L42.8689 94.1597L40.8475 94.237L38.826 94.2209L36.8046 94.0893L34.7832 94.2472L32.7618 94.1801L30.7403 94.2056L28.7181 94.1343L26.6474 94.2115L26.6601 92.0178L26.7187 89.8698L26.6754 87.7219L26.6211 85.574L26.6652 83.3964L28.7172 83.3412L30.7386 83.3573L32.7592 83.348L34.7798 83.4193L36.8012 83.4702L38.8218 83.46L40.8432 83.4286L42.8646 83.37L44.8852 83.4091L46.9058 83.4278L48.9272 83.4745L50.9486 83.4388L52.9692 83.4914L54.9898 83.3904L57.0104 83.3582L59.0309 83.3828L61.0523 83.3666L63.0729 83.3938L65.0943 83.4048L67.1149 83.4388L69.1363 83.4227L71.1569 83.4957L73.1775 83.4914L75.1989 83.4218L77.2203 83.4991L79.2409 83.3955L81.2623 83.5093L83.2829 83.4864L85.3043 83.4363L87.3249 83.3709L89.3463 83.3947L91.3677 83.5008L93.3892 83.46L95.4106 83.4201L97.4312 83.4015L99.4526 83.3607L101.474 83.4948L103.495 83.404L105.516 83.3437L107.537 83.3972L109.559 83.4957L111.58 83.4694L113.602 83.3403L115.623 83.4439L117.645 83.376L119.635 83.4566Z",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.794 108.982L34.0027 108.643L32.6842 107.335L32.2555 105.539L32.8302 103.319L34.4654 101.711L36.6753 101.056L38.7918 101.53L40.5789 102.737L41.7021 104.558L42.135 106.64L41.7878 108.748L40.921 110.725L39.2994 112.147L37.4317 113.205L35.2991 113.471L33.3761 113.341L31.5848 112.632L29.9199 111.664L28.5395 110.309L27.502 108.674L26.8925 106.838L26.7031 104.919L26.8763 102.816L27.5555 100.821L28.5649 98.9832L29.8197 97.2895L31.4336 95.9158L33.3532 95.0286L35.3542 94.3868L37.4495 94.2017L39.4913 94.189L41.5323 94.2051L43.5741 94.2408L45.6159 94.0914L47.6568 94.1185L49.6986 94.2L51.7404 94.1508L53.7822 94.1118L55.8232 94.1432L57.865 94.1771L59.9068 94.189L61.9477 94.2416L63.9895 94.2153L66.0313 94.1873L68.0731 94.1033L70.1149 94.2247L72.1567 94.1287L74.1985 94.2264L76.2403 94.0914L78.2821 94.1483L80.3239 94.0888L82.3657 94.1168L84.4083 94.127L86.4501 94.1907L88.4919 94.144L90.5337 94.2298L92.5755 94.088L94.6173 94.161L96.6591 94.2383L98.7018 94.0854L100.744 94.2085L102.785 94.2315L104.828 94.1729L106.871 94.082L108.913 94.0854L111.026 94.2994L113.006 95.0371L114.898 95.9625L116.526 97.3065L117.869 98.9348L118.836 100.809L119.379 102.838L119.699 104.919L119.526 106.851L118.75 108.621L117.842 110.325L116.376 111.58L114.787 112.653L112.973 113.284L111.064 113.583L108.945 113.162L106.992 112.244L105.5 110.682L104.438 108.793L104.15 106.64L104.606 104.536L105.838 102.791L107.566 101.517L109.688 101.09L111.911 101.687L113.542 103.313L114.094 105.539L113.685 107.339L112.336 108.599L110.568 109.041",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.794 108.982L34.0027 108.643L32.6842 107.335L32.2555 105.539L32.8302 103.319L34.4654 101.711L36.6753 101.056L38.7918 101.53L40.5789 102.737L41.7021 104.558L42.135 106.64L41.7878 108.748L40.921 110.725L39.2994 112.147L37.4317 113.205L35.2991 113.471L33.3761 113.341L31.5848 112.632L29.9199 111.664L28.5395 110.309L27.502 108.674L26.8925 106.838L26.7031 104.919L26.8763 102.816L27.5555 100.821L28.5649 98.9832L29.8197 97.2895L31.4336 95.9158L33.3532 95.0286L35.3542 94.3868L37.4495 94.2017L39.4913 94.189L41.5323 94.2051L43.5741 94.2408L45.6159 94.0914L47.6568 94.1185L49.6986 94.2L51.7404 94.1508L53.7822 94.1118L55.8232 94.1432L57.865 94.1771L59.9068 94.189L61.9477 94.2416L63.9895 94.2153L66.0313 94.1873L68.0731 94.1033L70.1149 94.2247L72.1567 94.1287L74.1985 94.2264L76.2403 94.0914L78.2821 94.1483L80.3239 94.0888L82.3657 94.1168L84.4083 94.127L86.4501 94.1907L88.4919 94.144L90.5337 94.2298L92.5755 94.088L94.6173 94.161L96.6591 94.2383L98.7018 94.0854L100.744 94.2085L102.785 94.2315L104.828 94.1729L106.871 94.082L108.913 94.0854L111.026 94.2994L113.006 95.0371L114.898 95.9625L116.526 97.3065L117.869 98.9348L118.836 100.809L119.379 102.838L119.699 104.919L119.526 106.851L118.75 108.621L117.842 110.325L116.376 111.58L114.787 112.653L112.973 113.284L111.064 113.583L108.945 113.162L106.992 112.244L105.5 110.682L104.438 108.793L104.15 106.64L104.606 104.536L105.838 102.791L107.566 101.517L109.688 101.09L111.911 101.687L113.542 103.313L114.094 105.539L113.685 107.339L112.336 108.599L110.568 109.041",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.6932 123.885L51.7204 125.919L51.6389 127.951L51.6703 129.983L51.7416 132.017L51.6431 134.049L51.7577 136.083L51.6355 138.116L51.683 140.149L51.6338 142.182L51.7518 144.216",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.6932 123.885L51.7204 125.919L51.6389 127.951L51.6703 129.983L51.7416 132.017L51.6431 134.049L51.7577 136.083L51.6355 138.116L51.683 140.149L51.6338 142.182L51.7518 144.216",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.5604 123.885L62.5876 125.919L62.5061 127.951L62.5375 129.983L62.6088 132.017L62.5103 134.049L62.6249 136.083L62.5027 138.116L62.5502 140.149L62.501 142.182L62.619 144.216",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.5604 123.885L62.5876 125.919L62.5061 127.951L62.5375 129.983L62.6088 132.017L62.5103 134.049L62.6249 136.083L62.5027 138.116L62.5502 140.149L62.501 142.182L62.619 144.216",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M73.4266 123.885L73.4538 125.919L73.3723 127.951L73.4037 129.983L73.475 132.017L73.3765 134.049L73.4911 136.083L73.3689 138.116L73.4164 140.149L73.3672 142.182L73.4852 144.216",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M73.4266 123.885L73.4538 125.919L73.3723 127.951L73.4037 129.983L73.475 132.017L73.3765 134.049L73.4911 136.083L73.3689 138.116L73.4164 140.149L73.3672 142.182L73.4852 144.216",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.2938 123.885L84.321 125.919L84.2395 127.951L84.2709 129.983L84.3422 132.017L84.2437 134.049L84.3583 136.083L84.2361 138.116L84.2836 140.149L84.2344 142.182L84.3524 144.216",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.2938 123.885L84.321 125.919L84.2395 127.951L84.2709 129.983L84.3422 132.017L84.2437 134.049L84.3583 136.083L84.2361 138.116L84.2836 140.149L84.2344 142.182L84.3524 144.216",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M95.161 123.885L95.1882 125.919L95.1067 127.951L95.1381 129.983L95.2094 132.017L95.1109 134.049L95.2255 136.083L95.1033 138.116L95.1508 140.149L95.1016 142.182L95.2196 144.216",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M95.161 123.885L95.1882 125.919L95.1067 127.951L95.1381 129.983L95.2094 132.017L95.1109 134.049L95.2255 136.083L95.1033 138.116L95.1508 140.149L95.1016 142.182L95.2196 144.216",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M60.1971 20.355L59.2997 22.3068L58.5671 24.2875L57.7419 26.2274L56.8343 28.1316L56.0532 30.0919L55.2382 32.0361L54.3281 33.9395L53.519 35.8879L52.6395 37.8049L53.845 39.2957L54.7806 40.9674L55.7688 42.611L56.4591 44.3998L57.0763 46.2166L57.3598 48.1132L57.6408 50.0031L57.6714 51.9133L57.6561 54.0001L57.3946 56.075L56.8403 58.0905L56.1764 60.0686L55.2781 61.9516L54.2891 63.7888L53.0351 65.4571L51.6801 67.0387L50.2318 68.544L48.5899 69.8361L46.7977 70.905L45.0046 71.9772L43.0749 72.7863L41.0518 73.3118L39.0032 73.6973L36.9351 73.9689L36.1455 75.8741L35.2524 77.7333L34.5053 79.6571L33.6877 81.5503L32.7793 83.4597L34.9119 83.3646L36.9953 83.4979L39.0796 83.3773L41.163 83.4937L43.2472 83.4189L45.3306 83.4359L47.414 83.4877L49.4983 83.4164L51.5817 83.4368L53.6659 83.3485L55.7493 83.4724L57.8336 83.3595L59.917 83.3824L62.0004 83.5013L64.0846 83.4088L66.1688 83.4588L68.2531 83.4495L70.3373 83.3655L72.4216 83.3519L74.5092 83.4291L74.5398 81.4205L74.5483 79.4151L74.4566 77.409L74.5211 75.4037L74.5084 73.3984L74.4795 71.3923L74.5084 69.387L74.4778 67.3817L74.5568 65.3756L74.5873 63.3703L74.5746 61.3641L74.4676 59.358L74.5092 57.3527L74.5814 55.3457L74.4473 53.3523L73.6577 51.5329L72.9692 49.6575L72.1635 47.8322L71.2551 46.0519L70.5895 44.1663L69.7091 42.3733L68.9179 40.542L68.2056 38.676L67.4041 36.849L66.6001 35.0237L65.8046 33.1941L64.9141 31.4062L64.1152 29.5775L63.3638 27.7284L62.6278 25.8734L61.7525 24.0778L61.0707 22.1981L60.1971 20.355Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M60.1971 20.355L59.2997 22.3068L58.5671 24.2875L57.7419 26.2274L56.8343 28.1316L56.0532 30.0919L55.2382 32.0361L54.3281 33.9395L53.519 35.8879L52.6395 37.8049L53.845 39.2957L54.7806 40.9674L55.7688 42.611L56.4591 44.3998L57.0763 46.2166L57.3598 48.1132L57.6408 50.0031L57.6714 51.9133L57.6561 54.0001L57.3946 56.075L56.8403 58.0905L56.1764 60.0686L55.2781 61.9516L54.2891 63.7888L53.0351 65.4571L51.6801 67.0387L50.2318 68.544L48.5899 69.8361L46.7977 70.905L45.0046 71.9772L43.0749 72.7863L41.0518 73.3118L39.0032 73.6973L36.9351 73.9689L36.1455 75.8741L35.2524 77.7333L34.5053 79.6571L33.6877 81.5503L32.7793 83.4597L34.9119 83.3646L36.9953 83.4979L39.0796 83.3773L41.163 83.4937L43.2472 83.4189L45.3306 83.4359L47.414 83.4877L49.4983 83.4164L51.5817 83.4368L53.6659 83.3485L55.7493 83.4724L57.8336 83.3595L59.917 83.3824L62.0004 83.5013L64.0846 83.4088L66.1688 83.4588L68.2531 83.4495L70.3373 83.3655L72.4216 83.3519L74.5092 83.4291L74.5398 81.4205L74.5483 79.4151L74.4566 77.409L74.5211 75.4037L74.5084 73.3984L74.4795 71.3923L74.5084 69.387L74.4778 67.3817L74.5568 65.3756L74.5873 63.3703L74.5746 61.3641L74.4676 59.358L74.5092 57.3527L74.5814 55.3457L74.4473 53.3523L73.6577 51.5329L72.9692 49.6575L72.1635 47.8322L71.2551 46.0519L70.5895 44.1663L69.7091 42.3733L68.9179 40.542L68.2056 38.676L67.4041 36.849L66.6001 35.0237L65.8046 33.1941L64.9141 31.4062L64.1152 29.5775L63.3638 27.7284L62.6278 25.8734L61.7525 24.0778L61.0707 22.1981L60.1971 20.355Z",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.1943 30.3501L32.155 30.5148L30.1446 30.8518L28.1648 31.3247L26.2071 31.8978L24.341 32.7264L22.5539 33.7146L20.85 34.8438L19.3201 36.1987L17.8531 37.6182L16.5992 39.2287L15.414 40.8868L14.3714 42.645L13.6108 44.5408L12.9392 46.4671L12.4587 48.4512L12.1947 50.476L12.1123 52.5153L12.2184 54.552L12.4544 56.5794L13.0003 58.5456L13.559 60.5093L14.4275 62.3575L15.4165 64.1412L16.5805 65.8163L17.8777 67.3894L19.3592 68.7885L20.8891 70.135L22.6049 71.2328L24.3206 72.3449L26.1986 73.1548L28.1597 73.7245L30.1421 74.1889L32.155 74.52L34.1943 74.5336L35.5493 74.6075L36.2471 72.6361L37.147 70.765L37.9128 68.8352L38.7915 66.9547L39.6031 65.0445L40.4411 63.1462L41.3359 61.2734L42.0703 59.33L42.8581 57.4097L43.7326 55.5275L44.6266 53.6538L45.473 51.7588L46.1921 49.8087L47.0037 47.8994L47.8985 46.0248L48.666 44.0959L49.4683 42.1815L50.3648 40.3078L51.1586 38.4001L49.897 36.9687L48.4351 35.6953L46.9647 34.4261L45.2675 33.4811L43.5738 32.5439L41.7706 31.8418L39.9623 31.1329L38.058 30.7466L36.1376 30.4435L34.1943 30.3501Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.6376 29.7485L33.5984 29.9132L31.5872 30.2503L29.6082 30.7232L27.6504 31.2962L25.7844 32.1248L23.9973 33.113L22.2934 34.2422L20.7635 35.5972L19.2965 37.0167L18.0425 38.6272L16.8565 40.2861L15.8148 42.0435L15.0541 43.9392L14.3826 45.8656L13.9012 47.8505L13.638 49.8745L13.5557 51.9137L13.6618 53.9504L13.8978 55.9778L14.4428 57.944L15.0023 59.9077L15.8708 61.7559L16.8599 63.5405L18.0238 65.2147L19.3202 66.7887L20.8026 68.1878L22.3324 69.5335L24.0482 70.632L25.764 71.7434L27.6419 72.5541L29.6022 73.1238L31.5855 73.5882L33.5984 73.9184L35.6376 73.932L36.9926 74.0059L37.6905 72.0354L38.5904 70.1634L39.3562 68.2345L40.2349 66.3532L41.0465 64.4438L41.8844 62.5455L42.7793 60.6718L43.5136 58.7285L44.3015 56.8081L45.1759 54.9259L46.0699 53.0522L46.9163 51.1573L47.6354 49.208L48.4471 47.2978L49.3419 45.4241L50.1094 43.4944L50.9117 41.5799L51.8082 39.7071L52.602 37.7986L51.3404 36.3672L49.8784 35.0937L48.408 33.8253L46.7109 32.8796L45.0172 31.9423L43.2139 31.2402L41.4056 30.5313L39.5014 30.1459L37.581 29.8419L35.6376 29.7485Z",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M57.7679 51.9133L57.5947 50.0073L57.4427 48.0996L56.9979 46.237L56.5021 44.3845L55.71 42.6381L54.7515 40.9843L53.8566 39.2881L52.6986 37.855L51.7376 39.6752L50.9141 41.5786L50.2179 43.5389L49.3647 45.4304L48.5463 47.3372L47.7508 49.2542L46.8882 51.1415L46.007 53.0212L45.1648 54.9178L44.3523 56.8271L43.5059 58.7212L42.673 60.6221L41.8614 62.5314L41.0031 64.4213L40.233 66.3502L39.4418 68.2689L38.5215 70.1315L37.782 72.0731L37.001 73.9732L39.0097 73.7312L41.0481 73.2974L43.0584 72.7379L45.0162 72.0001L46.8322 70.9627L48.5446 69.7724L50.1653 68.4667L51.7206 67.076L53.0781 65.4893L54.2896 63.7888L55.3585 61.9915L56.1625 60.0626L56.8722 58.0998L57.295 56.0563L57.6261 53.9975L57.7679 51.9133Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M57.7679 51.9133L57.5947 50.0073L57.4427 48.0996L56.9979 46.237L56.5021 44.3845L55.71 42.6381L54.7515 40.9843L53.8566 39.2881L52.6986 37.855L51.7376 39.6752L50.9141 41.5786L50.2179 43.5389L49.3647 45.4304L48.5463 47.3372L47.7508 49.2542L46.8882 51.1415L46.007 53.0212L45.1648 54.9178L44.3523 56.8271L43.5059 58.7212L42.673 60.6221L41.8614 62.5314L41.0031 64.4213L40.233 66.3502L39.4418 68.2689L38.5215 70.1315L37.782 72.0731L37.001 73.9732L39.0097 73.7312L41.0481 73.2974L43.0584 72.7379L45.0162 72.0001L46.8322 70.9627L48.5446 69.7724L50.1653 68.4667L51.7206 67.076L53.0781 65.4893L54.2896 63.7888L55.3585 61.9915L56.1625 60.0626L56.8722 58.0998L57.295 56.0563L57.6261 53.9975L57.7679 51.9133Z",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.542 0.37319L74.5692 2.37593L74.486 4.41434L74.5284 6.45189L74.5794 8.49029L74.5021 10.5295L74.5004 12.5679L74.5743 14.6055L74.4597 16.6439L74.4478 18.6823L74.4783 20.7207L74.5879 22.76L74.57 24.7984L74.4486 26.8368L74.5505 28.8752L74.4316 30.9136L74.5853 32.952L74.5064 34.9912L74.5505 37.0288L74.4817 39.068L74.5624 41.1064L74.5081 43.1448L74.5395 45.1841L74.4614 47.2225L74.5717 49.2617L74.5225 51.3001L74.5064 53.3402L75.3944 55.1893L76.0787 57.1267L76.8971 59.0063L77.7962 60.8512L78.5534 62.7571L79.4466 64.6037L80.1589 66.5291L81.0622 68.3714L81.8925 70.246L82.6931 72.1333L83.4937 74.0205L84.301 75.9053L85.1942 77.7527L85.9099 79.6773L86.7028 81.568L87.6104 83.3695L89.608 83.4103L91.643 83.3797L93.6772 83.4468L95.7122 83.4901L97.7472 83.457L99.7822 83.3627L101.817 83.4901L103.852 83.4264L105.887 83.3967L107.922 83.3644L109.95 83.4171L109.883 81.3999L109.885 79.3734L109.922 77.3468L109.998 75.3203L109.906 73.2938L109.902 71.2673L109.996 69.2408L109.928 67.2151L109.945 65.1886L109.961 63.1621L109.88 61.1364L109.919 59.1099L109.955 57.0834L110.012 55.0569L110.012 53.0312L109.982 51.0047L109.971 48.9782L109.977 46.9517L110.023 44.9251L109.949 42.8986L109.956 40.8721L109.91 38.8456L109.883 36.8191L110.042 34.7926L109.896 32.766L109.956 30.7395L109.994 28.713L109.902 26.6865L109.995 24.66L109.96 22.6335L110.039 20.6061L109.97 18.5796L109.877 16.5531L110.028 14.5265L109.883 12.5L110.042 10.4727L110.04 8.44615L109.898 6.41878L109.927 4.39226L109.918 2.3649L109.906 0.391019L107.873 0.372341L105.788 0.313761L103.702 0.295932L101.617 0.311215L99.5318 0.28999L97.4467 0.28235L95.3616 0.298479L93.2765 0.26452L91.1914 0.326496L89.1063 0.364701L87.0212 0.263672L84.9352 0.358757L82.8501 0.402055L80.7642 0.357059L78.6791 0.378283L76.5932 0.329892L74.542 0.37319Z",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.5239 83.4063L76.6837 83.3571L78.8613 83.5031L81.039 83.4743L83.2166 83.4233L85.3942 83.453L87.6058 83.4505L86.7713 81.5386L85.9928 79.642L85.0945 77.7971L84.2761 75.9175L83.4806 74.0285L82.6062 72.1735L81.8939 70.248L81.0933 68.3616L80.1985 66.515L79.3418 64.6515L78.52 62.7736L77.8264 60.8396L76.9766 58.9735L76.1751 57.0863L75.3202 55.2219L74.5086 53.355L74.5536 55.3458L74.4229 57.3511L74.5706 59.3564L74.5714 61.3626L74.5459 63.3679L74.5561 65.374L74.568 67.3793L74.4848 69.3846L74.5273 71.3899L74.5782 73.396L74.501 75.4022L74.4993 77.4075L74.5731 79.4136L74.4585 81.4206L74.5239 83.4063Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.5239 83.4063L76.6837 83.3571L78.8613 83.5031L81.039 83.4743L83.2166 83.4233L85.3942 83.453L87.6058 83.4505L86.7713 81.5386L85.9928 79.642L85.0945 77.7971L84.2761 75.9175L83.4806 74.0285L82.6062 72.1735L81.8939 70.248L81.0933 68.3616L80.1985 66.515L79.3418 64.6515L78.52 62.7736L77.8264 60.8396L76.9766 58.9735L76.1751 57.0863L75.3202 55.2219L74.5086 53.355L74.5536 55.3458L74.4229 57.3511L74.5706 59.3564L74.5714 61.3626L74.5459 63.3679L74.5561 65.374L74.568 67.3793L74.4848 69.3846L74.5273 71.3899L74.5782 73.396L74.501 75.4022L74.4993 77.4075L74.5731 79.4136L74.4585 81.4206L74.5239 83.4063Z",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.361 114.249L121.896 112.229L122.653 110.277L123.168 108.249L123.928 106.302L124.718 104.369L125.445 102.409L126.399 100.549L127.297 98.6638L128.36 96.8674L129.36 95.0353L130.415 93.2286L131.741 91.6088L132.905 89.8692L134.382 88.3852L135.81 86.8681L137.224 85.3255L138.833 83.9917L140.495 82.7234L142.215 81.5339L144.08 80.5186L143.487 82.5417L142.881 84.5257L142.264 86.5073L141.565 88.4608L140.831 90.4015L140.067 92.3296L139.201 94.2152L138.364 96.1135L137.442 97.9744L136.331 99.7301L135.32 101.544L134.188 103.287L132.903 104.92L131.588 106.528L130.134 108.011L128.582 109.386L127.021 110.751L125.343 111.977L123.526 112.994L121.563 113.671",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.361 114.249L121.896 112.229L122.653 110.277L123.168 108.249L123.928 106.302L124.718 104.369L125.445 102.409L126.399 100.549L127.297 98.6638L128.36 96.8674L129.36 95.0353L130.415 93.2286L131.741 91.6088L132.905 89.8692L134.382 88.3852L135.81 86.8681L137.224 85.3255L138.833 83.9917L140.495 82.7234L142.215 81.5339L144.08 80.5186L143.487 82.5417L142.881 84.5257L142.264 86.5073L141.565 88.4608L140.831 90.4015L140.067 92.3296L139.201 94.2152L138.364 96.1135L137.442 97.9744L136.331 99.7301L135.32 101.544L134.188 103.287L132.903 104.92L131.588 106.528L130.134 108.011L128.582 109.386L127.021 110.751L125.343 111.977L123.526 112.994L121.563 113.671",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M117.49 144.921L117.453 142.851L117.652 140.786L117.586 138.714L117.76 136.652L117.946 134.591L118.036 132.523L118.345 130.475L118.558 128.418L118.919 126.381L119.168 124.327L119.432 122.272L119.97 120.27L120.258 118.215L120.884 116.237L121.392 114.233",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M123.42 131.294L124.106 129.312L124.772 127.329L125.366 125.316L126.199 123.393L127.034 121.471L128.04 119.633L129.111 117.836L130.21 116.057L131.364 114.306L132.795 112.774L134.19 111.213L135.722 109.785L137.365 108.482L139.169 107.391L138.629 109.376L137.97 111.313L137.224 113.218L136.384 115.083L135.632 116.985L134.728 118.821L133.66 120.566L132.647 122.342L131.463 124.009L130.176 125.597L128.838 127.147L127.281 128.479L125.583 129.617L123.718 130.415",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M123.42 131.294L124.106 129.312L124.772 127.329L125.366 125.316L126.199 123.393L127.034 121.471L128.04 119.633L129.111 117.836L130.21 116.057L131.364 114.306L132.795 112.774L134.19 111.213L135.722 109.785L137.365 108.482L139.169 107.391L138.629 109.376L137.97 111.313L137.224 113.218L136.384 115.083L135.632 116.985L134.728 118.821L133.66 120.566L132.647 122.342L131.463 124.009L130.176 125.597L128.838 127.147L127.281 128.479L125.583 129.617L123.718 130.415",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.086 144.943L121.33 142.969L121.562 140.998L121.702 139.015L122.075 137.063L122.421 135.107L122.919 133.184L123.45 131.271",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M104.166 104.571L104.142 106.703L104.107 108.851L104.257 110.999L104.229 113.147L104.157 115.271L102.115 115.31L100.049 115.349L97.9826 115.318L95.917 115.284L93.8498 115.272L91.7842 115.219L89.7178 115.245L87.6505 115.273L85.5841 115.357L83.5177 115.237L81.4513 115.332L79.3848 115.234L77.3184 115.369L75.252 115.312L73.1847 115.372L71.1183 115.344L69.0519 115.334L66.9846 115.27L64.9182 115.317L62.8518 115.231L60.7845 115.373L58.7181 115.3L56.6517 115.222L54.5844 115.375L52.518 115.252L50.4507 115.229L48.3835 115.288L46.3171 115.379L44.2498 115.375L42.1299 115.345L42.2419 113.148L42.1647 111L42.1689 108.852L42.1655 106.704L42.1936 104.566L44.2489 104.64L46.3145 104.524L48.3818 104.48L50.4482 104.629L52.5138 104.489L54.5802 104.639L56.6466 104.577L58.7139 104.58L60.7803 104.495L62.8467 104.581L64.9131 104.511L66.9795 104.561L69.046 104.473L71.1124 104.524L73.1796 104.562L75.2461 104.618L77.3125 104.519L79.3798 104.511L81.4462 104.513L83.5126 104.51L85.5799 104.554L87.6463 104.48L89.7127 104.546L91.78 104.577L93.8464 104.593L95.9136 104.479L97.9809 104.524L100.047 104.493L102.115 104.603L104.166 104.571Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M104.166 104.571L104.142 106.703L104.107 108.851L104.257 110.999L104.229 113.147L104.157 115.271L102.115 115.31L100.049 115.349L97.9826 115.318L95.917 115.284L93.8498 115.272L91.7842 115.219L89.7178 115.245L87.6505 115.273L85.5841 115.357L83.5177 115.237L81.4513 115.332L79.3848 115.234L77.3184 115.369L75.252 115.312L73.1847 115.372L71.1183 115.344L69.0519 115.334L66.9846 115.27L64.9182 115.317L62.8518 115.231L60.7845 115.373L58.7181 115.3L56.6517 115.222L54.5844 115.375L52.518 115.252L50.4507 115.229L48.3835 115.288L46.3171 115.379L44.2498 115.375L42.1299 115.345L42.2419 113.148L42.1647 111L42.1689 108.852L42.1655 106.704L42.1936 104.566L44.2489 104.64L46.3145 104.524L48.3818 104.48L50.4482 104.629L52.5138 104.489L54.5802 104.639L56.6466 104.577L58.7139 104.58L60.7803 104.495L62.8467 104.581L64.9131 104.511L66.9795 104.561L69.046 104.473L71.1124 104.524L73.1796 104.562L75.2461 104.618L77.3125 104.519L79.3798 104.511L81.4462 104.513L83.5126 104.51L85.5799 104.554L87.6463 104.48L89.7127 104.546L91.78 104.577L93.8464 104.593L95.9136 104.479L97.9809 104.524L100.047 104.493L102.115 104.603L104.166 104.571Z",
                stroke: "black",
                strokeMiterlimit: "10"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/pageSegments/TextCtaSegment.tsx













function TextCtaSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, theme = param.theme, icon = param.icon, buttons = param.buttons, additionalBottomPadding = param.additionalBottomPadding;
    var getThemeColors = function() {
        if (theme === "green") {
            return {
                bgColor: "green400",
                textColor: "realWhite",
                buttonColor: "darkGreen",
                iconColor: "green700"
            };
        }
        if (theme === "darkGreen") {
            return {
                bgColor: "green700",
                textColor: "realWhite",
                buttonColor: "green",
                iconColor: "green400"
            };
        }
        if (theme === "blue") {
            return {
                bgColor: "blue400",
                textColor: "realWhite",
                buttonColor: "blue",
                iconColor: "blue700"
            };
        }
        return {
            bgColor: "transparent",
            textColor: "black",
            buttonColor: "green",
            iconColor: "grey700"
        };
    };
    var ref = getThemeColors(), bgColor = ref.bgColor, textColor = ref.textColor, buttonColor = ref.buttonColor, iconColor = ref.iconColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        color: bgColor,
        segmentType: "textCta",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 4,
                children: [
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: [
                            icon === "goGrid" && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoGridIcon, {}),
                            icon === "houseInHand" && /*#__PURE__*/ (0,jsx_runtime.jsx)(brixel_HouseInHand, {
                                color: iconColor
                            }),
                            icon === "magnifyingGlass" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MagnifyingGlass, {
                                color: iconColor
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Background/* default */.Z, {
                        $textColor: textColor,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                            title: title,
                            subtitle: subtitle,
                            size: "hero"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonGroup, {
                        buttons: buttons.map(function(b) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, b), {
                                color: buttonColor,
                                postIcon: b.primary && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {})
                            });
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var pageSegments_TextCtaSegment = (TextCtaSegment);

;// CONCATENATED MODULE: ./components/experts/Expert.tsx

function Expert_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n\n  h4 {\n    margin: 0;\n    ",
        ";\n    font-size: ",
        ";\n  }\n"
    ]);
    Expert_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Expert_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: relative;\n  width: 150px;\n  height: 150px;\n  border-radius: 100%;\n  margin-bottom: calc( 3 * var( --stack-basis ) );\n"
    ]);
    Expert_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



function Expert(param) {
    var expert = param.expert;
    var image = expert.mainImage[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledExpert, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Expert_StyledImage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                    src: image.url,
                    alt: image.alt,
                    dateModified: image.dateModified,
                    layout: "fill",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: expert.title
            })
        ]
    });
}
var StyledExpert = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1cf4cf2-0"
})(Expert_templateObject(), function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.normal;
});
var Expert_StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1cf4cf2-1"
})(Expert_templateObject1());
/* harmony default export */ var experts_Expert = (Expert);

;// CONCATENATED MODULE: ./components/experts/Experts.tsx

function Experts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: calc( 2 * var( --grid-gutter ) );\n\n  > * {\n    max-width: 305px;\n    flex: 0 0;\n  }\n"
    ]);
    Experts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function Experts(param) {
    var experts = param.experts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExperts, {
        children: experts.map(function(expert) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(experts_Expert, {
                expert: expert
            }, expert.id);
        })
    });
}
var StyledExperts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35aa6eb0-0"
})(Experts_templateObject());
/* harmony default export */ var experts_Experts = (Experts);

;// CONCATENATED MODULE: ./components/pageSegments/ExpertsSegment.tsx






function ExpertsSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, experts = param.experts, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        color: "green100",
        segmentType: "experts",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(experts_Experts, {
                        experts: experts
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var pageSegments_ExpertsSegment = (ExpertsSegment);

// EXTERNAL MODULE: ./components/contact/ContactCard.tsx
var ContactCard = __webpack_require__(4921);
;// CONCATENATED MODULE: ./components/contact/ContactCards.tsx

function ContactCards_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  gap: calc( 2 * var( --grid-gutter ) );\n\n  > * {\n    max-width: 305px;\n    min-width: min( 250px, 100% );\n    flex: 0 0 25%;\n  }\n"
    ]);
    ContactCards_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function ContactCards(param) {
    var contactCards = param.contactCards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContactCards, {
        children: contactCards.map(function(contactCard) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactCard/* default */.Z, {
                contactCard: contactCard
            }, contactCard.id);
        })
    });
}
var StyledContactCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e967e702-0"
})(ContactCards_templateObject());
/* harmony default export */ var contact_ContactCards = (ContactCards);

;// CONCATENATED MODULE: ./components/pageSegments/ContactSegment.tsx






function ContactSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, contactCards = param.contactCards, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        color: "green200",
        segmentType: "contact",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_ContactCards, {
                        contactCards: contactCards
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var pageSegments_ContactSegment = (ContactSegment);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
;// CONCATENATED MODULE: ./hooks/useWindowResize.tsx


var useWindowResize = function() {
    var handler = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], onLoad = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    (0,react.useEffect)(function() {
        if (true) {
            window.addEventListener("resize", handler);
            if (onLoad) {
                handler();
            }
            return function() {
                return window.removeEventListener("resize", handler);
            };
        }
    }, [
        onLoad
    ].concat((0,_to_consumable_array/* default */.Z)(deps)));
};
/* harmony default export */ var hooks_useWindowResize = (useWindowResize);

;// CONCATENATED MODULE: ./components/logos/Logo.tsx

function Logo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 80%;\n  margin-top: auto;\n  aspect-ratio: 1.6/1;\n"
    ]);
    Logo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Logo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-right: 1px solid ",
        ";\n  "
    ]);
    Logo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Logo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-sizing: border-box;\n  width: 235px;\n  padding: var( --grid-gutter );\n  \n  ",
        "\n\n  a {\n    display: block;\n  }\n\n  h5 {\n    margin: 0 0 var( --stack-basis );\n    text-align: center;\n    ",
        ";\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    Logo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





function Logo(param) {
    var label = param.label, image = param.image, href = param.href, hasBorder = param.hasBorder, setPosition = param.setPosition;
    var ref = (0,react.useRef)(null);
    hooks_useWindowResize(function() {
        if (ref.current) {
            setPosition(ref.current.offsetTop);
        }
    }, [], true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLogo, {
        ref: ref,
        $hasBorder: hasBorder,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLink, {
                href: href,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                    src: image.url,
                    alt: image.alt,
                    dateModified: image.dateModified,
                    layout: "fill",
                    objectFit: "contain"
                })
            })
        ]
    });
}
function LogoLink(param) {
    var href = param.href, children = param.children;
    if (href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo_StyledImage, {
            as: "a",
            href: href,
            target: "_blank",
            rel: "noopener",
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo_StyledImage, {
        children: children
    });
}
var Logo_StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-78b55a08-0"
})(Logo_templateObject());
var StyledLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-78b55a08-1"
})(Logo_templateObject2(), function(p) {
    return p.$hasBorder && (0,styled_components_browser_esm/* css */.iv)(Logo_templateObject1(), p.theme.colors.grey300);
}, function(p) {
    return p.theme.typo.regular;
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.theme.colors.grey400;
});
/* harmony default export */ var logos_Logo = (Logo);

;// CONCATENATED MODULE: ./components/logos/Logos.tsx


function Logos_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n"
    ]);
    Logos_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function Logos(param) {
    var logos = param.logos;
    var ref = (0,react.useState)(logos.map(function(l) {
        return {
            id: l.id,
            offsetTop: null
        };
    })), positions = ref[0], setPositions = ref[1];
    var setPosition = function(logoId) {
        return function(offsetTop) {
            setPositions(function(s) {
                var i = s.findIndex(function(p) {
                    return p.id === logoId;
                });
                var newPositions = (0,_to_consumable_array/* default */.Z)(s);
                newPositions[i].offsetTop = offsetTop;
                return newPositions;
            });
        };
    };
    var hasBorder = function(logoIndex) {
        var ref;
        if (((ref = positions[logoIndex + 1]) === null || ref === void 0 ? void 0 : ref.offsetTop) === positions[logoIndex].offsetTop) {
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogos, {
        children: logos.map(function(logo, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(logos_Logo, {
                label: logo.label,
                image: logo.logo[0],
                href: logo.logoLink,
                hasBorder: hasBorder(i),
                setPosition: setPosition(logo.id)
            }, logo.id);
        })
    });
}
var StyledLogos = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4fb7f7b4-0"
})(Logos_templateObject());
/* harmony default export */ var logos_Logos = (Logos);

;// CONCATENATED MODULE: ./components/pageSegments/LogosSegment.tsx






function LogosSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, logos = param.logos, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        segmentType: "logos",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: title || subtitle ? 12 : 0,
                $bottom: 12,
                $between: title || subtitle ? 7 : 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(logos_Logos, {
                        logos: logos
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var pageSegments_LogosSegment = (LogosSegment);

// EXTERNAL MODULE: ./components/postcards/Postcard.tsx
var Postcard = __webpack_require__(9895);
;// CONCATENATED MODULE: ./components/postcards/Postcards.tsx

function Postcards_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: var( --stack-basis );\n"
    ]);
    Postcards_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function Postcards(param) {
    var postcards = param.postcards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostcards, {
        children: postcards.map(function(card, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Postcard/* default */.Z, {
                layout: i % 2 ? "image-left" : "image-right",
                number: card.number,
                tag: card.tag,
                heading: card.heading,
                bodyText: card.bodyText,
                image: card.image[0],
                cardColor: card.cardColor
            }, card.id);
        })
    });
}
var StyledPostcards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6b1c91b-0"
})(Postcards_templateObject());
/* harmony default export */ var postcards_Postcards = (Postcards);

;// CONCATENATED MODULE: ./components/pageSegments/PostcardsSegment.tsx






function PostardsSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, postcards = param.postcards, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        segmentType: "packageCards",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(postcards_Postcards, {
                        postcards: postcards
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var PostcardsSegment = (PostardsSegment);

;// CONCATENATED MODULE: ./components/largePostcards/LargePostcard.tsx

function LargePostcard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    LargePostcard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LargePostcard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n  "
    ]);
    LargePostcard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LargePostcard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n  "
    ]);
    LargePostcard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LargePostcard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n  "
    ]);
    LargePostcard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LargePostcard_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n  "
    ]);
    LargePostcard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function LargePostcard_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n  \n  ",
        "\n"
    ]);
    LargePostcard_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function LargePostcard_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: stretch;\n  min-height: 423px;\n  flex-direction: ",
        ";\n  gap: calc( 4 * var( --stack-basis ) );\n  padding: calc( 8 * var( --stack-basis ) ) 0;\n\n  /* @media ( max-width: 900px ) {\n    padding: calc( 4 * var( --stack-basis ) ) 0;\n  }\n  \n  @media ( max-width: 600px ) {\n    padding: calc( 3 * var( --stack-basis ) ) 0;\n  } */\n"
    ]);
    LargePostcard_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function LargePostcard_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  box-sizing: border-box;\n  flex: 1 1 50%;\n  min-width: 250px;\n  max-width: 450px;\n\n  &:first-child {\n    h3 {\n      ",
        "\n      font-size: ",
        ";\n      line-height: 1.2;\n      margin: 0 0 calc( 4 * var( --stack-basis ) ) 0;\n      ",
        "\n    }\n\n    h4 {\n      margin: calc( 3 * var( --stack-basis ) ) 0 var( --stack-basis );\n      font-size: ",
        ";\n    }\n\n    p {\n      margin: 0 0 calc( 3 * var( --stack-basis ) ) 0;\n      font-size: ",
        ";\n\n      &:first-child {\n        margin-top: 0;\n      }\n      \n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    a {\n      ",
        "\n    }\n  }\n"
    ]);
    LargePostcard_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function LargePostcard_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex: 1 1 50%;\n  max-width: 600px;\n  min-width: 250px;\n  min-height: 250px\n"
    ]);
    LargePostcard_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





function LargePostcard(param) {
    var heading = param.heading, bodyText = param.bodyText, image = param.image, cardColor = param.cardColor, layout = param.layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostcardBackground, {
        $color: cardColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPostcard, {
                $layout: layout,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPostcardText, {
                        $color: cardColor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: heading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML: {
                                    __html: bodyText
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostcardImage, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                            src: image.url,
                            alt: image.alt,
                            dateModified: image.dateModified,
                            layout: "fill",
                            objectFit: "contain"
                        })
                    })
                ]
            })
        })
    });
}
var textLinkColorMap = {
    blue: "blue400",
    grey: "grey700",
    green: "green400",
    red: "red400"
};
var coloredTextLink = function(theme, cardColor) {
    return (0,links/* textLink */.k)(theme, textLinkColorMap[cardColor]);
};
var headingColorMap = {
    blue: "blue700",
    grey: "grey700",
    green: "green700",
    red: "red700"
};
var coloredHeading = function(theme, color) {
    return (0,styled_components_browser_esm/* css */.iv)(LargePostcard_templateObject(), theme.getColor(headingColorMap[color]));
};
var StyledPostcardBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8d800d7a-0"
})(LargePostcard_templateObject5(), function(p) {
    return p.$color === "grey" && (0,styled_components_browser_esm/* css */.iv)(LargePostcard_templateObject1(), p.theme.colors.grey100);
}, function(p) {
    return p.$color === "blue" && (0,styled_components_browser_esm/* css */.iv)(LargePostcard_templateObject2(), p.theme.colors.blue100);
}, function(p) {
    return p.$color === "green" && (0,styled_components_browser_esm/* css */.iv)(LargePostcard_templateObject3(), p.theme.colors.green100);
}, function(p) {
    return p.$color === "red" && (0,styled_components_browser_esm/* css */.iv)(LargePostcard_templateObject4(), p.theme.colors.red100);
});
var StyledPostcard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8d800d7a-1"
})(LargePostcard_templateObject6(), function(p) {
    return p.$layout === "image-right" ? "row" : "row-reverse";
});
var StyledPostcardText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8d800d7a-2"
})(LargePostcard_templateObject7(), function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return coloredHeading(p.theme, p.$color);
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return coloredTextLink(p.theme, p.$color);
});
var StyledPostcardImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8d800d7a-3"
})(LargePostcard_templateObject8());
/* harmony default export */ var largePostcards_LargePostcard = (LargePostcard);

;// CONCATENATED MODULE: ./components/largePostcards/LargePostcards.tsx

function LargePostcards_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    LargePostcards_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function LargePostcards(param) {
    var postcards = param.postcards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLargePostcards, {
        children: postcards.map(function(card, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(largePostcards_LargePostcard, {
                layout: i % 2 ? "image-left" : "image-right",
                heading: card.heading,
                bodyText: card.bodyText,
                image: card.image[0],
                cardColor: card.cardColor
            }, card.id);
        })
    });
}
var StyledLargePostcards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3855f788-0"
})(LargePostcards_templateObject());
/* harmony default export */ var largePostcards_LargePostcards = (LargePostcards);

;// CONCATENATED MODULE: ./components/pageSegments/LargePostcardsSegment.tsx






function LargePostardsSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, postcards = param.postcards, additionalBottomPadding = param.additionalBottomPadding, headingBackgroundColor = param.headingBackgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        segmentType: "largePostcards",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        color: getBGColor(headingBackgroundColor, postcards),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
            $top: 12,
            $between: 10,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(largePostcards_LargePostcards, {
                    postcards: postcards
                })
            ]
        })
    });
}
function getBGColor(headingBackgroundColor, cards) {
    if (headingBackgroundColor === "matchFirstCard") {
        return "".concat(cards[0].cardColor, "100");
    }
    if (headingBackgroundColor === "white") {
        return "white";
    }
    return "ivory";
}
/* harmony default export */ var LargePostcardsSegment = (LargePostardsSegment);

;// CONCATENATED MODULE: ./components/icons/LongArrowIcon.tsx

function LongArrowIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "31",
        height: "9",
        viewBox: "0 0 31 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M30.3536 4.7764C30.5488 4.58114 30.5488 4.26456 30.3536 4.0693L27.1716 0.887318C26.9763 0.692055 26.6597 0.692055 26.4645 0.887318C26.2692 1.08258 26.2692 1.39916 26.4645 1.59442L29.2929 4.42285L26.4645 7.25128C26.2692 7.44654 26.2692 7.76312 26.4645 7.95839C26.6597 8.15365 26.9763 8.15365 27.1716 7.95839L30.3536 4.7764ZM0 4.92285H30V3.92285H0V4.92285Z",
            fill: "#A2A9AD"
        })
    });
}
/* harmony default export */ var icons_LongArrowIcon = (LongArrowIcon);

;// CONCATENATED MODULE: ./components/processSteps/ProcessStep.tsx

function ProcessStep_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        font-weight: 600;\n      "
    ]);
    ProcessStep_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProcessStep_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: stretch;\n  gap: 1rem;\n  \n  > div {\n    display: flex;\n    flex-direction: column;\n    width: max( 250px, min( 22vw, 320px ) );\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: var( --card-border-radius );\n    overflow: hidden;\n    text-align: center;\n\n    h3,\n    p {\n      margin: 0;\n    }\n\n    h3 {\n      flex-grow: 1;\n      padding: calc( 3 * var( --stack-basis ) ) 1rem;\n      ",
        ";\n      font-size: ",
        ";\n\n      ",
        "\n    }\n\n    p {\n      padding: calc( 2 * var( --stack-basis ) ) 1rem;\n      background: ",
        ";\n      color: ",
        ";\n      ",
        ";\n      font-size: ",
        ";\n    }\n  }\n\n  > svg {\n    align-self: center;\n  }\n\n  @media ( max-width: ",
        " ) {\n    flex-direction: column;\n    width: 100%;\n    max-width: 300px;\n\n    > div {\n      width: 100%;\n    }\n\n    > svg {\n      transform: rotate( 90deg );\n    }\n  }\n"
    ]);
    ProcessStep_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



function ProcessStep(param) {
    var text1 = param.text1, text2 = param.text2, color = param.color, highlight = param.highlight, breakpoint = param.breakpoint;
    var colors = {
        green: "green400",
        blue: "blue400",
        lightBlue: "blue300"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProcessStep, {
        $color: colors[color],
        $highlight: highlight,
        $breakpoint: breakpoint,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    text1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: text1
                    }),
                    text2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: text2
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_LongArrowIcon, {})
        ]
    });
}
var StyledProcessStep = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-bc76320d-0"
})(ProcessStep_templateObject1(), function(p) {
    return p.theme.colors.realWhite;
}, function(p) {
    return p.theme.getColor(p.$color);
}, function(p) {
    return p.theme.typo.regular;
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.$highlight && (0,styled_components_browser_esm/* css */.iv)(ProcessStep_templateObject());
}, function(p) {
    return p.theme.getColor(p.$color);
}, function(p) {
    return p.theme.colors.realWhite;
}, function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return p.$breakpoint;
});
/* harmony default export */ var processSteps_ProcessStep = (ProcessStep);

;// CONCATENATED MODULE: ./components/processSteps/ProcessSteps.tsx

function ProcessSteps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin: 0;\n  padding: 0;\n\n  > *:last-child svg {\n    display: none;\n  }\n\n  @media ( max-width: ",
        " ) {\n    flex-direction: column;\n  }\n"
    ]);
    ProcessSteps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var breakpoint = "980px";
function ProcessSteps(param) {
    var processSteps = param.processSteps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProcessSteps, {
            children: processSteps.map(function(step) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(processSteps_ProcessStep, {
                    text1: step.text1,
                    text2: step.text2,
                    color: step.color,
                    highlight: step.highlight,
                    breakpoint: breakpoint
                }, step.id);
            })
        })
    });
}
var StyledProcessSteps = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    componentId: "sc-510a0aff-0"
})(ProcessSteps_templateObject(), breakpoint);
/* harmony default export */ var processSteps_ProcessSteps = (ProcessSteps);

;// CONCATENATED MODULE: ./components/pageSegments/ProcessStepsSegment.tsx







function ProcessStepsSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, bodyText = param.bodyText, processSteps = param.processSteps, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        color: "ivory",
        segmentType: "processSteps",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(processSteps_ProcessSteps, {
                        processSteps: processSteps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_PageSegmentBodyText, {
                        html: bodyText,
                        bodyStyle: "small"
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var pageSegments_ProcessStepsSegment = (ProcessStepsSegment);

// EXTERNAL MODULE: ./lib/craft/index.tsx + 31 modules
var craft = __webpack_require__(8767);
// EXTERNAL MODULE: ./components/BrixelLogo.tsx
var BrixelLogo = __webpack_require__(2290);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./hooks/useModalTraits.tsx + 3 modules
var useModalTraits = __webpack_require__(3974);
// EXTERNAL MODULE: ./components/icons/ChevronIcon.tsx
var ChevronIcon = __webpack_require__(7011);
;// CONCATENATED MODULE: ./components/LanguageSwitcher.tsx

function LanguageSwitcher_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    LanguageSwitcher_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LanguageSwitcher_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: 1;\n    pointer-events: all;\n  "
    ]);
    LanguageSwitcher_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LanguageSwitcher_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  top: 3rem;\n  min-width: 100%;\n  margin-bottom: 2rem;\n  border-radius: var( --card-border-radius );;\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.12);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity .3s ease-out;\n\n  ",
        "\n"
    ]);
    LanguageSwitcher_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LanguageSwitcher_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  a,\n  button {\n    display: block;\n    width: 100%;\n    padding: 10px 12px;\n    border: 0;\n    background: ",
        ";\n    font-size: ",
        ";\n    text-align: left;\n    text-decoration: none;\n    color: inherit;\n    transition: background .3s ease-out;\n\n    &:hover {\n      background: ",
        ";\n    }\n  }\n"
    ]);
    LanguageSwitcher_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var localeMap = {
    de: "Deutsch",
    en: "English",
    fr: "Fran\xe7ais",
    it: "Italiano",
    pt: "Portugu\xeas"
};
var activeLocales = [
    "de",
    "fr",
    "en",
    "it"
];
function LanguageSwitcher() {
    var containerRef = (0,react.useRef)();
    var ref = (0,next_router.useRouter)(), locale = ref.locale, pathname = ref.pathname, asPath = ref.asPath, query = ref.query, push = ref.push;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var toggleSwitcher = function() {
        return setIsOpen(function(s) {
            return !s;
        });
    };
    var switchLocale = function(newLocale) {
        setIsOpen(false);
        if (newLocale !== locale) {
            push({
                pathname: pathname,
                query: query
            }, asPath, {
                locale: newLocale
            });
        }
    };
    (0,useModalTraits/* default */.Z)({
        isOpen: isOpen,
        containerRef: containerRef,
        close: function() {
            return setIsOpen(false);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLanguageSwitcher, {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.ZP, {
                outline: true,
                color: "green",
                onClick: toggleSwitcher,
                children: [
                    localeMap[locale],
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronIcon/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDropdown, {
                $isOpen: isOpen,
                children: activeLocales.map(function(l) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDropdownItem, {
                        $isActive: l === locale,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: function() {
                                return switchLocale(l);
                            },
                            children: localeMap[l]
                        })
                    }, l);
                })
            })
        ]
    });
}
var StyledLanguageSwitcher = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8e22827e-0"
})(LanguageSwitcher_templateObject());
var StyledDropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8e22827e-1"
})(LanguageSwitcher_templateObject2(), function(p) {
    return p.$isOpen && (0,styled_components_browser_esm/* css */.iv)(LanguageSwitcher_templateObject1());
});
var StyledDropdownItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8e22827e-2"
})(LanguageSwitcher_templateObject3(), function(p) {
    return p.theme.colors.realWhite;
}, function(p) {
    return p.theme.typo.sizes.small;
}, function(p) {
    return p.theme.colors.green100;
});
/* harmony default export */ var components_LanguageSwitcher = (LanguageSwitcher);

;// CONCATENATED MODULE: ./components/CompanyFooter.tsx

function CompanyFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n"
    ]);
    CompanyFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyFooter_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  \n  margin: var( --grid-gutter-offset );\n\n  > * {\n    margin: var( --grid-gutter-item );\n  }\n\n  @media ( min-width: 900px ) {\n    grid-template-columns: 4fr 4fr 4fr 3fr;\n  }\n\n  @media ( min-width: 1200px ) {\n    grid-template-columns: 7fr 3fr 3fr 2fr;\n  }\n\n  @media ( min-width: 1400px ) {\n    grid-template-columns: 9fr 2fr 2fr 2fr;\n  }\n"
    ]);
    CompanyFooter_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyFooter_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  > *:first-child {\n    margin-bottom: auto;\n  }\n"
    ]);
    CompanyFooter_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyFooter_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100px;\n  \n  svg {\n    max-width: 100%;\n  }\n"
    ]);
    CompanyFooter_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanyFooter_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    CompanyFooter_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CompanyFooter_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h4 {\n    font-weight: 600;\n    margin: 0;\n  }\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    CompanyFooter_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CompanyFooter_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > * {\n    &:first-child {\n      margin-top: 0;\n    }\n    \n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  a {\n    ",
        "\n  }\n"
    ]);
    CompanyFooter_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}










function CompanyFooter(param) {
    var _showLanguageSwitcher = param.showLanguageSwitcher, showLanguageSwitcher = _showLanguageSwitcher === void 0 ? true : _showLanguageSwitcher, bodyText = param.bodyText, anchorId = param.anchorId;
    var ref, ref1, ref2, ref3;
    var craftData = (0,craft/* useCraft */.Yi)();
    var companyTitle = craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.companyInfo) === null || ref1 === void 0 ? void 0 : ref1.companyTitle;
    var companyAddress = craftData === null || craftData === void 0 ? void 0 : (ref2 = craftData.pageProps) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.companyInfo) === null || ref3 === void 0 ? void 0 : ref3.companyAddress;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCompanyFooter, {
        id: anchorId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyFooter_StyledGrid, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLogoCopyright, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFooter_StyledLogo, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://brixel.ch",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrixelLogo/* default */.Z, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCopyright, {
                                    children: [
                                        "\xa9 2016-",
                                        new Date().getFullYear(),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            description: "All rights reserved",
                                            defaultMessage: "All rights reserved",
                                            id: "8o9EVS"
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        }),
                        (companyTitle || companyAddress) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCompanyInfo, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: companyTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML: {
                                        __html: companyAddress
                                    }
                                })
                            ]
                        }),
                        bodyText && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBodyText, {
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML: {
                                __html: bodyText
                            }
                        }),
                        showLanguageSwitcher && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LanguageSwitcher, {})
                        })
                    ]
                })
            })
        })
    });
}
var StyledCompanyFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f33de5a3-0"
})(CompanyFooter_templateObject(), function(p) {
    return p.theme.colors.grey300;
});
var CompanyFooter_StyledGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f33de5a3-1"
})(CompanyFooter_templateObject1());
var StyledLogoCopyright = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f33de5a3-2"
})(CompanyFooter_templateObject2());
var CompanyFooter_StyledLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f33de5a3-3"
})(CompanyFooter_templateObject3());
var StyledCopyright = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f33de5a3-4"
})(CompanyFooter_templateObject4(), function(p) {
    return p.theme.colors.grey400;
});
var StyledCompanyInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f33de5a3-5"
})(CompanyFooter_templateObject5());
var StyledBodyText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f33de5a3-6"
})(CompanyFooter_templateObject6(), function(p) {
    return (0,links/* textLink */.k)(p.theme);
});
/* harmony default export */ var components_CompanyFooter = (CompanyFooter);

// EXTERNAL MODULE: ./components/cards/Card.tsx
var Card = __webpack_require__(8390);
;// CONCATENATED MODULE: ./components/cards/Cards.tsx

function Cards_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: var( --grid-gutter-offset );\n\n  > * {\n    margin: var( --grid-gutter-item );\n  }\n"
    ]);
    Cards_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function Cards(param) {
    var alignment = param.alignment, cards = param.cards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardsGrid, {
        children: cards.map(function(card) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.ZP, {
                alignment: alignment,
                card: card
            }, card.id);
        })
    });
}
var StyledCardsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65e5429a-0"
})(Cards_templateObject());
/* harmony default export */ var cards_Cards = (Cards);

;// CONCATENATED MODULE: ./components/pageSegments/CardsSegment.tsx






function CardsSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, alignment = param.alignment, mainImage = param.mainImage, cards = param.cards, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        segmentType: "cards",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        color: "ivory",
        image: mainImage === null || mainImage === void 0 ? void 0 : mainImage[0],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_Cards, {
                        alignment: alignment,
                        cards: cards
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var pageSegments_CardsSegment = (CardsSegment);

;// CONCATENATED MODULE: ./components/MaxAreaImage.tsx

function MaxAreaImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  max-width: 100%;\n  max-height: 100%;\n"
    ]);
    MaxAreaImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function MaxAreaImage(param) {
    var src = param.src, alt = param.alt, width = param.width, height = param.height, maxArea = param.maxArea, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? null : _maxWidth, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? null : _maxHeight, _dateModified = param.dateModified, dateModified = _dateModified === void 0 ? null : _dateModified;
    var aspectRatio = height / width;
    var calculatedMaxWidth = maxWidth ? Math.min(Math.sqrt(maxArea / aspectRatio), maxWidth) : Math.sqrt(maxArea / aspectRatio);
    var calculatedMaxHeight = maxHeight ? Math.min(calculatedMaxWidth * aspectRatio, maxHeight) : calculatedMaxWidth * aspectRatio;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMaxAreaImage, {
        $maxWidth: Math.floor(calculatedMaxWidth),
        $maxHeight: Math.floor(calculatedMaxHeight),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
            src: src,
            alt: alt,
            width: width,
            height: height,
            dateModified: dateModified
        })
    });
}
var StyledMaxAreaImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52bb1919-0"
})(MaxAreaImage_templateObject(), function(p) {
    return p.$maxWidth;
}, function(p) {
    return p.$maxHeight;
});
/* harmony default export */ var components_MaxAreaImage = (MaxAreaImage);

;// CONCATENATED MODULE: ./components/LogoGrid.tsx

function LogoGrid_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: calc( 2 * var( --grid-gutter ) );\n"
    ]);
    LogoGrid_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LogoGrid_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 130px;\n"
    ]);
    LogoGrid_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LogoGrid_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  \n"
    ]);
    LogoGrid_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




function LogoGrid(param) {
    var linkedLogos = param.linkedLogos;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogoGrid, {
        children: linkedLogos.map(function(logo) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoGrid_Logo, {
                url: logo.logoLink,
                image: logo.logoImage[0]
            }, logo.id);
        })
    });
}
function LogoGrid_Logo(param) {
    var image = param.image, url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoGrid_StyledLogo, {
        children: [
            url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: url,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoImage, {
                    image: image
                })
            }),
            !url && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoImage, {
                image: image
            })
        ]
    });
}
function LogoImage(param) {
    var image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogoImage, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MaxAreaImage, {
            maxArea: 5000,
            src: image.url,
            alt: image.alt,
            width: image.width,
            height: image.height,
            dateModified: image.dateModified
        })
    });
}
var StyledLogoGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a3e2b10-0"
})(LogoGrid_templateObject());
var LogoGrid_StyledLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a3e2b10-1"
})(LogoGrid_templateObject1());
var StyledLogoImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a3e2b10-2"
})(LogoGrid_templateObject2());
/* harmony default export */ var components_LogoGrid = (LogoGrid);

;// CONCATENATED MODULE: ./components/pageSegments/LogoGridSegment.tsx






function LogoGridSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, linkedLogos = param.linkedLogos, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        color: "ivory",
        segmentType: "logoGrid",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LogoGrid, {
                        linkedLogos: linkedLogos
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var pageSegments_LogoGridSegment = (LogoGridSegment);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./hooks/useMediaQuery.ts

function getMatches(query) {
    // Prevents SSR issues
    if (true) {
        return window.matchMedia(query).matches;
    }
    return false;
}
function useMediaQuery(query) {
    var ref = (0,react.useState)(getMatches(query)), matches = ref[0], setMatches = ref[1];
    (0,react.useEffect)(function() {
        var matchMedia = window.matchMedia(query);
        var handleChange = function() {
            setMatches(getMatches(query));
        };
        handleChange();
        matchMedia.addEventListener("change", handleChange);
        return function() {
            matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/swr/infinite/dist/index.mjs
var infinite_dist = __webpack_require__(4593);
;// CONCATENATED MODULE: ./hubApi/useHubAPIRequest.ts


function fetcher(key) {
    return fetch(key).then(function(r) {
        return r.json();
    });
}
function useHubAPIRequest(key) {
    return (0,dist/* default */.ZP)(key, fetcher);
}
function useHubAPIRequestInfinite(key) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0,infinite_dist/* default */.ZP)(key, fetcher, options);
}

;// CONCATENATED MODULE: ./components/icons/ClockIcon.tsx


function ClockIcon(param) {
    var _color = param.color, color = _color === void 0 ? "green400" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "17",
        viewBox: "0 0 18 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.16191 0.166504C4.56191 0.166504 0.836914 3.89984 0.836914 8.49984C0.836914 13.0998 4.56191 16.8332 9.16191 16.8332C13.7702 16.8332 17.5036 13.0998 17.5036 8.49984C17.5036 3.89984 13.7702 0.166504 9.16191 0.166504ZM9.17025 15.1665C5.48691 15.1665 2.50358 12.1832 2.50358 8.49984C2.50358 4.8165 5.48691 1.83317 9.17025 1.83317C12.8536 1.83317 15.8369 4.8165 15.8369 8.49984C15.8369 12.1832 12.8536 15.1665 9.17025 15.1665ZM9.58691 4.33317H8.33691V9.33317L12.7119 11.9582L13.3369 10.9332L9.58691 8.70817V4.33317Z",
            fill: (0,colors/* getColor */.L)(color)
        })
    });
}

;// CONCATENATED MODULE: ./components/propertyListings/DaysLeftTag.tsx

function DaysLeftTag_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: calc( 2 * var( --stack-basis ) );\n  left: calc( 2 * var( --stack-basis ) );\n  padding: 0.5rem 1rem 0.5rem 0.5rem;\n  display: flex;\n  gap: 0.5em;\n  align-items: center;\n  border-radius: var( --card-border-radius );\n  font-size: ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n"
    ]);
    DaysLeftTag_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function DaysLeftTag(param) {
    var countdownInDays = param.countdownInDays;
    var daysRemaining = Math.max(countdownInDays, 0);
    var daysRemainingTagColor = daysRemaining <= 3 ? "red" : "green";
    if (!daysRemaining) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDaysLeftTag, {
        $color: daysRemainingTagColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClockIcon, {
                color: "".concat(daysRemainingTagColor, "400")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                description: "[x] days left",
                defaultMessage: "{ daysRemaining } {daysRemaining, plural, one {day left} other {days left} }",
                values: {
                    daysRemaining: daysRemaining
                },
                id: "wNgL3D"
            })
        ]
    });
}
var StyledDaysLeftTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-96cd7302-0"
})(DaysLeftTag_templateObject(), function(p) {
    return p.theme.typo.sizes.small;
}, function(p) {
    return p.theme.colors["".concat(p.$color, "100")];
}, function(p) {
    return p.theme.colors["".concat(p.$color, "400")];
});

;// CONCATENATED MODULE: ./components/propertyListings/propertyPriceFormatter.ts
function propertyPriceFormatter(currency) {
    return new Intl.NumberFormat("de-CH", {
        style: "currency",
        currency: currency || "CHF",
        currencyDisplay: "symbol",
        maximumFractionDigits: 0
    });
}

;// CONCATENATED MODULE: ./components/propertyListings/PropertyPriceByStatus.tsx



function PropertyPriceByStatus(param) {
    var property = param.property;
    if ([
        "ON_SALE",
        "TO_RENT"
    ].includes(property.status)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !property.price && "—",
                property.price && propertyPriceFormatter(property.price.currency).format(property.price.amount)
            ]
        });
    }
    if (property.status === "ON_REQUEST") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
            description: "Property status: On request",
            defaultMessage: "On request",
            id: "IX9egs"
        });
    }
    if (property.status === "SOLD") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
            description: "Property status: Sold",
            defaultMessage: "Sold",
            id: "GJDsYb"
        });
    }
    if (property.status === "RESERVED") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
            description: "Property status: Reserved",
            defaultMessage: "Reserved",
            id: "rU6OoX"
        });
    }
    return null;
}

;// CONCATENATED MODULE: ./components/propertyListings/PropertyCard.tsx

function PropertyCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  overflow: hidden;\n  border-radius: var( --card-border-radius );\n  background: white;\n\n  a {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    color: inherit;\n    text-decoration: none;\n  }\n"
    ]);
    PropertyCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PropertyCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  aspect-ratio: 368 / 187;\n"
    ]);
    PropertyCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PropertyCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  padding: calc( 3 * var( --stack-basis ) );\n\n  h3 {\n    margin: 0;\n    ",
        "\n    line-height: 1.2;\n    font-size: ",
        ";\n  }\n"
    ]);
    PropertyCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PropertyCard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  gap: calc( 3 * var( --stack-basis ) );\n"
    ]);
    PropertyCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PropertyCard_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  margin-top: auto;\n  padding: calc( 2 * var( --stack-basis ) ) 0;\n  font-size: ",
        ";\n  line-height: 1;\n  color: ",
        ";\n\n  > * {\n    margin: 0;\n    font-weight: 400;\n  }\n\n  p {\n    margin-top: var( --stack-basis );\n    ",
        "\n    font-size: ",
        ";\n\n    span {\n      margin-right: 0.3rem;\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    PropertyCard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PropertyCard_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  p {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    PropertyCard_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








function PropertyCard(param) {
    var property = param.property, showCountdown = param.showCountdown;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var locale = router.locale || router.defaultLocale || "de";
    var isBuildingLand = !((ref = property.livingArea) === null || ref === void 0 ? void 0 : ref.value) && !property.numberOfRooms && !property.constructionYear;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPropertyCard, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            href: property.brixelPageUrl || property.url || "https://page.brixel.io/".concat(locale, "/").concat(property.stub),
            target: "_blank",
            rel: "noopener",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PropertyCard_StyledImage, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                            src: property.coverImage,
                            alt: property.title,
                            dateModified: null,
                            layout: "fill",
                            objectFit: "cover",
                            sizes: " ( max-width: 750px ) 100vw, ( max-width: 1150px ) 50vw, ( max-width: 2000px ) 33vw, ( max-width: 2600px ) 25vw, 20vw "
                        }),
                        showCountdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(DaysLeftTag, {
                            countdownInDays: ((ref1 = property.companyExclusivity) === null || ref1 === void 0 ? void 0 : ref1.countdownInDays) || 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDetails, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: property.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPropertyPrice, {
                            $status: property.status,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyPriceByStatus, {
                                    property: property
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyDataList, {
                            property: property,
                            showItems: isBuildingLand ? [
                                "lotSize"
                            ] : [
                                "rooms",
                                "livingArea",
                                "constructionYear"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function PropertyDataList(param) {
    var property = param.property, _showItems = param.showItems, showItems = _showItems === void 0 ? [
        "rooms",
        "livingArea",
        "constructionYear"
    ] : _showItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPropertyDataList, {
        children: showItems.map(function(showItem) {
            switch(showItem){
                case "rooms":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPropertyDataItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                !property.numberOfRooms && "—",
                                property.numberOfRooms > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        property.numberOfRooms,
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            description: "Number of rooms label",
                                            defaultMessage: "Rooms",
                                            id: "V2MxOz"
                                        })
                                    ]
                                })
                            ]
                        })
                    });
                case "livingArea":
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPropertyDataItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: ((ref = property.livingArea) === null || ref === void 0 ? void 0 : ref.value) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    property.livingArea.value,
                                    " ",
                                    property.livingArea.unit || "m2"
                                ]
                            }) : "—"
                        })
                    });
                case "constructionYear":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPropertyDataItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: property.constructionYear || "—"
                        })
                    });
                case "lotSize":
                    var ref1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPropertyDataItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: ((ref1 = property.lotArea) === null || ref1 === void 0 ? void 0 : ref1.value) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    property.lotArea.value,
                                    " ",
                                    property.lotArea.unit || "m2"
                                ]
                            }) : "—"
                        })
                    });
                default:
                    return null;
            }
        })
    });
}
var StyledPropertyCard = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-47e7d45c-0"
})(PropertyCard_templateObject());
var PropertyCard_StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-47e7d45c-1"
})(PropertyCard_templateObject1());
var StyledDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-47e7d45c-2"
})(PropertyCard_templateObject2(), function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.large;
});
var StyledPropertyDataList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-47e7d45c-3"
})(PropertyCard_templateObject3());
var StyledPropertyDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-47e7d45c-4"
})(PropertyCard_templateObject4(), function(p) {
    return p.theme.typo.sizes.small;
}, function(p) {
    return p.theme.colors.grey600;
}, function(p) {
    return p.theme.typo.mono;
}, function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.theme.typo.sizes.small;
});
var statusToColorMap = {
    ON_REQUEST: "grey700",
    SOLD: "red400",
    RESERVED: "yellow400",
    ON_SALE: "green400",
    TO_RENT: "blue400"
};
var StyledPropertyPrice = (0,styled_components_browser_esm/* default */.ZP)(StyledPropertyDataItem).withConfig({
    componentId: "sc-47e7d45c-5"
})(PropertyCard_templateObject5(), function(p) {
    return p.theme.grey400;
}, function(p) {
    return p.theme.colors.grey200;
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.theme.getColor(statusToColorMap[p.$status]);
});

;// CONCATENATED MODULE: ./components/propertyListingsLarge/PropertyListingLargeCard.tsx

function PropertyListingLargeCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  border-radius: var( --card-border-radius );\n  background: white;\n  color: inherit;\n  text-decoration: none;\n\n  > * {\n    flex: 0 0 50%;\n  }\n\n  @media ( max-width: ",
        "px ) {\n    flex-direction: column;\n\n    > {\n      flex: 0 0 100%;\n\n      &:first-child {\n        min-height: 50vw;\n      }\n    }\n  }\n"
    ]);
    PropertyListingLargeCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PropertyListingLargeCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    PropertyListingLargeCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PropertyListingLargeCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  padding: calc( 3 * var( --stack-basis ) );\n\n  > p {\n    margin: 0;\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n\n  > h3 {\n    margin-top: 0;\n    margin-bottom: calc( 7 * var( --stack-basis ) );\n    ",
        ";\n    font-size: ",
        ";\n  }\n\n  ",
        " {\n    p {\n      font-size: ",
        ";\n    }\n    \n    &:last-child {\n      @media ( min-width: ",
        "px ) {\n        min-width: 120px;\n      }\n    }\n  }\n"
    ]);
    PropertyListingLargeCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var PropertyListingLargeCard_breakpoint = 600;
function PropertyListingLargeCard(param) {
    var property = param.property, _showCountdown = param.showCountdown, showCountdown = _showCountdown === void 0 ? true : _showCountdown;
    var ref;
    var router = (0,next_router.useRouter)();
    var locale = router.locale || router.defaultLocale || "de";
    var image = {
        url: property.coverImage,
        alt: property.title,
        dateModified: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPropertyListingLargeCard, {
        href: property.url || "https://page.brixel.io/".concat(locale, "/").concat(property.stub),
        target: "_blank",
        rel: "noopener",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPropertyImage, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                        src: image.url,
                        alt: image.alt,
                        layout: "fill",
                        objectFit: "cover",
                        sizes: "\n            ( max-width: ".concat(PropertyListingLargeCard_breakpoint, " ) 100vw,\n            ( max-width: 1500px ) 50vw,\n            750px\n          "),
                        dateModified: image.dateModified
                    }),
                    showCountdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(DaysLeftTag, {
                        countdownInDays: ((ref = property.companyExclusivity) === null || ref === void 0 ? void 0 : ref.countdownInDays) || 0
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPropertyDetails, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: property.location
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: property.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPropertyPrice, {
                        $status: property.status,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    description: "Price label",
                                    defaultMessage: "Price",
                                    id: "bURm/c"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyPriceByStatus, {
                                    property: property
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPropertyDataList, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPropertyDataItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            description: "Number of rooms label",
                                            defaultMessage: "Rooms",
                                            id: "V2MxOz"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: property.numberOfRooms
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPropertyDataItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            description: "Living area label",
                                            defaultMessage: "Living area",
                                            id: "wDKxsa"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            property.livingArea.value,
                                            " ",
                                            property.livingArea.unit || "m2"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPropertyDataItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            description: "Year built label",
                                            defaultMessage: "Year built",
                                            id: "tsDsIk"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: property.constructionYear
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var StyledPropertyListingLargeCard = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b1df5b3b-0"
})(PropertyListingLargeCard_templateObject(), PropertyListingLargeCard_breakpoint);
var StyledPropertyImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1df5b3b-1"
})(PropertyListingLargeCard_templateObject1());
var StyledPropertyDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1df5b3b-2"
})(PropertyListingLargeCard_templateObject2(), function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.theme.colors.grey700;
}, function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.veryLarge;
}, StyledPropertyDataItem, function(p) {
    return p.theme.typo.sizes.medium;
}, PropertyListingLargeCard_breakpoint + 1);

;// CONCATENATED MODULE: ./hooks/useSwipe.tsx

function findDirection(param) {
    var dx = param.dx, dy = param.dy, offset = param.offset;
    if (Math.abs(dx) > Math.abs(dy)) {
        if (dx > offset) {
            return "right";
        }
        if (dx < -offset) {
            return "left";
        }
    } else if (dy > offset) {
        return "down";
    } else if (dy < -offset) {
        return "up";
    }
    return null;
}
function useSwipe(param) {
    var _offset = param.offset, offset = _offset === void 0 ? 50 : _offset, _up = param.up, up = _up === void 0 ? null : _up, _down = param.down, down = _down === void 0 ? null : _down, _left = param.left, left = _left === void 0 ? null : _left, _right = param.right, right = _right === void 0 ? null : _right, _move = param.move, move = _move === void 0 ? null : _move;
    var hasActed = (0,react.useRef)(false);
    var touchStartX = (0,react.useRef)(null);
    var touchStartY = (0,react.useRef)(null);
    var dx = (0,react.useRef)(null);
    var dy = (0,react.useRef)(null);
    var onTouchStart = function(event) {
        touchStartX.current = event.touches[0].clientX;
        touchStartY.current = event.touches[0].clientY;
    };
    var onTouchMove = function(event) {
        dx.current = event.touches[0].clientX - touchStartX.current;
        dy.current = event.touches[0].clientY - touchStartY.current;
        handler(findDirection({
            dx: dx.current,
            dy: dy.current,
            offset: offset
        }));
        move === null || move === void 0 ? void 0 : move(dx.current, dy.current);
    };
    var handler = function(direction) {
        if (hasActed.current) {
            return;
        }
        if (direction === "up") {
            hasActed.current = true;
            up === null || up === void 0 ? void 0 : up(dy.current);
        } else if (direction === "down") {
            hasActed.current = true;
            down === null || down === void 0 ? void 0 : down(dy.current);
        } else if (direction === "left") {
            hasActed.current = true;
            left === null || left === void 0 ? void 0 : left(dx.current);
        } else if (direction === "right") {
            hasActed.current = true;
            right === null || right === void 0 ? void 0 : right(dx.current);
        }
    };
    var onTouchEnd = function() {
        reset();
    };
    var reset = function() {
        touchStartX.current = null;
        touchStartY.current = null;
        dx.current = null;
        dy.current = null;
        hasActed.current = false;
    };
    return {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
}

;// CONCATENATED MODULE: ./components/Carousel.tsx



function Carousel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 0;\n"
    ]);
    Carousel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Carousel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 2rem;\n  "
    ]);
    Carousel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Carousel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: var( --stack-basis );\n  margin-bottom: calc( 3 * var( --stack-basis ) );\n\n  ",
        "\n\n  button {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    span {\n      overflow: hidden;\n      width: 0;\n    }\n\n    svg {\n      width: 16px;\n      height: 16px;\n      \n      path {\n        fill: ",
        ";\n      }\n    }\n\n    &:first-child > svg{\n      transform: rotate( 90deg );\n    }\n      \n    &:last-child > svg {\n      transform: rotate( 270deg );\n    }\n  }\n"
    ]);
    Carousel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Carousel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --carousel-slides-gutter: calc( 3 * var( --stack-basis ) );\n  position: relative;\n  width: 100%;\n  display: flex;\n  overflow-x: visible;\n  gap: var( --carousel-slides-gutter );\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  left: calc(\n    ( 100% + var( --carousel-slides-gutter ) ) * ",
        "\n  );\n  transition: left 0.5s ease-in-out;\n\n  > li {\n    position: relative;\n    flex: 0 0 100%;\n    width: 100%;\n    display: flex;\n    transition: opacity 0.5s linear;\n\n    &:not( :nth-child( ",
        " ) ) {\n      opacity: 0.5;\n    }\n\n    > * {\n      width: 100%;\n    }\n  }\n"
    ]);
    Carousel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Carousel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  list-style: none;\n\n  button {\n    width: 8px;\n    height: 8px;\n    margin: 0;\n    padding: 0;\n    border-radius: 50%;\n    overflow: hidden;\n    text-indent: -999em;\n    border: none;\n    appearance: none;\n    background-color: ",
        ";\n    transition: background-color 0.4s ease;\n    &.is-current {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    Carousel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






function Carousel(param) {
    var children = param.children, _overlayControls = param.overlayControls, overlayControls = _overlayControls === void 0 ? false : _overlayControls, _dots = param.dots, dots = _dots === void 0 ? false : _dots;
    var slidesCount = children.length;
    var ref = (0,react.useState)(0), currentSlide = ref[0], setCurrentSlide = ref[1];
    var useSwipeProps = useSwipe({
        left: function() {
            return next();
        },
        right: function() {
            return previous();
        }
    });
    var previous = function() {
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        }
    };
    var next = function() {
        if (currentSlide < slidesCount - 1) {
            setCurrentSlide(currentSlide + 1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCarousel, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledControls, {
                $overlay: overlayControls,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        onClick: previous,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    defaultMessage: "Previous property",
                                    id: "ev8tkE",
                                    description: "Carousel control: Previous property"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronIcon/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        onClick: next,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    defaultMessage: "Next property",
                                    id: "HTUOPV",
                                    description: "Carousel control: Next property"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronIcon/* default */.Z, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSlider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                $currentSlide: currentSlide,
                $totalSlides: slidesCount
            }, useSwipeProps), {
                children: children
            })),
            dots && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDots, {
                children: new Array(slidesCount).fill(true).map(function(_, i) {
                    return(// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: i === currentSlide ? "is-current" : "",
                            onClick: function() {
                                return setCurrentSlide(i);
                            },
                            children: i
                        })
                    }, i));
                })
            })
        ]
    });
}
var StyledCarousel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-49667a45-0"
})(Carousel_templateObject());
var StyledControls = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-49667a45-1"
})(Carousel_templateObject2(), function(p) {
    return p.$overlay && (0,styled_components_browser_esm/* css */.iv)(Carousel_templateObject1());
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey300;
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey700;
});
var StyledSlider = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-49667a45-2"
})(Carousel_templateObject3(), function(param) {
    var $currentSlide = param.$currentSlide;
    return $currentSlide * -1;
}, function(param) {
    var $currentSlide = param.$currentSlide;
    return $currentSlide + 1;
});
var StyledDots = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    componentId: "sc-49667a45-3"
})(Carousel_templateObject4(), function(p) {
    return p.theme.colors.grey300;
}, function(p) {
    return p.theme.colors.green400;
});

;// CONCATENATED MODULE: ./components/icons/brixel/ParkScene.tsx

function ParkScene() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "430",
        height: "109",
        viewBox: "0 0 430 109",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M235.952 26.3875C234.469 23.1775 231.773 20.6431 228.451 19.3829C228.855 9.03462 237.362 0.769531 247.798 0.769531C258.491 0.769531 267.16 9.44829 267.16 20.1541C267.16 24.3812 265.809 28.2923 263.515 31.478C260.266 30.0411 257.083 30.3194 254.556 31.6692M235.952 26.3875C237.507 23.0369 240.894 20.7101 244.828 20.7101C249.147 20.7101 252.812 23.5052 254.118 27.3858C254.451 28.3731 254.6 31.2954 254.556 31.6692M235.952 26.3875C233.805 21.741 229.117 18.5103 223.667 18.5103C217.59 18.5103 212.449 22.5178 210.734 28.0356C210.338 29.3133 210.121 31.9996 210.124 32.0686C207.902 30.5004 205.026 30.2317 201.955 30.7726C200.356 31.0521 198.884 31.8616 197.807 33.0777C197.771 33.1176 197.735 33.1612 197.698 33.2011C194.431 36.9619 197.176 42.839 202.155 42.839H261.971C266.623 42.839 269.336 37.4556 266.457 33.8001C266.428 33.7602 266.395 33.7239 266.362 33.6839C265.608 32.7474 264.644 31.9814 263.545 31.4914C260.285 30.0393 257.091 30.3152 254.556 31.6692",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M140.479 94.661L147.264 81.0737H194.766L201.551 94.661",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M154.05 81.0736L160.836 67.4863",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M154.05 67.4863H208.337",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M157.445 74.2808H198.161",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M187.979 94.661L194.765 81.0736L201.551 67.4863",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M154.051 94.661L147.265 81.0737",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.24609 95.269H267.641",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M344 95L429 95",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M309 95H289",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M373.985 18.112C356.616 18.112 342.535 32.2087 342.535 49.5978C342.535 66.9869 356.616 81.0835 373.985 81.0835C391.354 81.0835 405.435 66.9869 405.435 49.5978C405.435 32.2087 391.354 18.112 373.985 18.112Z",
                fill: "#009877"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M373.491 36.9556V95.1081",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M386.398 43.7207L373.884 56.3398",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M360.563 56.4033L373.491 69.2615",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M328.719 80.8594C330.159 82.9175 332.04 84.6579 334.261 85.9431L341.935 90.3819L345.113 92.2171V92.2361L340.964 99.4349L339.661 101.692L338.539 103.636C338.344 103.968 337.838 103.836 337.833 103.452L337.819 100.639C337.819 100.639 337.819 100.63 337.814 100.63C337.814 100.63 334.347 98.6287 329.866 96.0441L329.458 95.807C327.45 94.6499 325.607 93.2746 323.949 91.7239",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M316.626 43.8848V44.9992",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M315.551 49.343C317.607 49.2671 319.208 47.5362 319.132 45.478L315.551 49.343Z",
                fill: "#E6F5ED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M315.551 49.343C317.607 49.2671 319.208 47.5362 319.132 45.478",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M330.457 73.8555C330.016 77.1893 329.055 80.4614 327.582 83.5439L316.142 107.469V107.336L316.047 107.559C316.047 107.564 316.038 107.568 316.029 107.568L308.345 104.415L305.939 103.428L303.864 102.575C303.509 102.428 303.575 101.906 303.954 101.849L306.74 101.46L306.749 101.451L307.616 99.2266L317.307 74.3581",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M325.754 41.4375L336.184 43.14L337.165 37.1126C332.708 36.3823 328.425 38.1748 325.754 41.4375Z",
                fill: "#E6F5ED",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M305.413 71.3471C304.423 69.9291 302.557 69.4312 300.999 70.1852L300.388 70.4793",
                fill: "#E6F5ED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M305.413 71.3471C304.423 69.9291 302.557 69.4312 300.999 70.1852L300.388 70.4793",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M283.511 98.4822L284.127 98.3257C284.127 98.3257 284.131 98.3352 284.136 98.3446L281.218 108H277.239L278.755 99.6962L283.511 98.4869V98.4822Z",
                fill: "#E6F5ED",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M266.543 84.563V85.2601",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M259.917 87.1858C261.011 87.1858 262.058 86.7496 262.83 85.9766L259.917 87.1858Z",
                fill: "#E6F5ED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M259.917 87.1858C261.011 87.1858 262.058 86.7496 262.83 85.9766",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M259.268 82.9321L260.277 82.8041L261.821 82.6855C261.963 84.113 261.006 85.4076 259.623 85.7064L259.268 82.9321Z",
                fill: "#E6F5ED",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M271.03 86.1331C273.664 86.1331 273.664 80.855 273.664 80.855H268.392C268.392 80.855 268.392 86.1331 271.025 86.1331H271.03Z",
                fill: "#E6F5ED",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M272.1 86.1337C272.228 87.9832 273.644 89.4912 275.482 89.7283L286.358 91.2601C288.072 91.5019 289.806 90.6578 290.545 89.0929C290.55 89.0834 290.554 89.0692 290.564 89.0597C290.829 88.4859 290.967 87.8883 290.99 87.2908C292.212 88.6186 292.587 90.6057 291.777 92.3461C291.246 93.4842 290.313 94.3046 289.223 94.7125C289.223 94.7125 289.223 94.7125 289.223 94.7077C289.28 94.9923 289.313 95.2009 289.328 95.2626C290.014 98.5252 291.668 101.537 294.107 103.879L291.265 106.943L290.19 105.947C287.793 103.732 285.747 101.162 284.131 98.3213L283.515 98.4778L278.76 99.6871L276.396 100.289L272.138 101.371L271.981 101.409L269.532 107.986H265.084L267.552 94.5939C267.358 94.3615 267.173 94.1244 266.998 93.8778C266.198 92.7444 265.629 91.4356 265.35 90.0224H260.187L259.268 82.8758L268.4 81.9463",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M302.122 71.3472H300.199C297.537 71.3472 295.377 73.5096 295.377 76.1748V78.674C295.377 81.3391 293.217 83.5016 290.555 83.5016H284.624C281.171 83.5016 277.798 84.5544 274.961 86.5224L273.028 87.8597",
                fill: "#E6F5ED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M302.122 71.3472H300.199C297.537 71.3472 295.377 73.5096 295.377 76.1748V78.674C295.377 81.3391 293.217 83.5016 290.555 83.5016H284.624C281.171 83.5016 277.798 84.5544 274.961 86.5224L273.028 87.8597",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M318.724 40.2143C316.829 41.4331 313.869 41.3572 312.111 40.0483L318.724 40.2143Z",
                fill: "#E6F5ED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M318.724 40.2143C316.829 41.4331 313.869 41.3572 312.111 40.0483",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M325.8 45.4779C321.731 45.3735 318.557 43.0119 318.704 40.1997L325.8 45.4779Z",
                fill: "#E6F5ED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M325.8 45.4779C321.731 45.3735 318.557 43.0119 318.704 40.1997",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M316.01 52.876L315.082 46.4313L313.04 46.5024L313.329 42.6849C313.537 39.8964 315.532 37.4826 318.279 36.9705C321.438 36.3777 324.451 38.3125 325.285 41.3429L326.815 50.8037",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M328.284 50.519L316.011 52.8759",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M330.182 56.3328C331.329 55.3844 332.162 54.0945 332.546 52.6433C332.906 51.2871 331.831 50.0114 330.486 50.092L326.81 50.7986L315.716 52.9326L315.849 54.3031C315.948 55.3132 315.73 56.3281 315.223 57.2054C313.078 60.9091 310.321 64.186 307.071 66.9128L311.334 72.6557L312.907 71.4417C313.637 73.1537 315.328 74.3487 317.303 74.3487L330.533 73.865C333.2 73.7701 335.028 71.1429 334.199 68.6058L330.182 56.3281V56.3328Z",
                fill: "#00C1DE",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M322.415 59.1641C320.88 62.1043 319.028 64.8406 316.906 67.3303C314.206 70.5028 311.061 73.2771 307.555 75.5771C307.555 75.5771 301.483 79.9162 300.668 78.6738C300.256 78.0478 302.539 76.5729 303.453 76.0181C302.198 76.7342 299.858 78.0146 299.361 77.1183C298.977 76.4259 301.407 74.8894 302.402 74.3014C301.246 74.8942 298.584 76.1177 298.228 75.4632C297.831 74.7377 301.369 72.8503 301.369 72.8503",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M272.445 87.4849L265.79 91.6011C266.07 92.3504 266.439 93.0618 266.88 93.7162L273.904 89.1589C273.27 88.7558 272.758 88.1725 272.445 87.4849Z",
                fill: "#FF595A",
                stroke: "#FF595A",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M306.797 66.5381L311.292 72.5987",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.6257 67.4868L59.0869 76.9835L60.8779 77.4318L63.4075 67.9813L61.6257 67.4868Z",
                fill: "#FF595A",
                stroke: "#FF595A",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M97.2789 88.6245H86.8145C86.8329 89.2438 86.8468 89.8584 86.856 90.473H97.3205L97.2789 88.6245Z",
                fill: "#FF595A",
                stroke: "#FF595A",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.084 32.9845C97.1872 32.8412 97.9027 32.5593 97.9258 32.1988C97.9489 31.7968 97.0949 31.3855 95.7886 31.1082C97.118 30.9835 98.0135 30.6831 98.0412 30.2764C98.0689 29.8281 97.0118 29.3752 95.4562 29.098C96.6702 28.964 97.4734 28.6728 97.4965 28.2892C97.5334 27.6608 95.4424 26.9768 92.8205 26.8659C88.7215 26.6857 86.6581 27.938 86.6581 27.938C85.2364 28.6682 84.1101 29.976 83.6301 31.6027L80.9251 40.7436L80.1542 43.3454L79.7434 43.2252C69.5743 40.2445 58.7452 45.559 55.0432 55.4994C54.6508 56.5484 54.4893 57.2508 54.6693 57.4033C55.1263 57.7869 56.6311 55.6657 57.1988 54.82C56.4603 55.9753 55.1263 58.1289 55.8187 58.5679C56.3495 58.9052 57.9097 56.6639 58.5098 55.7489C57.882 56.8118 56.5618 59.2565 57.0696 59.5707C57.6328 59.9219 58.4406 58.8683 59.1745 57.6852C59.3084 57.4726 59.9315 56.4606 59.9038 56.5068C59.1699 57.6898 58.2744 59.4274 58.8191 59.7648C59.5899 60.2408 61.3994 57.297 62.1933 55.9014C62.5534 56.5669 63.2181 57.3432 63.6243 57.2508C64.2382 57.1075 64.2844 55.5086 63.9659 54.1499C66.1631 50.7856 70.3083 49.2745 74.1534 50.4344L76.3737 51.1045L70.4652 69.9409L57.1942 66.2577L53.9215 78.1344C53.8199 78.4902 54.2492 78.749 54.5169 78.4949L56.5711 76.3598L69.879 79.6779C74.3704 80.7962 78.9494 78.1945 80.2881 73.7534L82.4161 66.0359",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M91.8604 33.6777V34.7406",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M90.8594 37.421L90.8732 37.0005",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M87.4424 34.3198C88.4394 34.3198 89.2472 35.1286 89.2472 36.1267C89.2472 37.1249 88.4394 37.9337 87.4424 37.9337",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M66.5223 68.8408L64.002 78.2636",
                stroke: "#06262D",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M81.3682 70.3096L82.4298 71.7607C86.4919 77.2092 86.732 83.9978 86.852 90.5508L86.9304 94.9041H99.726C100.095 94.9041 100.225 94.4142 99.906 94.2294L97.3672 92.8522L97.2056 85.8186C97.021 77.6806 94.9023 70.5407 90.7248 63.886C88.4537 60.2676 89.8246 55.3505 89.8246 55.3505C101.355 59.1307 110.306 52.6609 113.939 42.91C114.331 41.861 114.493 41.1586 114.313 41.0061C113.856 40.6225 112.351 42.7437 111.783 43.5894C112.522 42.434 113.856 40.2805 113.163 39.8415C112.632 39.5042 111.072 41.7455 110.472 42.6605C111.1 41.5976 112.42 39.1529 111.912 38.8387C111.349 38.4875 110.541 39.5411 109.807 40.7242C109.673 40.9368 109.05 41.9488 109.078 41.9026C109.812 40.7195 110.707 38.982 110.163 38.6446C109.392 38.1686 107.582 41.1124 106.788 42.508C106.428 41.8425 105.764 41.0661 105.357 41.1586C104.744 41.3018 104.697 42.9008 105.016 44.2595C104.111 45.6458 102.874 46.718 101.462 47.4204C99.2967 48.4925 96.7625 48.548 94.4822 47.7485L91.0294 46.5377L91.7126 43.7511L93.0928 38.1316L95.0269 38.1963C95.2669 38.2056 95.4469 37.9791 95.3869 37.7434L94.833 32.4336",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.5362 37.3195C84.0658 37.3195 85.3058 36.0781 85.3058 34.5467C85.3058 33.0153 84.0658 31.7739 82.5362 31.7739C81.0066 31.7739 79.7666 33.0153 79.7666 34.5467C79.7666 36.0781 81.0066 37.3195 82.5362 37.3195Z",
                fill: "#E6F5ED",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.5361 34.5463V29.4213C82.5361 26.2557 85.098 23.6909 88.2599 23.6909C90.4941 23.6909 92.4328 24.9756 93.3745 26.8426",
                stroke: "#06262D",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M97.1966 85.3896H86.6582",
                stroke: "#06262D",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/propertyListings/PropertyListings.tsx


function PropertyListings_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --min-grid-item-width: 320px;\n  display: grid;\n  grid-template-columns: repeat( auto-fill, minmax( min( 100%, var( --min-grid-item-width ) ), 1fr ) );\n  gap: calc( 3 * var( --stack-basis ) );\n\n  > * {\n    max-width: 100%;\n  }\n\n  @media ( min-width: 1200px ) {\n    --min-grid-item-width: 380px;\n  }\n"
    ]);
    PropertyListings_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PropertyListings_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: space-between;\n  align-items: center;\n  font-size: ",
        ";\n\n  > div {\n    max-width: 20em;\n  }\n"
    ]);
    PropertyListings_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













function endpointPaginator(endpoint, limit) {
    return function getPaginatedEndpoint(pageIndex, previousPageData) {
        if (previousPageData && !previousPageData.length) {
            return null;
        }
        var ref = (0,_sliced_to_array/* default */.Z)(endpoint.split("?"), 2), ep = ref[0], searchParams = ref[1];
        var params = searchParams ? "&".concat(searchParams) : "";
        return "".concat(ep, "?limit=").concat(limit, "&offset=").concat(pageIndex * limit).concat(params);
    };
}
function PropertyListings(param) {
    var company = param.company, related = param.related, numberOfProperties = param.numberOfProperties, propertyCardStyle = param.propertyCardStyle, carouselForSmallScreens = param.carouselForSmallScreens, showCountdown = param.showCountdown, showLoadMoreButton = param.showLoadMoreButton;
    var ref, ref1;
    var craftData = (0,craft/* useCraft */.Yi)();
    var isSmallScreen = useMediaQuery("( max-width: 768px )");
    var shouldUseCarousel = isSmallScreen && carouselForSmallScreens;
    var companyStub = company || (craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : ref.partnerSlug) || "brixel_zurich";
    var defaultNumberOfProperties = propertyCardStyle === "large" ? 3 : 6;
    var resultsPerPage = numberOfProperties && numberOfProperties > 0 ? numberOfProperties : defaultNumberOfProperties;
    var query = (0,next_router.useRouter)().query;
    var searchParams = new URLSearchParams();
    Object.entries(query).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        if (key === "stateCodes") {
            if (typeof value === "string") {
                searchParams.append(key, value);
            } else {
                value.forEach(function(v) {
                    return searchParams.append(key, v);
                });
            }
        }
    });
    var relatedEndpoint = [
        "related",
        "others",
        "mixed",
        "portfolio"
    ].includes(related) ? related : "others";
    var endpoint = "/api/company/stub/".concat(companyStub, "/portfolio/").concat(relatedEndpoint, "?").concat(searchParams.toString());
    var ref2 = useHubAPIRequestInfinite(endpointPaginator(endpoint, resultsPerPage), {
        initialSize: 1
    }), data = ref2.data, error = ref2.error, size = ref2.size, setSize = ref2.setSize;
    if (!data && !error) {
        return null;
    }
    var properties = data === null || data === void 0 ? void 0 : data.flat();
    properties.length = Math.min(size * resultsPerPage, properties.length);
    if (error || properties.length === 0 || ((ref1 = properties[0]) === null || ref1 === void 0 ? void 0 : ref1.status) === "Data is currently unavailable") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEmptyState, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            defaultMessage: "We can't find any properties meeting your search criteria.",
                            id: "mHZeeW",
                            description: "Message shown when no properties are found matching the search criteria"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ParkScene, {})
            ]
        });
    }
    if (propertyCardStyle === "large") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.ZP, {
                    $between: 2,
                    $bottom: showLoadMoreButton && properties.length >= resultsPerPage * size ? 6 : 0,
                    children: properties.map(function(property) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyListingLargeCard, {
                                property: property,
                                showCountdown: showCountdown
                            })
                        }, property.id);
                    })
                }),
                showLoadMoreButton && properties.length >= resultsPerPage * size && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonGroup, {
                    buttons: [
                        {
                            id: "load-more",
                            onClick: function() {
                                return setSize(function(s) {
                                    return s + 1;
                                });
                            },
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                defaultMessage: "Load more",
                                id: "0YlyNR",
                                description: "Load more button label"
                            }),
                            href: null
                        }, 
                    ]
                })
            ]
        });
    }
    if (shouldUseCarousel) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
            children: properties.map(function(property) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyCard, {
                        property: property,
                        showCountdown: showCountdown
                    })
                }, property.id);
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
        $between: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPropertyListings, {
                children: properties.map(function(property) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyCard, {
                        property: property,
                        showCountdown: showCountdown
                    }, property.id);
                })
            }),
            showLoadMoreButton && properties.length >= resultsPerPage * size && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonGroup, {
                buttons: [
                    {
                        id: "load-more",
                        onClick: function() {
                            return setSize(function(s) {
                                return s + 1;
                            });
                        },
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            defaultMessage: "Load more",
                            id: "0YlyNR",
                            description: "Load more button label"
                        }),
                        href: null
                    }, 
                ]
            })
        ]
    });
}
var StyledPropertyListings = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4744070a-0"
})(PropertyListings_templateObject());
var StyledEmptyState = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4744070a-1"
})(PropertyListings_templateObject1(), function(p) {
    return p.theme.typo.sizes.large;
});

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
;// CONCATENATED MODULE: ./components/ui/FilterGroup/actions.ts



function removeItemFromSelect(param) {
    var selectedState = param.selectedState, key = param.key, itemValue = param.itemValue;
    var newValues = selectedState[key].filter(function(v) {
        return v !== itemValue;
    });
    if (newValues.length === 0) {
        return clearFilter({
            selectedState: selectedState,
            key: key
        });
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedState), (0,_define_property/* default */.Z)({}, key, selectedState[key].filter(function(v) {
        return v !== itemValue;
    })));
}
function clearFilter(param) {
    var selectedState = param.selectedState, key = param.key;
    var newState = (0,_object_spread/* default */.Z)({}, selectedState);
    delete newState[key];
    return newState;
}
function replaceFilterState(param) {
    var selectedState = param.selectedState, key = param.key, value = param.value;
    if (!value || Array.isArray(value) && value.length === 0) {
        return clearFilter({
            selectedState: selectedState,
            key: key
        });
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedState), (0,_define_property/* default */.Z)({}, key, value));
}

// EXTERNAL MODULE: ./components/ui/Select/Select.tsx + 1 modules
var Select = __webpack_require__(5330);
;// CONCATENATED MODULE: ./components/ui/FilterGroup/FilterGroupSelect.tsx

function FilterGroupSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  button {\n    position: relative;\n    display: flex;\n    width: 100%;\n    cursor: default;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    overflow: hidden;\n    border: 1px solid ",
        ";\n    border-radius: 100rem;\n    background: transparent;\n    padding: 8px 12px;\n    text-align: left;\n    font-size: 14px;\n    outline: none;\n\n    &:focus-within {\n      border-color: ",
        ";\n    }\n\n    > span {\n      max-width: 100%;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    > div {\n      flex-shrink: 0;\n    }\n  }\n"
    ]);
    FilterGroupSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function FilterGroupSelect(param) {
    var label = param.label, options = param.options, selected = param.selected, onChange = param.onChange;
    var selectedCount = selected.length ? "(".concat(selected.length, ")") : "";
    var displayValue = "".concat(label, " ").concat(selectedCount);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
            displayValue: displayValue,
            options: options,
            selected: selected,
            onChange: onChange
        })
    });
}
var StyledSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60fa0179-0"
})(FilterGroupSelect_templateObject(), function(p) {
    return p.theme.colors.grey200;
}, function(p) {
    return p.theme.colors.green400;
});

;// CONCATENATED MODULE: ./components/ui/FilterGroup/FilterGroupControls.tsx



function FilterGroupControls(param) {
    var filters = param.filters, selected = param.selected, onChange = param.onChange;
    var internalOnChange = function(key) {
        return function(selectedOptions) {
            onChange(replaceFilterState({
                selectedState: selected,
                key: key,
                value: selectedOptions
            }));
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex gap-12",
        children: filters.map(function(filter) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-max",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterGroupControl, {
                    filter: filter,
                    selected: selected,
                    onChange: internalOnChange(filter.key)
                })
            }, filter.key);
        })
    });
}
FilterGroupControls.displayName = "FilterGroup.Controls";
function FilterGroupControl(param) {
    var filter = param.filter, selected = param.selected, onChange = param.onChange;
    if (filter.type === "select") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterGroupSelect, {
            options: filter.options,
            label: filter.label,
            selected: selected[filter.key] || [],
            onChange: onChange
        }, filter.key);
    }
    return null;
}

;// CONCATENATED MODULE: ./components/ui/FilterGroup/FilterGroupSummary.tsx



function FilterGroupSummary_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n"
    ]);
    FilterGroupSummary_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilterGroupSummary_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 8px 8px 16px;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background-color: #fff;\n\n  > span {\n    font-size: 14px;\n  }\n\n  > button {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 0;\n    border-radius: 9999px;\n    background-color: #fff;\n    padding: 4px;\n    transition: background-color 0.2s ease-in-out;\n\n    > svg {\n      width: 16px;\n      height: 16px;\n      transform: rotate(45deg);\n\n      path {\n        fill: black;\n      }\n    }\n\n    &:hover {\n      background-color: ",
        ";\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n    }\n  }\n"
    ]);
    FilterGroupSummary_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




function defaultSelectSummaryLabel(value) {
    return value;
}
function FilterGroupSummary(param) {
    var filters = param.filters, selected = param.selected, onChange = param.onChange;
    var selectedFilterValues = getSelectedFilterDisplayValues(filters, selected);
    if (!selectedFilterValues.length) {
        return null;
    }
    var removeSelectedFilterValue = function(type, key, value) {
        if (type === "select") {
            onChange(removeItemFromSelect({
                selectedState: selected,
                key: key,
                itemValue: value
            }));
        } else if (type === "range") {
            onChange(clearFilter({
                selectedState: selected,
                key: key
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSummaryWrapper, {
        children: selectedFilterValues.map(function(selectedValue) {
            if (!(selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.values)) {
                return null;
            }
            return selectedValue.values.map(function(value) {
                return value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSummaryItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-sm",
                            children: value.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: function() {
                                return removeSelectedFilterValue(selectedValue.filterType, selectedValue.key, value.value);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_PlusIcon, {})
                        })
                    ]
                }, "".concat(selectedValue.key, "-").concat(value.value));
            });
        })
    });
}
FilterGroupSummary.displayName = "FilterGroup.Summary";
function getSelectedFilterDisplayValues(filters, selected) {
    return filters.map(function(filter) {
        var ref;
        if (!((ref = selected[filter.key]) === null || ref === void 0 ? void 0 : ref.length)) {
            return null;
        }
        if (filter.type === "select") {
            return {
                filterType: filter.type,
                key: filter.key,
                values: filter.options.filter(function(o) {
                    return selected[filter.key].includes(o.value);
                }).map(function(v) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, v), {
                        label: filter.summaryLabel ? filter.summaryLabel(v.label) : defaultSelectSummaryLabel(v.label)
                    });
                })
            };
        }
        return null;
    }).filter(Boolean);
}
var StyledSummaryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c312c139-0"
})(FilterGroupSummary_templateObject());
var StyledSummaryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c312c139-1"
})(FilterGroupSummary_templateObject1(), function(p) {
    return p.theme.colors.grey100;
});

;// CONCATENATED MODULE: ./components/ui/FilterGroup/FilterGroup.tsx




function FilterGroup(param) {
    var filters = param.filters, selected = param.selected, onChange = param.onChange;
    var key = (0,react.useId)();
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterGroupControls, {
            filters: filters,
            selected: selected,
            onChange: onChange
        }, "".concat(key, "-controls")),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterGroupSummary, {
            filters: filters,
            selected: selected,
            onChange: onChange
        }, "".concat(key, "-summary")), 
    ];
}

;// CONCATENATED MODULE: ./components/ui/PropertyListingsFilterGroup/swissCantons.ts
function swissCantons(intl) {
    return {
        AG: intl.formatMessage({
            description: "Swiss Canton name for state code: AG",
            defaultMessage: "Aargau",
            id: "w+vERP"
        }),
        AI: intl.formatMessage({
            description: "Swiss Canton name for state code: AI",
            defaultMessage: "Appenzell Inner-Rhodes",
            id: "ZQWkJ9"
        }),
        AR: intl.formatMessage({
            description: "Swiss Canton name for state code: AR",
            defaultMessage: "Appenzell Outer-Rhodes",
            id: "6fRR0B"
        }),
        BE: intl.formatMessage({
            description: "Swiss Canton name for state code: BE",
            defaultMessage: "Bern",
            id: "iPAnLE"
        }),
        BL: intl.formatMessage({
            description: "Swiss Canton name for state code: BL",
            defaultMessage: "Basel District",
            id: "LGpzov"
        }),
        BS: intl.formatMessage({
            description: "Swiss Canton name for state code: BS",
            defaultMessage: "Basel",
            id: "gtiHtC"
        }),
        FR: intl.formatMessage({
            description: "Swiss Canton name for state code: FR",
            defaultMessage: "Fribourg",
            id: "3CyOuX"
        }),
        GE: intl.formatMessage({
            description: "Swiss Canton name for state code: GE",
            defaultMessage: "Geneva",
            id: "BML85d"
        }),
        GL: intl.formatMessage({
            description: "Swiss Canton name for state code: GL",
            defaultMessage: "Glarus",
            id: "iIDcto"
        }),
        GR: intl.formatMessage({
            description: "Swiss Canton name for state code: GR",
            defaultMessage: "Grisons",
            id: "RxH0Zp"
        }),
        JU: intl.formatMessage({
            description: "Swiss Canton name for state code: JU",
            defaultMessage: "Jura",
            id: "JchSgw"
        }),
        LU: intl.formatMessage({
            description: "Swiss Canton name for state code: LU",
            defaultMessage: "Lucerne",
            id: "5vG1Zi"
        }),
        NE: intl.formatMessage({
            description: "Swiss Canton name for state code: NE",
            defaultMessage: "Neuch\xe2tel",
            id: "+hh+VE"
        }),
        NW: intl.formatMessage({
            description: "Swiss Canton name for state code: NW",
            defaultMessage: "Nidwalden",
            id: "EQ/XxL"
        }),
        OW: intl.formatMessage({
            description: "Swiss Canton name for state code: OW",
            defaultMessage: "Obwalden",
            id: "ssOh8n"
        }),
        SG: intl.formatMessage({
            description: "Swiss Canton name for state code: SG",
            defaultMessage: "St. Gallen",
            id: "XOCDU1"
        }),
        SH: intl.formatMessage({
            description: "Swiss Canton name for state code: SH",
            defaultMessage: "Schaffhausen",
            id: "wQJ8/A"
        }),
        SO: intl.formatMessage({
            description: "Swiss Canton name for state code: SO",
            defaultMessage: "Solothurn",
            id: "kcqF2C"
        }),
        SZ: intl.formatMessage({
            description: "Swiss Canton name for state code: SZ",
            defaultMessage: "Schwyz",
            id: "DXJv2Y"
        }),
        TG: intl.formatMessage({
            description: "Swiss Canton name for state code: TG",
            defaultMessage: "Thurgau",
            id: "MIYCJc"
        }),
        TI: intl.formatMessage({
            description: "Swiss Canton name for state code: TI",
            defaultMessage: "Ticino",
            id: "YyoBcv"
        }),
        UR: intl.formatMessage({
            description: "Swiss Canton name for state code: UR",
            defaultMessage: "Uri",
            id: "KWSZCn"
        }),
        VD: intl.formatMessage({
            description: "Swiss Canton name for state code: VD",
            defaultMessage: "Vaud",
            id: "h4gb19"
        }),
        VS: intl.formatMessage({
            description: "Swiss Canton name for state code: VS",
            defaultMessage: "Valais",
            id: "FScS0U"
        }),
        ZG: intl.formatMessage({
            description: "Swiss Canton name for state code: ZG",
            defaultMessage: "Zug",
            id: "kB1Pu4"
        }),
        ZH: intl.formatMessage({
            description: "Swiss Canton name for state code: ZH",
            defaultMessage: "Zurich",
            id: "z+bbkF"
        })
    };
}

;// CONCATENATED MODULE: ./components/ui/PropertyListingsFilterGroup/PropertyListingsFilterGroup.tsx




function PropertyListingsFilterGroup(param) {
    var selected = param.selected, onChange = param.onChange;
    var intl = (0,useIntl/* default */.Z)();
    return FilterGroup({
        filters: [
            {
                key: "stateCodes",
                type: "select",
                label: intl.formatMessage({
                    description: "Label for the Swiss canton multi select",
                    defaultMessage: "Cantons",
                    id: "REcF0D"
                }),
                options: Object.entries(swissCantons(intl)).map(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), stateCode = _param[0], cantonName = _param[1];
                    return {
                        value: stateCode,
                        label: cantonName
                    };
                })
            }, 
        ],
        selected: selected,
        onChange: onChange
    });
}

;// CONCATENATED MODULE: ./components/pageSegments/PropertyListingsSegment.tsx


function PropertyListingsSegment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n"
    ]);
    PropertyListingsSegment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










function PropertyListingsSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, additionalBottomPadding = param.additionalBottomPadding, buttonLabel = param.buttonLabel, buttonLink = param.buttonLink, company = param.company, related = param.related, numberOfProperties = param.numberOfProperties, showCountdown = param.showCountdown, propertyCardStyle = param.propertyCardStyle, carouselForSmallScreens = param.carouselForSmallScreens, showLoadMoreButton = param.showLoadMoreButton, showFilterControls = param.showFilterControls;
    var ref;
    var ref1 = (0,next_router.useRouter)(), asPath = ref1.asPath, query = ref1.query, push = ref1.push;
    var stateCodes = Array.isArray(query.stateCodes) ? query.stateCodes : ((ref = query.stateCodes) === null || ref === void 0 ? void 0 : ref.split(",")) || [];
    var sectionHeadingId = "".concat(anchorId, "-heading");
    var ref2 = (0,_sliced_to_array/* default */.Z)(PropertyListingsFilterGroup({
        selected: {
            stateCodes: stateCodes
        },
        onChange: function(param) {
            var newSelectedStateCodes = param.stateCodes;
            var pathname = asPath.split("?")[0];
            if (!(newSelectedStateCodes === null || newSelectedStateCodes === void 0 ? void 0 : newSelectedStateCodes.length)) {
                push(pathname, undefined, {
                    scroll: false
                });
                return;
            }
            var urlSearchParams = new URLSearchParams();
            newSelectedStateCodes.forEach(function(stateCode) {
                urlSearchParams.append("stateCodes", stateCode);
            });
            push("".concat(pathname, "?").concat(urlSearchParams.toString()), undefined, {
                scroll: false
            });
        }
    }), 2), filterControls = ref2[0], filterSummary = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        segmentType: propertyCardStyle === "large" ? "propertyListingsLarge" : "propertyListings",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        color: "ivory",
        hideOverflow: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            "aria-labelledby": sectionHeadingId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                    $top: 12,
                    $bottom: 12,
                    $between: 10,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                            id: sectionHeadingId,
                            title: title,
                            subtitle: subtitle
                        }),
                        showFilterControls && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFilters, {
                            children: [
                                filterControls,
                                filterSummary
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyListings, {
                            company: company,
                            related: related,
                            numberOfProperties: numberOfProperties,
                            propertyCardStyle: propertyCardStyle,
                            carouselForSmallScreens: carouselForSmallScreens,
                            showCountdown: showCountdown,
                            showLoadMoreButton: showLoadMoreButton
                        }),
                        buttonLabel && buttonLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonGroup, {
                            buttons: [
                                {
                                    id: 1,
                                    label: buttonLabel,
                                    href: buttonLink,
                                    primary: true
                                }, 
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var pageSegments_PropertyListingsSegment = (PropertyListingsSegment);
var StyledFilters = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4db16e35-0"
})(PropertyListingsSegment_templateObject());

;// CONCATENATED MODULE: ./components/propertyListingsLarge/PropertyListingsLarge.tsx




function PropertyListingsLarge(param) {
    var companyStub = param.companyStub, _related = param.related, related = _related === void 0 ? false : _related;
    var endpoint = "/api/company/stub/".concat(companyStub, "/portfolio/").concat(related ? "related" : "others", "?limit=30");
    var ref = useHubAPIRequest(endpoint), properties = ref.data, error = ref.error;
    if (!properties && !error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Loading"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.ZP, {
            $between: 2,
            children: properties.map(function(property) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyListingLargeCard, {
                        property: property
                    })
                }, property.id);
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/pageSegments/PropertyListingsLargeSegment.tsx







function PropertyListingsLargeSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, additionalBottomPadding = param.additionalBottomPadding;
    var ref;
    var craftData = (0,craft/* useCraft */.Yi)();
    var companyStub = craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : ref.partnerSlug;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        segmentType: "propertyListingsLarge",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        color: "ivory",
        hideOverflow: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyListingsLarge, {
                        companyStub: companyStub,
                        related: true
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./components/pageSegments/StorySegment.tsx
var StorySegment = __webpack_require__(2419);
;// CONCATENATED MODULE: ./components/processStepsSimple/ProcessStepSimple.tsx

function ProcessStepSimple(param) {
    var step = param.step, stepNumber = param.stepNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: stepNumber
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: step.stepText
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/processStepsSimple/ProcessStepsSimple.tsx

function ProcessStepsSimple_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n\n  > li {\n    display: flex;\n    padding: 0;\n\n    span {\n      display: block;\n\n      &:first-child {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 50px;\n        height: 50px;\n        border-radius: 100%;\n        background-color: ",
        ";\n        color: ",
        ";\n        ",
        ";\n      }\n\n      &:last-child {\n        font-weight: 600;\n      }\n    }\n  }\n\n  @media ( max-width: 999px ) {\n    flex-direction: column;\n    gap: 1rem;\n\n    li {\n      background-color: ",
        ";\n      border-radius: 20rem;\n\n      span {\n        &:last-child {\n          display: flex;\n          align-items: center;\n          padding-left: 1rem;\n        }\n      }\n    }\n  }\n  \n  @media ( min-width: 1000px ) {\n    li {\n      flex: 0 0 20%;\n      flex-direction: column;\n      align-items: center;\n\n      span {\n        display: block;\n\n        &:first-child {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 50px;\n          height: 50px;\n          border-radius: 100%;\n          background-color: ",
        ";\n          color: ",
        ";\n          ",
        ";\n        }\n\n        &:last-child {\n          margin-top: 1rem;\n        }\n      }\n    }\n  }\n"
    ]);
    ProcessStepsSimple_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function ProcessStepsSimple(param) {
    var steps = param.steps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProcessStepsSimple, {
        children: steps.map(function(step, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcessStepSimple, {
                step: step,
                stepNumber: i + 1
            }, step.id);
        })
    });
}
var StyledProcessStepsSimple = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-a973fc24-0"
})(ProcessStepsSimple_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.red200;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red400;
}, function(param) {
    var theme = param.theme;
    return theme.typo.mono;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red100;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red200;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red400;
}, function(param) {
    var theme = param.theme;
    return theme.typo.mono;
});

;// CONCATENATED MODULE: ./components/pageSegments/ProcessStepsSimpleSegment.tsx








function ProcessStepsSimpleSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, bodyText = param.bodyText, button = param.button, processStepsSimple = param.processStepsSimple, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        color: "ivory",
        segmentType: "processSteps",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcessStepsSimple, {
                            steps: processStepsSimple
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_PageSegmentBodyText, {
                        html: bodyText,
                        bodyStyle: "small"
                    }),
                    button && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonGroup, {
                        buttons: [
                            {
                                id: 1,
                                label: button.text,
                                href: button.url,
                                primary: true,
                                color: "red",
                                openInNewTab: button.target === "_blank"
                            }, 
                        ]
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/highlights/Highlight.tsx

function Highlight_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  column-gap: 73px;\n  row-gap: 24px;\n  flex-direction: ",
        ";\n"
    ]);
    Highlight_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Highlight_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0 calc(40% - 73px);\n  min-width: 305px;\n\n  > span {\n    ",
        "\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    Highlight_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Highlight_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0 calc(60% - 73px);\n"
    ]);
    Highlight_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




function Highlight(param) {
    var eyebrow = param.eyebrow, title = param.title, description = param.description, image = param.image, caption = param.caption, _alignment = param.alignment, alignment = _alignment === void 0 ? "row" : _alignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHighlight, {
        $alignment: alignment,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight_StyledImage, {
                children: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCaption, {
                children: [
                    eyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: eyebrow
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: title
                    }),
                    description && // eslint-disable-next-line react/no-danger
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: (0,strings/* wrapWithPTags */.gu)(description)
                        }
                    }),
                    caption
                ]
            })
        ]
    });
}
var StyledHighlight = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-b39d3c57-0"
})(Highlight_templateObject(), function(p) {
    return p.$alignment;
});
var StyledCaption = styled_components_browser_esm/* default.figcaption.withConfig */.ZP.figcaption.withConfig({
    componentId: "sc-b39d3c57-1"
})(Highlight_templateObject1(), function(p) {
    return p.theme.typo.mono;
}, function(p) {
    return p.theme.typo.sizes.small;
}, function(p) {
    return p.theme.getColor("green400");
});
var Highlight_StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b39d3c57-2"
})(Highlight_templateObject2());
/* harmony default export */ var highlights_Highlight = (Highlight);

;// CONCATENATED MODULE: ./components/highlights/ThreeDeeTourHighlight.tsx

function ThreeDeeTourHighlight_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  background-color: #222; // matterport bg color\n  inset: 0;\n  z-index: 99;\n  iframe {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n  }\n  button {\n    position: absolute;\n    top: 30px;\n    right: 30px;\n    z-idnex: 1;\n  }\n"
    ]);
    ThreeDeeTourHighlight_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ThreeDeeTourHighlight_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex: 0 0 50%;\n  aspect-ratio: 1.59/1;\n  margin-top: max( var( --grid-gutter ), calc( 4 * var( --stack-basis ) ) );\n\n  button {\n    display: block;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border: 0;\n    padding: 0;\n    margin: 0;\n    background: ",
        ";\n    cursor: pointer;\n\n    img {\n      opacity: 0.6;\n    }\n\n    &:hover svg {\n      transform: \n      translate( -50%, -50% )\n      scale( 1.1 );\n    }\n  }\n\n  svg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate( -50%, -50% );\n    transition: transform .3s ease-out;\n  }\n"
    ]);
    ThreeDeeTourHighlight_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








function ThreeDeeTourHighlight(param) {
    var title = param.title, description = param.description, eyebrow = param.eyebrow, image = param.image, buttonText = param.buttonText, tourURL = param.tourURL, alignment = param.alignment;
    var ref = (0,react.useState)(false), tour = ref[0], setTour = ref[1];
    var launchTour = function() {
        return setTour(true);
    };
    var closeTour = function() {
        return setTour(false);
    };
    var tourRef = (0,react.useRef)();
    (0,useModalTraits/* default */.Z)({
        containerRef: tourRef,
        isOpen: tour,
        close: closeTour,
        preventBodyScroll: true
    });
    (0,react.useEffect)(function() {
        var handler = function(e) {
            if (e.key === "Escape") {
                closeTour();
            }
        };
        document.addEventListener("keyup", handler);
        return function() {
            return document.removeEventListener("keyup", handler);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(highlights_Highlight, {
                title: title,
                description: description,
                eyebrow: eyebrow,
                alignment: alignment,
                image: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeDeeTourHighlight_StyledCoverImage, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        onClick: launchTour,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                                src: image.url,
                                alt: image.alt,
                                dateModified: image.dateModified,
                                layout: "fill",
                                objectFit: "cover"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_VideoPlayIcon, {})
                        ]
                    })
                }),
                caption: tourURL && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    onClick: launchTour,
                    children: buttonText
                })
            }),
            tour && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTourEmbed, {
                ref: tourRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        src: tourURL,
                        title: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        onClick: closeTour,
                        children: "Close"
                    })
                ]
            })
        ]
    });
}
var StyledTourEmbed = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ccbdd99-0"
})(ThreeDeeTourHighlight_templateObject());
var ThreeDeeTourHighlight_StyledCoverImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ccbdd99-1"
})(ThreeDeeTourHighlight_templateObject1(), function(p) {
    return p.theme.colors.black;
});
/* harmony default export */ var highlights_ThreeDeeTourHighlight = (ThreeDeeTourHighlight);

;// CONCATENATED MODULE: ./components/highlights/ImagesHighlight.tsx

function ImagesHighlight_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n"
    ]);
    ImagesHighlight_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ImagesHighlight_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  aspect-ratio: 1.59/1;\n\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    ImagesHighlight_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






function ImagesHighlight(param) {
    var title = param.title, description = param.description, eyebrow = param.eyebrow, images = param.images, alignment = param.alignment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(highlights_Highlight, {
        title: title,
        description: description,
        eyebrow: eyebrow,
        alignment: alignment,
        image: images && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagesHighlight_StyledCarousel, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                overlayControls: true,
                dots: true,
                children: images.map(function(image) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagesHighlight_StyledImage, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                                src: image.url,
                                alt: image.alt,
                                dateModified: image.dateModified,
                                layout: "fill"
                            }, image.id)
                        })
                    }, image.id);
                })
            })
        })
    });
}
var ImagesHighlight_StyledCarousel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9760e519-0"
})(ImagesHighlight_templateObject());
var ImagesHighlight_StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9760e519-1"
})(ImagesHighlight_templateObject1());
/* harmony default export */ var highlights_ImagesHighlight = (ImagesHighlight);

;// CONCATENATED MODULE: ./components/pageSegments/HighlightsSegment.tsx







function HighlightsSegment(param) {
    var anchorId = param.anchorId, title = param.title, highlights = param.highlights;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        color: "ivory",
        segmentType: "highlights",
        hasSectionTitle: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        align: "left"
                    }),
                    highlights.map(function(highlight, i) {
                        var alignment = i % 2 === 0 ? "row" : "row-reverse";
                        if (highlight.typeHandle === "threeDeeTour") {
                            var ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(highlights_ThreeDeeTourHighlight, {
                                alignment: alignment,
                                eyebrow: highlight.highlightEyebrow,
                                buttonText: highlight.highlightButtonText,
                                title: highlight.highlightTitle,
                                description: highlight.highlightDescription,
                                image: (ref = highlight.highlightPreviewImage) === null || ref === void 0 ? void 0 : ref[0],
                                tourURL: highlight.highlightTourUrl
                            }, highlight.id);
                        }
                        if (highlight.typeHandle === "images") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(highlights_ImagesHighlight, {
                                alignment: alignment,
                                eyebrow: highlight.highlightEyebrow,
                                title: highlight.highlightTitle,
                                description: highlight.highlightDescription,
                                images: highlight.highlightImages
                            }, highlight.id);
                        }
                        return null;
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var pageSegments_HighlightsSegment = (HighlightsSegment);

;// CONCATENATED MODULE: ./components/floorplan/FloorplanTable.tsx
/* eslint-disable jsx-a11y/control-has-associated-label */ 
function FloorplanTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    FloorplanTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FloorplanTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 0;\n  overflow: scroll;\n  margin-right: calc( var( --container-margin-width ) * -1 );\n  padding-right: var( --container-margin-width );\n"
    ]);
    FloorplanTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FloorplanTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border: none;\n  border-collapse: separate;\n  border-spacing: 0;\n  white-space: nowrap;\n  text-align: left;\n\n\n  thead {\n    th {\n      font-weight: bold;\n      padding-bottom: 24px;\n      background: white;\n      &:first-child {\n        position: sticky;\n        left: 0;\n      }\n    }\n  }\n\n  th,\n  td {\n    &:not(:last-child) {\n      padding-right: 24px;\n    }\n  }\n\n  tbody {\n    th,\n    td {\n      border-bottom: 1px solid ",
        ";\n      padding: 14px 0;\n    }\n\n    th {\n      position: sticky;\n      left: 0;\n      background: white;\n      z-index: 1;\n    }\n  }\n"
    ]);
    FloorplanTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var cols = [
    "floor",
    "apartment",
    "numberOfRooms",
    "livingArea",
    "balcony",
    "rent",
    "extraCosts",
    "availability", 
];
function FloorplanTable(param) {
    var rows = param.rows;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOverflow, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: cols.map(function(col) {
                            if (col === "floor") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        defaultMessage: "Floor",
                                        description: "Floorplan/units table header: Floor",
                                        id: "biUozd"
                                    })
                                }, col);
                            }
                            if (col === "apartment") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        defaultMessage: "Apartment",
                                        description: "Floorplan/units table header: Apartment",
                                        id: "E2Ajt6"
                                    })
                                }, col);
                            }
                            if (col === "numberOfRooms") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        defaultMessage: "Number of rooms",
                                        description: "Floorplan/units table header: Number of rooms",
                                        id: "JkP/dR"
                                    })
                                }, col);
                            }
                            if (col === "livingArea") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        defaultMessage: "Living Area",
                                        description: "Floorplan/units table header: Living Area",
                                        id: "t3uTml"
                                    })
                                }, col);
                            }
                            if (col === "balcony") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        defaultMessage: "Balcony",
                                        description: "Floorplan/units table header: Balcony",
                                        id: "D41ybz"
                                    })
                                }, col);
                            }
                            if (col === "rent") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        defaultMessage: "Rent",
                                        description: "Floorplan/units table header: Rent",
                                        id: "+2W/WP"
                                    })
                                }, col);
                            }
                            if (col === "extraCosts") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        defaultMessage: "Extra Costs",
                                        description: "Floorplan/units table header: Extra Costs",
                                        id: "J4JtcB"
                                    })
                                }, col);
                            }
                            if (col === "availability") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        defaultMessage: "Availability",
                                        description: "Floorplan/units table header: Availability",
                                        id: "mJNLNN"
                                    })
                                }, col);
                            }
                            return null;
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: rows.map(function(row) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            children: cols.map(function(col, i) {
                                var value = row[col];
                                if (i === 0) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: value
                                    }, col);
                                }
                                if (col === "availability") {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAvailability, {
                                        $value: value,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailabilityValue, {
                                            value: value
                                        })
                                    }, col);
                                }
                                if (col === "livingArea") {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: value.replace("m2", "m\xb2")
                                    }, col);
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: value
                                }, col);
                            })
                        }, row.id);
                    })
                })
            ]
        })
    });
}
function AvailabilityValue(param) {
    var value = param.value;
    switch(value){
        case "available":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: "Available",
                    id: "CkmV9k",
                    description: "Rental property availability: available"
                })
            });
        case "reserved":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: "Reserved",
                    id: "oCoQLk",
                    description: "Rental property availability: reserved"
                })
            });
        case "occupied":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: "Occupied",
                    id: "zxC1er",
                    description: "Rental property availability: occupied"
                })
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "—"
            });
    }
}
var StyledAvailability = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-11050480-0"
})(FloorplanTable_templateObject(), function(p) {
    switch(p.$value){
        case "available":
            return p.theme.colors.green400;
        case "reserved":
            return p.theme.colors.yellow400;
        case "occupied":
            return p.theme.colors.red400;
        default:
            return "inherit";
    }
});
var StyledOverflow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11050480-1"
})(FloorplanTable_templateObject1());
var StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-11050480-2"
})(FloorplanTable_templateObject2(), function(p) {
    return p.theme.colors.grey200;
});
/* harmony default export */ var floorplan_FloorplanTable = (FloorplanTable);

// EXTERNAL MODULE: ./components/icons/small/index.tsx + 16 modules
var small = __webpack_require__(6154);
;// CONCATENATED MODULE: ./components/floorplan/FloorplanFooter.tsx

function FloorplanFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: var(--grid-gutter);\n\n  > h3 {\n    flex: 1 0 calc(35% - var(--grid-gutter));\n    min-width: 305px;\n  }\n  > div {\n    flex: 1 0 calc(65% - var(--grid-gutter));\n  }\n\n  h4 {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n"
    ]);
    FloorplanFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function FloorplanFooter(param) {
    var sectionTitle = param.sectionTitle, options = param.options;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooter, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: sectionTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: options.map(function(option) {
                    if (option.typeHandle === "list") {
                        var Icon = small[option.listIcon];
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    children: [
                                        Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
                                        option.listTitle
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML: {
                                        __html: option.listContent
                                    }
                                })
                            ]
                        }, option.id);
                    }
                    return null;
                })
            })
        ]
    });
}
var StyledFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c22c88e-0"
})(FloorplanFooter_templateObject());
/* harmony default export */ var floorplan_FloorplanFooter = (FloorplanFooter);

;// CONCATENATED MODULE: ./components/pageSegments/FloorplanSegment.tsx


function FloorplanSegment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: auto;\n  margin-left: calc( var( --container-margin-width ) * -1 );\n  padding-left: var( --container-margin-width );\n  margin-right: calc( var( --container-margin-width ) * -1 );\n  padding-right: var( --container-margin-width );\n  > div {\n    min-width: 100vh;\n  }\n"
    ]);
    FloorplanSegment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










function FloorplanSegment(param) {
    var anchorId = param.anchorId, title = param.title, image = param.image, table = param.table, footer = param.footer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        segmentType: "floorplans",
        color: "realWhite",
        hasSectionTitle: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        align: "left"
                    }),
                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageFrame, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                                src: image.url,
                                alt: image.alt,
                                dateModified: image.dateModified,
                                width: image.width,
                                height: image.height
                            })
                        })
                    }),
                    (table === null || table === void 0 ? void 0 : table.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(floorplan_FloorplanTable, {
                        rows: table
                    }),
                    footer === null || footer === void 0 ? void 0 : footer.map(function(f) {
                        return(// eslint-disable-next-line react/jsx-props-no-spreading
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(floorplan_FloorplanFooter, (0,_object_spread/* default */.Z)({}, f), f.id));
                    })
                ]
            })
        })
    });
}
var StyledImageFrame = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9f04dbb0-0"
})(FloorplanSegment_templateObject());
/* harmony default export */ var pageSegments_FloorplanSegment = (FloorplanSegment);

;// CONCATENATED MODULE: ./components/Map.tsx

function Map_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 12px;\n  aspect-ratio: 650/430;\n  position: relative;\n  border: 1px solid ",
        ";\n  overflow: hidden;\n\n  iframe {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n"
    ]);
    Map_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function Map(param) {
    var location = param.location;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMap, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            title: location.address,
            src: "https://maps.google.com/maps?q=".concat(location.lat, ",").concat(location.lng, "&t=&z=18&ie=UTF8&iwloc=&output=embed")
        })
    });
}
var StyledMap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8968a0d7-0"
})(Map_templateObject(), function(p) {
    return p.theme.colors.grey400;
});
/* harmony default export */ var components_Map = (Map);

;// CONCATENATED MODULE: ./components/DefinitionList.tsx

function DefinitionList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  dd {\n    margin: 0;\n  }\n\n  dt {\n    color: ",
        ";\n  }\n\n  dt:not(:first-child) {\n    margin-top: 18px;\n  }\n"
    ]);
    DefinitionList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function DefinitionList(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
        children: items.map(function(param) {
            var key = param.key, term = param.term, data = param.data;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                        children: term
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                        children: data
                    })
                ]
            }, key);
        })
    });
}
var StyledList = styled_components_browser_esm/* default.dl.withConfig */.ZP.dl.withConfig({
    componentId: "sc-c8e26626-0"
})(DefinitionList_templateObject(), function(p) {
    return p.theme.colors.green400;
});
/* harmony default export */ var components_DefinitionList = (DefinitionList);

// EXTERNAL MODULE: ./components/rentals/Location.tsx + 1 modules
var Location = __webpack_require__(4399);
;// CONCATENATED MODULE: ./components/pageSegments/LocalAreaSegment.tsx

function LocalAreaSegment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: ",
        "px) {\n    flex-direction: row;\n    --gutter: 122px;\n    column-gap: var(--gutter);\n    > div {\n      &:first-child {\n        flex: 1 0 calc(60% - var(--gutter));\n      }\n      &:last-child {\n        flex: 1 0 calc(40% - var(--gutter));\n      }\n    }\n  }\n"
    ]);
    LocalAreaSegment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LocalAreaSegment_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        "px) {\n    margin-right: calc(var(--container-margin-width) * -1);\n  }\n  // margin-left: calc(var(--container-margin-width) * -1);\n"
    ]);
    LocalAreaSegment_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var BREAKPOINT = 900;
function LocalAreaSegment(param) {
    var title = param.title, anchorId = param.anchorId, distances = param.distances, location = param.location, image = param.image, subtitle = param.subtitle, bodyText = param.bodyText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        color: "ivory",
        segmentType: "localArea",
        hasSectionTitle: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        align: "left",
                        title: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Map, {
                                    location: location
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    location && /*#__PURE__*/ (0,jsx_runtime.jsx)(Location/* default */.Z, {
                                        location: location
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            defaultMessage: "Distances",
                                            id: "xHyaHg",
                                            description: "Distances"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DefinitionList, {
                                        items: distances.map(function(param) {
                                            var place = param.place, id = param.id, distance = param.distance;
                                            return {
                                                key: id,
                                                term: place,
                                                data: distance
                                            };
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: subtitle
                                    }),
                                    bodyText && // eslint-disable-next-line react/no-danger
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: (0,strings/* wrapWithPTags */.gu)(bodyText)
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalAreaSegment_StyledImage, {
                                    children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                                        src: image.url,
                                        alt: image.alt,
                                        width: image.width,
                                        height: image.height,
                                        dateModified: image.dateModified
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7efa5f95-0"
})(LocalAreaSegment_templateObject(), BREAKPOINT);
var LocalAreaSegment_StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7efa5f95-1"
})(LocalAreaSegment_templateObject1(), BREAKPOINT);
/* harmony default export */ var pageSegments_LocalAreaSegment = (LocalAreaSegment);

;// CONCATENATED MODULE: ./components/pageSegments/ColumnSegment.tsx

function ColumnSegment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: var(--grid-gutter);\n  > div {\n    flex: 1 0 calc(50% - var(--grid-gutter));\n  }\n\n  a {\n    color: ",
        ";\n  }\n"
    ]);
    ColumnSegment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function ColumnsSegment(param) {
    var anchorId = param.anchorId, title = param.title, columns = param.columns;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        color: "green100",
        segmentType: "contact",
        hasSectionTitle: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                $top: 12,
                $bottom: 12,
                $between: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                        title: title,
                        align: "left"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledColumns, {
                        children: columns === null || columns === void 0 ? void 0 : columns.map(function(param) {
                            var id = param.id, columnHeading = param.columnHeading, columnContent = param.columnContent;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: columnHeading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML: {
                                            __html: columnContent
                                        }
                                    })
                                ]
                            }, id);
                        })
                    })
                ]
            })
        })
    });
}
var StyledColumns = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aeb09415-0"
})(ColumnSegment_templateObject(), function(p) {
    return p.theme.colors.green700;
});
/* harmony default export */ var ColumnSegment = (ColumnsSegment);

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.mjs + 37 modules
var react_dialog_dist = __webpack_require__(1549);
;// CONCATENATED MODULE: ./components/YoutubeModal.tsx

function YoutubeModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  inset: 0;\n  z-index: 99;\n  background-color: rgba(6, 38, 45, 0.8);\n"
    ]);
    YoutubeModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function YoutubeModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 100;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90vw;\n  max-width: 900px;\n  max-height: 90vh;\n  overflow: auto;\n  padding: 25px;\n  color: ",
        ";\n\n  h4 {\n    margin: 1rem 0 0;\n  }\n\n  p {\n    margin: 1rem 0 0;\n  }\n\n  a {\n    color: inherit;\n  }\n\n"
    ]);
    YoutubeModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function YoutubeModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  aspect-ratio: 16 / 9;\n  width: 100%;\n  background: #000;\n"
    ]);
    YoutubeModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function YoutubeModal(param) {
    var videoUrl = param.videoUrl, id = param.id, content = param.content, children = param.children;
    var router = (0,next_router.useRouter)();
    var hash = router.asPath.split("#")[1] || "";
    var basePath = router.asPath.split("#")[0];
    var handleClick = function(e) {
        e.preventDefault();
        router.replace("".concat(basePath, "#").concat(id));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dialog_dist/* Root */.fC, {
        open: hash === id,
        onOpenChange: function(open) {
            if (!open) {
                router.replace(basePath, basePath, {
                    scroll: false
                });
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist/* Trigger */.xz, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "#".concat(id),
                    onClick: handleClick,
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dialog_dist/* Portal */.h_, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist/* Overlay */.aV, {
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist/* Content */.VY, {
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoFrame, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VideoEmbed, {
                                        url: videoUrl,
                                        autoplay: true
                                    })
                                }),
                                content
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c103c6-0"
})(YoutubeModal_templateObject());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c103c6-1"
})(YoutubeModal_templateObject1(), function(p) {
    return p.theme.colors.white;
});
var VideoFrame = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c103c6-2"
})(YoutubeModal_templateObject2());
/* harmony default export */ var components_YoutubeModal = (YoutubeModal);

;// CONCATENATED MODULE: ./components/pageSegments/VideoGroupSegment.tsx

function VideoGroupSegment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 2rem;\n\n  header {\n    display: flex;\n    flex-wrap: wrap;\n    margin-left: -1.2rem;\n\n    > div {\n      box-sizing: border-box;\n      padding-left: 1.2rem;\n      width: 100%;\n      @media ( min-width: 900px ) {\n        width: 50%;\n      }\n    }\n  }\n\n  p {\n    display: block;\n    max-width: 30rem;\n    margin-bottom: 4rem;\n  }\n"
    ]);
    VideoGroupSegment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoGroupSegment_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -1.2rem;\n  margin-top: -2rem;\n\n  > div {\n   box-sizing: border-box;\n   padding-left: 1.2rem;\n   padding-top: 2rem;\n   width: 100%;\n   @media ( min-width: 900px ) {\n      width: 50%;\n    }\n  }\n\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n\n  h4 {\n    font-size: ",
        ";\n  }\n"
    ]);
    VideoGroupSegment_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VideoGroupSegment_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        "%;\n  position: relative;\n  overflow: hidden;\n  img {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    transform: translateY(-50%);\n  }\n\n  svg {\n    position: absolute;\n    inset: 0;\n    margin: auto;\n  }\n"
    ]);
    VideoGroupSegment_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







function VideoGroupSegment(param) {
    var anchorId = param.anchorId, title = param.title, subtitle = param.subtitle, videos = param.videos, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
        anchorId: anchorId,
        segmentType: "processSteps",
        hasSectionTitle: title || subtitle,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoGroup, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: title
                                })
                            }),
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: subtitle
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoGrid, {
                        children: videos.map(function(video) {
                            var id = getYoutubeId(video.videoUrl);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_YoutubeModal, {
                                    id: "watch-".concat((0,strings/* slugify */.lV)(video.videoTitle)),
                                    videoUrl: video.videoUrl,
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: video.videoTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: video.videoDescription
                                                }
                                            })
                                        ]
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoThumbnail, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://img.youtube.com/vi/".concat(id, "/maxresdefault.jpg"),
                                                    alt: video.videoTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    width: "35",
                                                    height: "41",
                                                    viewBox: "0 0 35 41",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M35 20.5161L0.499998 40.4347L0.5 0.597527L35 20.5161Z",
                                                        fill: "#009877"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            children: video.videoTitle
                                        })
                                    ]
                                })
                            }, video.id);
                        })
                    })
                ]
            })
        })
    });
}
var VideoGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b87e7109-0"
})(VideoGroupSegment_templateObject());
var VideoGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b87e7109-1"
})(VideoGroupSegment_templateObject1(), function(p) {
    return p.theme.typo.sizes.normal;
});
var VideoThumbnail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b87e7109-2"
})(VideoGroupSegment_templateObject2(), 9 / 16 * 100 - 1);
/* harmony default export */ var pageSegments_VideoGroupSegment = (VideoGroupSegment);

;// CONCATENATED MODULE: ./components/pageSegments/PageSegments.tsx

function PageSegments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: 900px) {\n    ",
        " + ",
        " {\n      padding-top: calc(6 * var(--stack-basis));\n    }\n\n    ",
        " + ",
        " {\n      padding-top: calc(12 * var(--stack-basis));\n      margin-top: calc(-12 * var(--stack-basis));\n    }\n\n    ",
        " {\n      padding-top: calc(6 * var(--stack-basis));\n    }\n  }\n\n  /**\n  If there's a document page style header, collapse the top margin of the first page segment\n  */\n  .bx-page-document-header + & > {\n    .bx-page-segment:first-child > div > ",
        " > ",
        ",\n    .bx-page-segment:first-child > div > section > ",
        " > ",
        " {\n      padding-top: 0;\n    }\n  }\n\n  /**\n  if two adjecent page segments have the same BG color, collapse padding\n  with exceptions for specific page segment types:\n  - cards\n  - infoPoints\n  - largePostcards\n  - packageCards\n  - testimonials\n  */\n  .bx-background--color_transparent:not(.bx-page-segment-cards):not(\n      .bx-page-segment-largePostcards\n    ):not(.bx-page-segment-infoPoints):not(.bx-page-segment-testimonials)\n    + .bx-background--color_transparent,\n  .bx-background--color_ivory:not(.bx-page-segment-cards):not(\n      .bx-page-segment-largePostcards\n    ):not(.bx-page-segment-infoPoints):not(.bx-page-segment-testimonials):not(.bx-page-segment-highlights)\n    + .bx-background--color_ivory {\n    > div > ",
        " > ",
        ",\n    > div > section > ",
        " > ",
        " {\n      padding-top: 0;\n    }\n  }\n\n  /**\n  Line border for specific page segment types:\n  - cards\n  - infoPoints\n  - testimonials\n  */\n  .bx-background--color_transparent.bx-page-segment-cards\n    + .bx-background--color_transparent,\n  .bx-background--color_transparent.bx-page-segment-infoPoints\n    + .bx-background--color_transparent,\n  .bx-background--color_transparent.bx-page-segment-testimonials\n    + .bx-background--color_transparent,\n  .bx-background--color_ivory.bx-page-segment-cards\n    + .bx-background--color_ivory,\n  .bx-background--color_ivory.bx-page-segment-infoPoints\n    + .bx-background--color_ivory,\n  .bx-background--color_ivory.bx-page-segment-testimonials\n    + .bx-background--color_ivory,\n  .bx-background--color_ivory.bx-page-segment-highlights\n    + .bx-background--color_ivory,\n  .bx-background--color_realWhite.bx-page-segment-intro\n    + .bx-background--color_realWhite {\n    border-top: 1px solid ",
        ";\n  }\n\n  .bx-background--color_green200.bx-page-segment-documents:last-child {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  /* .bx-background--color_transparent:not( .bx-page-segment-packageCards ) \n  + .bx-background--color_transparent.bx-page-segment-with-title,\n  .bx-background--color_ivory + .bx-background--color_ivory {\n    border-top: 1px solid ",
        ";\n  } */\n"
    ]);
    PageSegments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






























function PageSegments(param) {
    var pageSegments = param.pageSegments, _before = param.before, before = _before === void 0 ? null : _before, _after = param.after, after = _after === void 0 ? null : _after;
    if (!pageSegments) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageSegments, {
        children: [
            before,
            pageSegments.map(function(pageSegment, i) {
                var ref;
                var additionalBottomPadding = ((ref = pageSegments[i + 1]) === null || ref === void 0 ? void 0 : ref.typeHandle) === "videoCta" ? 6 : 0;
                var anchorId = pageSegment.anchorId || pageSegment.id;
                if (pageSegment.typeHandle === "accordion") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_AccordionSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        image: pageSegment.mainImage[0],
                        buttonLabel: pageSegment.buttonLabel,
                        buttonLink: pageSegment.buttonLink,
                        buttonIcon: pageSegment.buttonIcon,
                        accordionStyle: pageSegment.accordionStyle,
                        accordionLayout: pageSegment.accordionLayout,
                        accordion: pageSegment.accordion,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "cards") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_CardsSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        alignment: pageSegment.alignment ? "center" : "left",
                        mainImage: pageSegment.mainImage,
                        cards: pageSegment.cards,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "contact") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_ContactSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        contactCards: pageSegment.contactCards,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "experts") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_ExpertsSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        experts: pageSegment.experts,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "footer") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyFooter, {
                        anchorId: anchorId,
                        bodyText: pageSegment.bodyText,
                        showLanguageSwitcher: !pageSegment.hideLanguagePicker
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "infoPoints") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_InfoPointsSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        alignment: pageSegment.infoPointsAlignment ? "center" : "left",
                        infoPoints: pageSegment.infoPoints,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "largePostcards") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LargePostcardsSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        postcards: pageSegment.largePostcards,
                        additionalBottomPadding: additionalBottomPadding,
                        headingBackgroundColor: pageSegment.largeCardsSectionBGColor
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "logoGrid") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_LogoGridSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        linkedLogos: pageSegment.linkedLogos,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "partnerLogos") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_LogosSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        logos: pageSegment.partnerLogos,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "packages") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_PackagesSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        bodyText: pageSegment.bodyText,
                        packages: pageSegment.packageEntries,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "postcards") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostcardsSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        postcards: pageSegment.postcards,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "processSteps") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_ProcessStepsSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        processSteps: pageSegment.processSteps,
                        bodyText: pageSegment.bodyText,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "processStepsSimple") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcessStepsSimpleSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        processStepsSimple: pageSegment.processStepsSimple,
                        bodyText: pageSegment.bodyText,
                        button: pageSegment.button,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "propertyListings") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_PropertyListingsSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        additionalBottomPadding: additionalBottomPadding,
                        buttonLabel: pageSegment.buttonLabel,
                        buttonLink: pageSegment.buttonLink,
                        company: pageSegment.company,
                        related: pageSegment.related,
                        numberOfProperties: pageSegment.numberOfProperties,
                        showCountdown: pageSegment.showCountdown,
                        propertyCardStyle: pageSegment.propertyCardStyle,
                        carouselForSmallScreens: pageSegment.carouselForSmallScreens,
                        showLoadMoreButton: pageSegment.showLoadMoreButton,
                        showFilterControls: pageSegment.showFilterControls
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "properties") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyListingsLargeSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "story") {
                    var ref1, ref2, ref3;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StorySegment/* default */.Z, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        additionalBottomPadding: additionalBottomPadding,
                        label: pageSegment.label,
                        buttonLabel: (ref1 = pageSegment.button) === null || ref1 === void 0 ? void 0 : ref1.text,
                        buttonLink: (ref2 = pageSegment.button) === null || ref2 === void 0 ? void 0 : ref2.url,
                        buttonTarget: (ref3 = pageSegment.button) === null || ref3 === void 0 ? void 0 : ref3.target,
                        image: pageSegment.mainImage[0]
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "testimonials") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_TestimonialsSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        testimonials: pageSegment.testimonials,
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "textCta") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_TextCtaSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        theme: pageSegment.ctaTheme,
                        icon: pageSegment.ctaIcon,
                        buttons: pageSegment.buttonGroup.map(function(b) {
                            return {
                                id: b.id,
                                href: b.buttonLink,
                                label: b.buttonLabel,
                                primary: b.primary,
                                openInNewTab: b.openInNewTab
                            };
                        }),
                        additionalBottomPadding: additionalBottomPadding
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "videoCta") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_VideoCtaSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        description: pageSegment.description,
                        coverImage: pageSegment.mainImage[0],
                        buttonLabel: pageSegment.buttonLabel,
                        videoUrl: pageSegment.videoUrl
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "highlights") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_HighlightsSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        highlights: pageSegment.highlights
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "floorplan") {
                    var ref4;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_FloorplanSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        image: (ref4 = pageSegment.mainImage) === null || ref4 === void 0 ? void 0 : ref4[0],
                        table: pageSegment.floorplanTable,
                        footer: pageSegment.floorplanFooter
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "localArea") {
                    var ref5;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_LocalAreaSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        distances: pageSegment.distances,
                        location: pageSegment.location,
                        subtitle: pageSegment.subtitle,
                        bodyText: pageSegment.bodyText,
                        image: (ref5 = pageSegment.mainImage) === null || ref5 === void 0 ? void 0 : ref5[0]
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "columns") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColumnSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        columns: pageSegment.textColumns
                    }, pageSegment.id);
                }
                if (pageSegment.typeHandle === "videoGroup") {
                    var isLast = pageSegments.length === i + 1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSegments_VideoGroupSegment, {
                        anchorId: anchorId,
                        title: pageSegment.mainTitle,
                        subtitle: pageSegment.subtitle,
                        videos: pageSegment.videos,
                        additionalBottomPadding: isLast ? 6 : 0
                    }, pageSegment.id);
                }
                return null;
            }),
            after
        ]
    });
}
var StyledPageSegments = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64c20b65-0"
})(PageSegments_templateObject(), StyledVideoCta, Background/* default */.Z, Background/* default */.Z, StyledVideoCta, StyledVideoCta, Container/* default */.Z, Stack/* default */.ZP, Container/* default */.Z, Stack/* default */.ZP, Container/* default */.Z, Stack/* default */.ZP, Container/* default */.Z, Stack/* default */.ZP, function(p) {
    return p.theme.colors.grey300;
}, function(p) {
    return p.theme.colors.green400;
}, function(p) {
    return p.theme.colors.grey300;
});
/* harmony default export */ var pageSegments_PageSegments = (PageSegments);


/***/ }),

/***/ 2419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StorySegment; },
/* harmony export */   "s": function() { return /* binding */ StyledStoryContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2125);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(570);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7753);
/* harmony import */ var _layout_Stack__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4970);
/* harmony import */ var _PageSegmentBackground__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2475);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  flex: 0 0 max( 42%, calc( 50% - ( 10 * var( --stack-basis ) ) ) );\n  min-height: 200px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: min( 8%, calc( 10 * var( --stack-basis ) ) );\n  margin-right: var( --container-margin-width );\n  max-width: 31rem;\n\n  h2 {\n    ",
        ";\n    font-size: ",
        ";\n    font-weight: 400;\n  }\n\n  h3 {\n    font-size: ",
        ";\n    line-height: 1.1;\n    font-weight: 600;\n  }\n\n  p {\n    font-size: ",
        ";\n    line-height: 1.2;\n  }\n\n  @media ( max-width: 500px ) {\n    h3 {\n      font-size: ",
        ";\n      /* line-height: 1.2; */\n    }\n\n    p {\n      font-size: ",
        ";\n      line-height: 1.35;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n\n  @media ( max-width: 750px ) {\n    flex-wrap: wrap;\n\n    ",
        " {\n      flex-basis: 100vw;\n    }\n\n    ",
        " {\n      margin-left: var( --container-margin-width );\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function StorySegment(param) {
    var anchorId = param.anchorId, label = param.label, title = param.title, subtitle = param.subtitle, buttonLabel = param.buttonLabel, buttonLink = param.buttonLink, buttonTarget = param.buttonTarget, image = param.image, additionalBottomPadding = param.additionalBottomPadding;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PageSegmentBackground__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        anchorId: anchorId,
        segmentType: "story",
        color: "#f0f0f0",
        hasSectionTitle: false,
        additionalBottomPadding: additionalBottomPadding,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledStory, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledStoryImage, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        alt: image.alt,
                        src: image.url,
                        layout: "fill",
                        objectFit: "cover",
                        dateModified: image.dateModified
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledStoryContent, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_layout_Stack__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        $top: 10,
                        $bottom: 10,
                        $between: 3,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                children: label
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: subtitle
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                href: buttonLink,
                                target: buttonTarget,
                                children: buttonLabel
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var StyledStoryImage = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6f4447b5-0"
})(_templateObject());
var StyledStoryContent = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6f4447b5-1"
})(_templateObject1(), function(p) {
    return p.theme.typo.mono;
}, function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.theme.typo.sizes.smallHero;
}, function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return p.theme.typo.sizes.veryLarge;
}, function(p) {
    return p.theme.typo.sizes.medium;
});
var StyledStory = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6f4447b5-2"
})(_templateObject2(), StyledStoryImage, StyledStoryContent);


/***/ }),

/***/ 9895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ StyledPostcard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _styles_links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2676);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7753);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 32px;\n  padding: 0 1.5rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: calc( 4 * var( --stack-basis ) );\n  border-radius: 100rem;\n  border: 1px solid;\n  color: ",
        ";\n  border-color: --currentColor;\n  ",
        "\n  font-size: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 32px;\n  padding: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    > div {\n      &:first-child {\n        background-color: ",
        ";\n      }\n      \n      &:last-child {\n        background-color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    > div {\n      &:first-child {\n        background-color: ",
        ";\n      }\n      \n      &:last-child {\n        background-color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    > div {\n      &:first-child {\n        background-color: ",
        ";\n      }\n      \n      &:last-child {\n        background-color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    > div {\n      &:first-child {\n        background-color: ",
        ";\n      }\n      \n      &:last-child {\n        background-color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  min-height: 423px;\n\n  flex-direction: ",
        ";\n\n  > div {\n    position: relative;\n    box-sizing: border-box;\n    flex: 1 0 50%;\n    min-width: min( 250px, 100% );\n    word-wrap: break-word;\n    word-break: break-all;\n    word-break: break-word;\n    hyphens: auto;\n\n    &:first-child {\n      padding: calc( 8 * var( --stack-basis ) ) calc( 3 * var( --grid-gutter ) );\n\n      @media ( max-width: 900px ) {\n        padding: calc( 6 * var( --stack-basis ) ) calc( 2 * var( --grid-gutter ) );\n      }\n      \n      @media ( max-width: 600px ) {\n        padding-left: calc( 1 * var( --grid-gutter ) );\n        padding-right: calc( 1 * var( --grid-gutter ) );\n      }\n\n      h3 {\n        ",
        "\n        font-size: ",
        ";\n        line-height: 1.2;\n        margin: 0 0 calc( 2 * var( --stack-basis ) ) 0;\n        ",
        "\n      }\n\n      h4 {\n        margin: calc( 3 * var( --stack-basis ) ) 0 var( --stack-basis );\n        font-size: ",
        ";\n      }\n\n      p {\n        margin: 0 0 calc( 3 * var( --stack-basis ) ) 0;\n        font-size: ",
        ";\n\n        &:first-child {\n          margin-top: 0;\n        }\n        \n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n\n      a {\n        ",
        "\n      }\n    }\n\n    &:last-child {\n      min-height: 250px\n    }\n  }\n\n  ",
        "\n  \n  ",
        "\n  \n  ",
        "\n  \n  ",
        "\n\n  ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




function Postcard(param) {
    var _number = param.number, number = _number === void 0 ? null : _number, _tag = param.tag, tag = _tag === void 0 ? null : _tag, heading = param.heading, bodyText = param.bodyText, image = param.image, cardColor = param.cardColor, layout = param.layout;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPostcard, {
        $layout: layout,
        $color: cardColor,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    number && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledNumber, {
                        $color: cardColor,
                        children: number
                    }),
                    tag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTag, {
                        $color: cardColor,
                        children: tag
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                        children: heading
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: bodyText
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    src: image.url,
                    alt: image.alt,
                    dateModified: image.dateModified,
                    layout: "fill",
                    objectFit: "contain"
                })
            })
        ]
    });
}
var colorMap = {
    blue: "blue400",
    grey: "grey700",
    green: "green400",
    red: "red400"
};
var coloredTextLink = function(theme, cardColor) {
    return (0,_styles_links__WEBPACK_IMPORTED_MODULE_3__/* .textLink */ .k)(theme, colorMap[cardColor]);
};
var headingColorMap = {
    blue: "blue700",
    grey: "grey700",
    green: "green700",
    red: "red700"
};
var coloredHeading = function(theme, color) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), theme.getColor(headingColorMap[color]));
};
var StyledTag = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4a8ee33-0"
})(_templateObject1(), function(p) {
    return p.theme.getColor(colorMap[p.$color]);
}, function(p) {
    return p.theme.typo.mono;
}, function(p) {
    return p.theme.typo.sizes.small;
});
var StyledNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(StyledTag).withConfig({
    componentId: "sc-f4a8ee33-1"
})(_templateObject2());
var StyledPostcard = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.attrs */ .ZP.div.attrs(function(p) {
    return {
        className: "bx-c-postcard--".concat(p.$color)
    };
}).withConfig({
    componentId: "sc-f4a8ee33-2"
})(_templateObject7(), function(p) {
    return p.$layout === "image-right" ? "row" : "row-reverse";
}, function(p) {
    return p.theme.typo.semiBold;
}, function(p) {
    return p.theme.typo.sizes.veryLarge;
}, function(p) {
    return coloredHeading(p.theme, p.$color);
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return coloredTextLink(p.theme, p.$color);
}, function(p) {
    return p.$color === "blue" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject3(), p.theme.colors.blue100, p.theme.colors.blue200);
}, function(p) {
    return p.$color === "red" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4(), p.theme.colors.red100, p.theme.colors.red200);
}, function(p) {
    return p.$color === "green" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject5(), p.theme.colors.green100, p.theme.colors.green200);
}, function(p) {
    return p.$color === "grey" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject6(), p.theme.colors.grey100, p.theme.colors.grey200);
}, StyledNumber, function(p) {
    return p.theme.getColor(colorMap[p.$color]);
});
/* harmony default export */ __webpack_exports__["Z"] = (Postcard);


/***/ }),

/***/ 4399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ rentals_Location; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./components/icons/PinIcon.tsx

function PinIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "23",
        viewBox: "0 0 16 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.5 8C4.5 8.92826 4.86875 9.8185 5.52513 10.4749C6.1815 11.1313 7.07174 11.5 8 11.5C8.92826 11.5 9.8185 11.1313 10.4749 10.4749C11.1313 9.8185 11.5 8.92826 11.5 8C11.5 7.07174 11.1313 6.1815 10.4749 5.52513C9.8185 4.86875 8.92826 4.5 8 4.5C7.07174 4.5 6.1815 4.86875 5.52513 5.52513C4.86875 6.1815 4.5 7.07174 4.5 8Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 11.1799 10.2643 19.1533 8.58333 21.6873C8.51948 21.7836 8.4328 21.8626 8.33102 21.9172C8.22923 21.9718 8.11551 22.0004 8 22.0004C7.88449 22.0004 7.77077 21.9718 7.66898 21.9172C7.5672 21.8626 7.48052 21.7836 7.41667 21.6873C5.73573 19.1533 1 11.1799 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1V1Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/rentals/Location.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  svg {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function Location(param) {
    var location = param.location;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLocation, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PinIcon, {}),
            location.address
        ]
    });
}
var StyledLocation = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4cfebf7e-0"
})(_templateObject(), function(p) {
    return p.theme.colors.green400;
});
/* harmony default export */ var rentals_Location = (Location);


/***/ }),

/***/ 5330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ Select; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs + 4 modules
var floating_ui_react_dom = __webpack_require__(294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 30 modules
var listbox = __webpack_require__(9468);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/icons/ChevronIcon.tsx
var ChevronIcon = __webpack_require__(7011);
// EXTERNAL MODULE: ./components/icons/TickIcon.tsx
var TickIcon = __webpack_require__(3525);
// EXTERNAL MODULE: ./hooks/usePreventBodyScroll.tsx
var usePreventBodyScroll = __webpack_require__(7325);
;// CONCATENATED MODULE: ./components/ui/Select/displayValueUtils.ts
function defaultSingleSelectDisplayValue(selected, options, placeholder) {
    var ref;
    return ((ref = options.find(function(option) {
        return option.value === selected;
    })) === null || ref === void 0 ? void 0 : ref.label) || placeholder || "";
}
function defaultMultipleSelectDisplayValue(selected, options, placeholder) {
    return selected.map(function(selectedValue) {
        var ref;
        return (ref = options.find(function(option) {
            return option.value === selectedValue;
        })) === null || ref === void 0 ? void 0 : ref.label;
    }).filter(Boolean).join(", ") || placeholder || "";
}
function getDisplayValue(selected, options, placeholder, displayValue) {
    if (displayValue) {
        return displayValue;
    }
    if (Array.isArray(selected)) {
        return defaultMultipleSelectDisplayValue(selected, options, placeholder);
    }
    return defaultSingleSelectDisplayValue(selected, options, placeholder);
}

;// CONCATENATED MODULE: ./components/ui/Select/Select.tsx
"use client";

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding-bottom: 8px;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-weight: 500;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  inset: 0;\n  z-index: 10;\n  overflow: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  z-index: 10;\n  margin-top: 8px;\n  width: max-content;\n  overflow: hidden;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 4px 11px rgba(0, 0, 0, 0.1);\n\n  &:focus {\n    outline: none;\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 4px 11px rgba(0, 0, 0, 0.1), 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 8px 12px;\n  cursor: pointer;\n  background: white;\n\n  &[data-headlessui-state="active"] {\n    background: ',
        ";\n  }\n\n  > span {\n    width: max-content;\n  }\n\n  > div {\n    width: 16px;\n    height: 16px;\n\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









function Select(param) {
    var _label = param.label, label = _label === void 0 ? undefined : _label, _displayValue = param.displayValue, displayValue = _displayValue === void 0 ? undefined : _displayValue, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? undefined : _placeholder, options = param.options, selected = param.selected, onChange = param.onChange;
    var refs = (0,floating_ui_react_dom/* useFloating */.YF)({
        placement: "bottom-end",
        middleware: [
            floatingUISelectPositionMiddleware
        ]
    }).refs;
    var computedDisplayValue = getDisplayValue(selected, options, placeholder, displayValue);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
        value: selected,
        onChange: onChange,
        multiple: Array.isArray(selected),
        children: function(param) {
            var open = param.open;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelectWrapper, {
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelectLabel, {
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
                        ref: refs.setReference,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: computedDisplayValue
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronIcon/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal, {
                        open: open,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOptionsWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOptionsList, {
                                ref: refs.setFloating,
                                children: options.map(function(option) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectionOption, {
                                        label: option.label,
                                        value: option.value,
                                        isSelected: selected.includes(option.value)
                                    }, option.value);
                                })
                            })
                        })
                    })
                ]
            });
        }
    });
}
function SelectionOption(param) {
    var label = param.label, value = param.value, isSelected = param.isSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOption, {
        value: value,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(TickIcon/* default */.Z, {})
            })
        ]
    });
}
function Portal(param) {
    var open = param.open, children = param.children;
    (0,usePreventBodyScroll/* default */.Z)(open, "floating-ui-select");
    if (!open) {
        return null;
    }
    return /*#__PURE__*/ (0,react_dom.createPortal)(children, document.body);
}
var floatingUISelectPositionMiddleware = {
    name: "floatingUISelectPositionMiddleware",
    fn: function fn(state) {
        var refEl = state.elements.reference;
        var floatingEl = state.elements.floating;
        var refBoundingRect = refEl.getBoundingClientRect();
        var floatingBoundingRect = floatingEl.getBoundingClientRect();
        var width = Math.max(refBoundingRect.width, floatingBoundingRect.width);
        Object.assign(floatingEl.style, {
            width: "".concat(width, "px"),
            transform: "translate(".concat(refBoundingRect.right - width, "px, ").concat(refBoundingRect.bottom, "px)")
        });
        return {};
    }
};
var StyledSelectWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf944c66-0"
})(_templateObject());
var StyledSelectLabel = (0,styled_components_browser_esm/* default */.ZP)(listbox/* Listbox.Label */.R.Label).withConfig({
    componentId: "sc-cf944c66-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.black;
});
var StyledOptionsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf944c66-2"
})(_templateObject2());
var StyledOptionsList = (0,styled_components_browser_esm/* default */.ZP)(listbox/* Listbox.Options */.R.Options).withConfig({
    componentId: "sc-cf944c66-3"
})(_templateObject3());
var StyledOption = (0,styled_components_browser_esm/* default */.ZP)(listbox/* Listbox.Option */.R.Option).withConfig({
    componentId: "sc-cf944c66-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.green100;
});


/***/ }),

/***/ 8744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gu": function() { return /* binding */ wrapWithPTags; },
/* harmony export */   "lV": function() { return /* binding */ slugify; }
/* harmony export */ });
/* unused harmony exports nl2p, nl2pIfNotRedactored, nl2br, humanList */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_dom_server__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7762);



var slugify = function(str) {
    var result = str;
    result = result.replace(/^\s+|\s+$/g, "") // trim leading/trailing white space
    ;
    result = result.toLowerCase() // convert string to lowercase
    ;
    result = result.replace(/[^a-z0-9 -]/g, "") // remove any non-alphanumeric characters
    .replace(/\s+/g, "-") // replace spaces with hyphens
    .replace(/-+/g, "-") // remove consecutive hyphens
    ;
    return result;
};
var nl2p = function(str) {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: str.split(/(?:\r\n\r\n|\r\r|\n\n)/g).map(function(line, i) {
            return(// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ _jsx(Fragment, {
                children: /*#__PURE__*/ _jsx("p", {
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: line
                    }
                }, i)
            }, i));
        })
    });
};
/**
 * Note: whereas nl2p returns a JSX object, nl2pIfNotRedactored returns markup as 
 * a string because it’s intended for use with dangerouslySetInnerHTML
 */ var nl2pIfNotRedactored = function(str) {
    if (str.startsWith("<p>")) {
        return str;
    }
    return renderToStaticMarkup(nl2p(str));
};
var nl2br = function(str) {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: str.split(/(?:\r\n|\r|\n)/g).map(function(line, i) {
            return(// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    line,
                    /*#__PURE__*/ _jsx("br", {})
                ]
            }, i));
        })
    });
};
var humanList = function(jsxEls) {
    if (jsxEls.length < 2) {
        return jsxEls;
    }
    var separated = jsxEls.reduce(function(r, a, i) {
        if (i === jsxEls.length - 1) {
            return r.concat(a);
        }
        if (i === jsxEls.length - 2) {
            return r.concat(a, " and ");
        }
        return r.concat(a, ", ");
    }, []);
    return separated;
};
function wrapWithPTags(str) {
    return "\n    ".concat(!str.startsWith("<p") ? "<p>" : "", "\n    ").concat(str, "\n    ").concat(!str.endsWith("</p>") ? "</p>" : "", "\n  ");
}


/***/ })

}]);